/* eslint-disable no-case-declarations */
/* global jQuery, $, PDFLib, fontkit, dat */

/*                                                                                                

          _____                    _____                    _____                    _____                    _____                   _______         
         /\    \                  /\    \                  /\    \                  /\    \                  /\    \                 /::\    \        
        /::\____\                /::\    \                /::\    \                /::\    \                /::\____\               /::::\    \       
       /::::|   |               /::::\    \              /::::\    \              /::::\    \              /:::/    /              /::::::\    \      
      /:::::|   |              /::::::\    \            /::::::\    \            /::::::\    \            /:::/    /              /::::::::\    \     
     /::::::|   |             /:::/\:::\    \          /:::/\:::\    \          /:::/\:::\    \          /:::/    /              /:::/~~\:::\    \    
    /:::/|::|   |            /:::/__\:::\    \        /:::/__\:::\    \        /:::/__\:::\    \        /:::/____/              /:::/    \:::\    \   
   /:::/ |::|   |           /::::\   \:::\    \      /::::\   \:::\    \      /::::\   \:::\    \       |::|    |              /:::/    / \:::\    \  
  /:::/  |::|___|______    /::::::\   \:::\    \    /::::::\   \:::\    \    /::::::\   \:::\    \      |::|    |     _____   /:::/____/   \:::\____\ 
 /:::/   |::::::::\    \  /:::/\:::\   \:::\    \  /:::/\:::\   \:::\____\  /:::/\:::\   \:::\    \     |::|    |    /\    \ |:::|    |     |:::|    |
/:::/    |:::::::::\____\/:::/  \:::\   \:::\____\/:::/  \:::\   \:::|    |/:::/__\:::\   \:::\____\    |::|    |   /::\____\|:::|____|     |:::|    |
\::/    / ~~~~~/:::/    /\::/    \:::\  /:::/    /\::/   |::::\  /:::|____|\:::\   \:::\   \::/    /    |::|    |  /:::/    / \:::\    \   /:::/    / 
 \/____/      /:::/    /  \/____/ \:::\/:::/    /  \/____|:::::\/:::/    /  \:::\   \:::\   \/____/     |::|    | /:::/    /   \:::\    \ /:::/    /  
             /:::/    /            \::::::/    /         |:::::::::/    /    \:::\   \:::\    \         |::|____|/:::/    /     \:::\    /:::/    /   
            /:::/    /              \::::/    /          |::|\::::/    /      \:::\   \:::\____\        |:::::::::::/    /       \:::\__/:::/    /    
           /:::/    /               /:::/    /           |::| \::/____/        \:::\   \::/    /        \::::::::::/____/         \::::::::/    /     
          /:::/    /               /:::/    /            |::|  ~|               \:::\   \/____/          ~~~~~~~~~~                \::::::/    /      
         /:::/    /               /:::/    /             |::|   |                \:::\    \                                         \::::/    /       
        /:::/    /               /:::/    /              \::|   |                 \:::\____\                                         \::/____/        
        \::/    /                \::/    /                \:|   |                  \::/    /                                          ~~              
         \/____/                  \/____/                  \|___|                   \/____/                                                           
                                                                                                                                                      


   ____  _      _                        _        _______         __                      _           _    
  / __ \| |    | |                      | |      |__   __|       / _|                    | |         | |   
 | |  | | | ___| | _____  __ _ _ __   __| |_ __     | |_ __ ___ | |_ _   _ _ __ ___   ___| |__  _   _| | __
 | |  | | |/ _ \ |/ / __|/ _` | '_ \ / _` | '__|    | | '__/ _ \|  _| | | | '_ ` _ \ / __| '_ \| | | | |/ /
 | |__| | |  __/   <\__ \ (_| | | | | (_| | |       | | | | (_) | | | |_| | | | | | | (__| | | | |_| |   < 
  \____/|_|\___|_|\_\___/\__,_|_| |_|\__,_|_|       |_|_|  \___/|_|  \__, |_| |_| |_|\___|_| |_|\__,_|_|\_\
  _____            _        __      __                   _            __/ |                                
 |  __ \          | |       \ \    / /                  (_)          |___/                                 
 | |__) |_ ___   _| | ___    \ \  / /__  _ __ ___  _ __  _ _ __                                            
 |  ___/ _` \ \ / / |/ _ \    \ \/ / _ \| '__/ _ \| '_ \| | '_ \                                           
 | |  | (_| |\ V /| | (_) |    \  / (_) | | | (_) | | | | | | | |                                          
 |_|   \__,_| \_/ |_|\___/      \/ \___/|_|  \___/|_| |_|_|_| |_|                                          
 
*/

// Created by Marevo (Pavlo Voronin based on Oleksandr Trofymchuk's configurator)
// Welcome to our custom script!

// REMEMBER:
// Theft is wrong not because some ancient text says, 'Thou shalt not steal.'
// It's always bad, robber :)

"use strict";
import $ from "jquery";
import * as THREE from "three";
import "../core/model-viewer.marevo";
import { getPostMeshName, getLouverMeshNames, getPostMorphSet } from "./Meshconfig";

// import * as GeometryUtils from 'three/addons/utils/GeometryUtils.js';
import { TextGeometry } from "three/addons/geometries/TextGeometry.js";
import { FontLoader } from "three/addons/loaders/FontLoader.js";
import { computeMorphedAttributes } from "three/addons/utils/BufferGeometryUtils.js";

// const { PDFDocument, StandardFonts, rgb } = PDFLib;

// import { updateRangeBackgroundAndLabel } from './app.js';

//#region PUBLIC VALUES
import {
  ACCESSORIES_DATA,
  BACKGROUND_COLOR,
  ENVIRONMENT_MAP,
  ENVIRONMENT_MAP_INTENSITY,
  MODEL_CENTER_POSITION,
  MODEL_PATHS,
  pdfImg,
  pdfImgTop,
  SHADOW_TRANSPARENCY,
  state,
  SIZE_DATA,
  getInitialModelIndex,
} from "./settings";

import { interfaceComponent, shapeType } from "../components/interface/interface";
import { applyAllColors } from "../components/interface/interfaceItems/interfaceGroup/interfaceGroupInputs/interfaceGroupInputs";
import {
  animateScale,
  bloomPass,
  camera,
  canvas,
  create3DScene,
  dirLight,
  fxaaPass,
  getMobileOperatingSystem,
  IMPORTED_MODELS,
  IMPORTED_MODELS_GLTF,
  TABLES_GLTF,
  HEATER_PHOENIX_GLTF,
  HEATER_PALMA_GLTF,
  outputPass,
  renderer,
  requestDelayedRender,
  saoPass,
  scene,
  updateBloomSettings,
  updateEnvMap,
  // params_Bloom,
  updateRenderSize,
  floor,
} from "./3d-scene";
import { initSubSystem } from "./customFunctions/initiSubSystem";
import { preloadTextures, setMaterialTexture, TEXTURES } from "./utils";
import { initURLSystem, decodeURLToState, initStateFromUrl } from "./customFunctions/paramsURL"

const DEBUG_MODE_VALUES = false;
export let modelForExport = null;

const sceneProperties = {
  BACKGROUND_COLOR: BACKGROUND_COLOR,
  MODEL_PATHS: MODEL_PATHS,
  MODEL_CENTER_POSITION: MODEL_CENTER_POSITION,
  SHADOW_TRANSPARENCY: SHADOW_TRANSPARENCY,
  ENVIRONMENT_MAP: ENVIRONMENT_MAP,
  ENVIRONMENT_MAP_INTENSITY: ENVIRONMENT_MAP_INTENSITY,
};

export const clickableObjects = [];
export const hotspots = [];
export const labelObjects = {
  addObject: {
    url: "public/img/icons/hotspot.svg",
    obj: null,
  },
  addObjectHover: {
    url: "public/img/icons/hotspot-hover.svg",
    obj: null,
  },
};

export let currentOS = "unknown";
let delayForWriteURL = false;
let parametersKey = "config";
let parametersValue = "";
let loaded = false;
let paramsLoaded = false;
let isFirstStart = true;
let init = true;
const spanAvatarThickness = 0.1;

let buildCopyAmount = 1;
let buildStepSize = 0;
let buildModelHalfW = 0;
let buildGeomStartZ = 0;
let buildGeomFrameZ = 0;
let buildGeomFrameZOrg = 0;
let buildBackWallZ = 0;
let buildBackWallX = 0;

// hotspot zones
export const ACCESSORY_ZONE_CONFIG = {
  // Ventilation
  automateOpening: ['roof'],
  mosquitoDoor: ['wallFront'],
  extraDoor: ['wallLeft', 'wallRight'],
  extraDoubleDoor: ['wallFront', 'wallBack', 'wallLeft', 'wallRight'],
  roofWindow: ['roof'],
  sideWindow: ['wallLeft', 'wallRight'],
  backWindow: ['wallBack'],
  // standHeater / phoenixHeater: auto-placed (no hotspots)
  // Organization
  plasticTable3Win: ['wallLeft', 'wallRight'],
  woodTable3Win: ['wallLeft', 'wallRight'],
  plasticShelf3Win: ['wallLeft', 'wallRight'],
  woodShelf3Win: ['wallLeft', 'wallRight'],
  plasticTable1Win: ['wallLeft', 'wallRight'],
  woodTable1Win: ['wallLeft', 'wallRight'],
  plasticShelf1Win: ['wallLeft', 'wallRight'],
  woodShelf1Win: ['wallLeft', 'wallRight'],
  cultivationTable: ['wallLeft', 'wallRight'],
  aluminumTable1Win: ['wallLeft', 'wallRight'],
  aluminumShelf1Win: ['wallLeft', 'wallRight'],
  set2Shelves: ['wallLeft', 'wallRight'],
  // Options
  veil: ['roof'],
  downpipes: ['wallFront', 'wallBack'],
  roofDecor: ['roof'],
  // Paquets
  paquetVentilation: ['roof'],
  paquetCultivation: ['wallLeft', 'wallRight'],
};

let modelViewer;
let qrcode;
let qrScaned = 0;

export let theModel;

let isAutoRotate = false;
const autoRotateSpeed = 0.05;
const spanOpacity = 0.15;

// MORPHS & SHADER

let isWorldposVertexShaderEnabled = true;
let morphs = [];
let globalMorphs = [];

var threejs_font_helvetiker_regular;

//#endregion

export const greenHouseConst = {
  side: {
    Left: 0,
    Right: 1,
    Front: 2,
    Back: 3,
    Center: 4,
  },
  sideString: {
    0: "Left",
    1: "Right",
    2: "Front",
    3: "Back",
    4: "Center",
  },
  corner: {
    RL: 0,
    RR: 1,
    FL: 2,
    FR: 3,
  },
  direction: {
    Straight: 0,
    Perpendicular: 1,
  },
  shape: {
    Straight: 0,
    Sloping: 1,
    ExtraHigh: 2
  },
  shapeNames: {
    Straight: "Straight walls",
    Sloping: "Sloping walls",
    ExtraHigh: "Extra-high walls"
  },
  accessoriesType: {
    automateOpening: 0,
    mosquitoDoor: 1,
    extraDoor: 2,
    extraDoubleDoor: 3,
    roofWindow: 4,
    sideWindow: 5,
    backWindow: 6,
    palmaHeating: 7,
    phoenixHeating: 8,
  },
  accessoriesNameString: {
    automateOpening: "Automated opening",
    mosquitoDoor: "Mosquito door",
    extraDoor: "Extra single door",
    extraDoubleDoor: "Extra single door for double opening",
    roofWindow: "Extra roof window",
    sideWindow: "Side window",
    backWindow: "Back window",
    palmaHeating: "Palma Heating",
    phoenixHeating: "Phoenix Heating",
  },
  organizationType: {
    woodTable1Win: 0,
    woodTable3Win: 1,
    woodShelf1Win: 2,
    woodShelf3Win: 3,
    plasticTable1Win: 4,
    plasticTable3Win: 5,
    plasticShelf1Win: 6,
    plasticShelf3Win: 7,
    cultivationTable3Win: 8,
    aluminumTable2Win: 9,
    aluminumShelf2Win: 10,
    set2Shelves: 11,
  },
  organizationNameString: {
    woodTable1Win: "Wood work table 1 window",
    woodTable3Win: "Wood work table 3 windows",
    woodShelf1Win: "Wood work shelf 1 window",
    woodShelf3Win: "Wood work shelf 3 windows",
    plasticTable1Win: "Plastic work table 1 window",
    plasticTable3Win: "Plastic work table 3 windows",
    plasticShelf1Win: "Plastic work shelf 1 window",
    plasticShelf3Win: "Plastic work shelf 3 windows",
    cultivationTable3Win: "Cultivation table 3 windows",
    aluminumTable2Win: "Aluminum table 2 windows",
    aluminumShelf2Win: "Aluminum table 3 windows",
    set2Shelves: "Set of 2 small shelves",
  },
  option: {
    veil: 0,
    downpipes: 1,
    roofDecor: 2,
  },
  optionNameString: {
    veil: "Shade veil",
    downpipes: "Downpipes",
    roofDecor: "Roof decoration",
  },
  accessoriesPaquetsType: {
    ventilation: 0,
    cultivation: 1,
  },
  accessoriesPaquetsNameString: {
    ventilation: "Ventilation",
    cultivation: "Cultivation",
  },
}

const SMALL_CODES = new Set(['R204H', 'R205H', 'S104H', 'S106H']);
const MEDIUM_CODES = new Set(['R305H', 'R306H', 'R308H', 'S206H', 'S208H']);
const XH_CODES = new Set(['R306XH', 'R308XH']);

// How many copy-amount modules each organization item spans (matches "X windows" in the name)
const ORG_WINDOW_COUNT = {
  woodTable1Win: 1,
  woodTable3Win: 3,
  woodShelf1Win: 1,
  woodShelf3Win: 3,
  plasticTable1Win: 1,
  plasticTable3Win: 3,
  plasticShelf1Win: 1,
  plasticShelf3Win: 3,
  cultivationTable3Win: 3,
  aluminumTable2Win: 2,
  aluminumShelf2Win: 2,
  set2Shelves: 1,
};
const ORG_KEYS = new Set(Object.keys(ORG_WINDOW_COUNT));
const ORG_TABLE_KEYS = new Set(['woodTable1Win', 'woodTable3Win', 'plasticTable1Win', 'plasticTable3Win', 'cultivationTable3Win', 'aluminumTable2Win']);
const ORG_SHELF_KEYS = new Set(['woodShelf1Win', 'woodShelf3Win', 'plasticShelf1Win', 'plasticShelf3Win', 'aluminumShelf2Win', 'set2Shelves']);
// Tables and shelves can share the same span — shelf mounts higher and doesn't conflict.
const isTableShelfPair = (a, b) => (ORG_TABLE_KEYS.has(a) && ORG_SHELF_KEYS.has(b)) || (ORG_SHELF_KEYS.has(a) && ORG_TABLE_KEYS.has(b));
const HEATER_KEYS = new Set(['standHeater', 'phoenixHeater']);

loadThreeJSFonts();

//#region INITIALIZATION

export async function Start() {
  blockURLWriter = true;
  currentOS = await getMobileOperatingSystem();

  create3DScene(sceneProperties, async () => await startCallback());

  const startCallback = async () => {
    if (loaded) return;
    loaded = true;

    await StartSettings();
    setTimeout(() => {
      toggleLoad(false);
    }, 3000);
  };
}

export const clones = [];

function animateProperty(object, property, targetValue, duration, onUpdate) {
  const startValue = object[property];
  const startTime = performance.now();

  function animate(time) {
    const elapsedTime = time - startTime;
    const progress = Math.min(elapsedTime / duration, 1);
    object[property] = startValue + (targetValue - startValue) * progress;

    if (onUpdate) onUpdate();

    if (progress < 1) {
      requestAnimationFrame(animate);
    }
  }

  requestAnimationFrame(animate);
}

// #region RAYCAST
function initRaycast() {
  const raycaster = new THREE.Raycaster();
  const mouse = new THREE.Vector2();
  const canvas = document.getElementById("ar_model_view");

  let isMouseMoved = false;
  let clickThreshold = 5;
  let startX, startY;

  let avatarObject;

  function onMouseDown(event) {
    isMouseMoved = false;
    startX = event.offsetX;
    startY = event.offsetY;
  }

  function onMouseMove(event) {
    mouse.x = (event.offsetX / renderer.domElement.clientWidth) * 2 - 1;
    mouse.y = -(event.offsetY / renderer.domElement.clientHeight) * 2 + 1;
    raycaster.setFromCamera(mouse, camera);

    const visibleClickableObjects =
      getVisibleClickableObjects(clickableObjects);
    const intersects = raycaster.intersectObjects(
      visibleClickableObjects,
      true
    );

    if (intersects.length > 0) {
      canvas.style.cursor = "pointer";
      avatarObject = intersects[0].object;
      visibleClickableObjects.forEach((object) => {
        // pergola && pergola.outlineAvatar(object, false);
      });
      // pergola && pergola.outlineAvatar(avatarObject, true, false);
    } else {
      canvas.style.cursor = "default";
      visibleClickableObjects.forEach((object) => {
        pergola && pergola.outlineAvatar(object, false);
      });
    }

    if (
      Math.abs(event.offsetX - startX) > clickThreshold ||
      Math.abs(event.offsetY - startY) > clickThreshold
    ) {
      isMouseMoved = true;
    }
  }

  function onMouseUp(event) {
    if (!isMouseMoved) {
      mouse.x = (event.offsetX / renderer.domElement.clientWidth) * 2 - 1;
      mouse.y = -(event.offsetY / renderer.domElement.clientHeight) * 2 + 1;
      raycaster.setFromCamera(mouse, camera);

      const visibleClickableObjects =
        getVisibleClickableObjects(clickableObjects);
      const intersects = raycaster.intersectObjects(
        visibleClickableObjects,
        true
      );

      if (intersects.length > 0) {
        const intersectedObject = intersects[0].object;
        console.log(`CLICKED: ${intersectedObject.name}`);

        const clickedSpan = intersectedObject.parentSpan;
        pergola && pergola.editSystem(clickedSpan);
        visibleClickableObjects.forEach((object) => {
          pergola && pergola.outlineAvatar(object, false);
        });
      }
    }
  }

  canvas.addEventListener("mousedown", onMouseDown);
  canvas.addEventListener("mousemove", onMouseMove);
  canvas.addEventListener("mouseup", onMouseUp);
}

function getVisibleClickableObjects(objects = []) {
  const visibleObjects = objects.filter(
    (avatar) => avatar.parentSpan.isSystemSet === true
  );

  return visibleObjects;
}
// #endregion

export function toggleLoad(toggle) {
  toggle
    ? $("#app").addClass("app-loader")
    : $("#app").removeClass("app-loader");
}

function getModelIndexForSize(shapeType, sizeIndex) {
  if (shapeType === 2) return MODEL_PATHS.length - 1; // Extra-high

  const sizes = SIZE_DATA[shapeType];
  const code = sizes?.[sizeIndex]?.code ?? sizes?.[0]?.code ?? '';
  const digit = parseInt(code[1], 10);

  if (shapeType === 0) {
    // Straight (R...): R2...= MODEL_PATHS[0], R3... = MODEL_PATHS[1]
    return digit === 2 ? 0 : 1;
  } else {
    // Sloping (S...): S1... = MODEL_PATHS[2], S2... = MODEL_PATHS[3]
    return digit === 1 ? 2 : 3;
  }
}

export function changeShapeType(shapeType) {
  const modelIndex = getModelIndexForSize(shapeType, state.sizeIndex);
  const nextModel = IMPORTED_MODELS[modelIndex];
  if (!nextModel) {
    console.warn(`changeShapeType: model for shapeType ${shapeType} (modelIndex ${modelIndex}) is not loaded yet.`);
    return;
  }

  const prevModel = theModel;

  theModel = nextModel;
  window.theModel = theModel;
  theModel.scale.set(1, 1, 1);
  theModel.visible = true;

  buildTheModel(theModel);
  rebuildAccessoriesForCurrentSize();

  // Hide previous after build — JS is single-threaded so no frame renders in between
  if (prevModel && prevModel !== nextModel) prevModel.visible = false;
}


export function rebuildAccessoriesForCurrentSize() {
  if (!theModel || !scene) return;

  // Remove all accessory clones left from the previous size
  const stale = [];
  scene.traverse(o => { if (o.userData?.accTag) stale.push(o); });
  stale.forEach(o => o.parent?.remove(o));

  pergola._defaultsHandledByRebuild = true;

  // Clear permanent entries so placeAccessory doesn't see them as "already placed" and toggle off
  if (pergola.placedAccessories) {
    for (const [k, e] of [...pergola.placedAccessories.entries()]) {
      if (e.permanent) pergola.placedAccessories.delete(k);
    }
  }

  theModel.updateWorldMatrix(true, true);

  // default roof window(s) — count depends on model size
  placeDefaultRoofWindows();

  // default back downpipe (permanent, non-removable)
  pergola.placeAccessory('downpipes', 'wallBack', 0, { permanent: true });

  // Re-apply user-placed (non-permanent) accessories at their new Z positions
  pergola.reapplyAccessories();
}

export async function getSize(model) {
  const box = new THREE.Box3().setFromObject(model);
  const size = box.getSize(new THREE.Vector3());
  // console.log(size);
}

async function StartSettings() {
  // Use the priority model (the one that was loaded first) as initial reference
  const initModelIndex = getInitialModelIndex();
  theModel = IMPORTED_MODELS[initModelIndex];
  window.theModel = theModel;
  console.log("🚀 ~ theModel:", theModel);

  // Populate state.shapeType / state.sizeIndex from URL
  getSize(theModel);

  // Hide all other already-loaded models; nulls are unloaded background models — skip them
  IMPORTED_MODELS.forEach((m, i) => { if (m) m.visible = i === initModelIndex; });

  ParseMorphByModel(theModel);

  PrepareAR();
  paramsLoaded = true;

  theModel.scale.set(0, 0, 0);
  theModel.visible = true;
  animateScale(theModel);

  await preloadTextures();

  isFirstStart = false;

  if (["Android", "iOS", "VisionPro"].includes(currentOS)) {
    CheckQRMobile();
  }

  modelForExport = theModel;

  buildTheModel(theModel);
  initDayScene();

  //UI ADD
  interfaceComponent($("#content"));
  setAllHotspotsVisibility(false);
  //#endregion

  initRaycast();
}


const MODEL_BUILD_PARAMS = {
  //                                                                        
  0: { frontWallX: 0, frontWallXRight: -0.08, backWallX: 0.05, backWinX: 0, backDoorX: 0.05, backDoorXLeft: -0.08, backDoorXRight: 0.09, backDoorFlipSide: false, diagX: 0, frontDiagRot: [Math.PI / 2, Math.PI, 0], backDiagRot: [Math.PI / 2, -Math.PI * 2, 0], decorFrontX: null, decorFrontRot: [-Math.PI / 2, Math.PI, 0], decorFrontZDelta: -1.04, decorFrontYOffset: 0.0, decorBackX: null, decorBackRot: null, decorBackZDelta: 1.04, decorBackYOffset: 0.0, orgZFraction: 0.18, orgXFraction: 0.038 }, // R200H
  1: { frontWallX: -0.37, frontWallXRight: 0.29, backWallX: -0.28, backDoorX: -0.28, backDoorXLeft: -0.29, backDoorXRight: 0.29, backDoorFlipSide: true, backDoorRot: null, backDoubleDoorRot: [0, Math.PI / 2, 0], diagX: 0.36, veilX: 0, frontDiagRot: [Math.PI / 2, Math.PI, 0], backDiagRot: [Math.PI / 2, -Math.PI, 0], decorFrontX: 0, decorFrontRot: [-Math.PI / 2, Math.PI, 0], decorFrontZDelta: -1.04, decorFrontYOffset: null, decorBackX: 0, decorBackRot: [-Math.PI / 2, Math.PI, 0], decorBackZDelta: 1.04, decorBackYOffset: null, orgZFraction: 0.24, orgXFraction: 0.038 }, // R300H
  2: { frontWallX: -0.085, frontWallXRight: 0, frontWallZOffset: -0.012, backWallX: 0.08, backWinX: 0.0, backWinUseWallX: true, backDoorX: 0.0, backDoorXLeft: -0.08, backDoorXRight: -0.14, backDoorFlipSide: false, diagX: 0, frontDiagRot: [-Math.PI / 2, 0, Math.PI], backDiagRot: [-Math.PI / 2, -Math.PI * 2, 0], decorFrontX: 0, decorFrontRot: [-Math.PI / 2, Math.PI, 0], decorFrontZDelta: -1.04, decorFrontYOffset: null, decorBackX: 0, decorBackRot: [-Math.PI / 2, Math.PI, 0], decorBackZDelta: 1.04, decorBackYOffset: null, orgZFraction: 0.24, orgXFraction: 0.085 }, // S100H
  3: { frontWallX: -0.085, frontWallXRight: 0, backWallX: -0.28, backDoorX: 0.0, backDoorXLeft: -0.28, backDoorXRight: -0.28, backLogoZ: 0.02, backDoorFlipSide: false, backDoubleDoorRot: [0, Math.PI / 2, 0], diagX: 0.36, diagBackX: -0.36, frontDiagRot: [Math.PI / 2, Math.PI, 0], backDiagRot: [Math.PI / 2, -Math.PI, 0], doorLogoLeftUsesRight: true, decorFrontX: 0, decorFrontRot: [-Math.PI / 2, Math.PI, 0], decorFrontZDelta: -1.04, decorFrontYOffset: null, decorBackX: 0, decorBackRot: [-Math.PI / 2, Math.PI, 0], decorBackZDelta: 1.04, decorBackYOffset: null, orgZFraction: 0.31, orgXFraction: 0.038 }, // S200H
  4: { frontWallX: -0.37, frontWallXRight: 0.29, backWallX: 0.05, backDoorX: -0.28, backDoorXLeft: -0.29, backDoorXRight: 0.29, backDoorFlipSide: true, backDoorRot: null, backDoubleDoorRot: [0, Math.PI / 2, 0], diagX: -0.36, veilX: 0, sideDoorZOffset: 0.1, sideDoorZOffsetLeft: -0.09, frontDiagRot: [Math.PI / 2, Math.PI, Math.PI], backDiagRot: [Math.PI / 2, -Math.PI, Math.PI], decorFrontX: 0, decorFrontRot: [-Math.PI / 2, Math.PI, 0], decorFrontZDelta: -1.04, decorFrontYOffset: null, decorBackX: 0, decorBackRot: [-Math.PI / 2, Math.PI, 0], decorBackZDelta: 1.04, decorBackYOffset: null, orgZFraction: 0.25, orgXFraction: 0.038, backDoorWallXOffset: -0.69 }, // R300HX
};

export function getActiveBuildParams() {
  const shapeIdx = +state.shapeType;
  const modelIndex = getModelIndexForSize(shapeIdx, state.sizeIndex);
  return MODEL_BUILD_PARAMS[modelIndex] ?? MODEL_BUILD_PARAMS[0];
}

export function buildTheModel(model) {
  // shape + size
  const shapeIdx = +state.shapeType;
  const sizes = SIZE_DATA[shapeIdx];
  if (!sizes || !sizes.length) {
    console.warn(`buildTheModel: no SIZE_DATA for shapeType ${shapeIdx}`);
    return;
  }

  const currentSize = sizes[state.sizeIndex] ?? sizes[0];

  const digits = currentSize.code.replace(/\D/g, '');
  const copyAmount = parseInt(digits.charAt(digits.length - 1));
  buildCopyAmount = copyAmount;
  state.width = currentSize.width;
  state.length = currentSize.length;

  // Diagonal rotations depend on which GLB is active
  const modelIndex = getModelIndexForSize(shapeIdx, state.sizeIndex);
  const buildParams = MODEL_BUILD_PARAMS[modelIndex] ?? MODEL_BUILD_PARAMS[0];

  model.updateWorldMatrix(true, true);
  const worldPos = new THREE.Vector3().setFromMatrixPosition(model.matrixWorld);
  const worldRot = new THREE.Euler().setFromRotationMatrix(model.matrixWorld);

  const allMeshNames = [];
  model.traverse(o => { if (o.isMesh) allMeshNames.push(o.name); });
  //console.log('  all mesh names in model:', allMeshNames);

  // Front side
  const FRONT_WALL_NAMES = ["front_wall"];
  const FRONT_DIAGONAL_NAMES = ["diagonal_front"];
  const FRONT_HIDDEN_GROUPS = ["front_wall_double", "drain_plastic_front", "drain_alum_front", "shade_veil_front", "decor_front"];

  // Back (XH models use back_door_wall placed separately — back_wall_door doesn't exist there)
  const isXHModel = XH_CODES.has(currentSize.code);
  const BACK_WALL_NAMES = isXHModel ? ["back_wall"] : ["back_wall", "back_wall_door"];
  const BACK_DIAGONAL_NAMES = ["diagonal_back"];
  const BACK_HIDDEN_GROUPS = ["back_wall_double", "drain_plastic_back", "drain_alum_back", "side_w_back", "shade_veil_back", "decor_back"];

  // Groups (not meshes) that repeat along the length — cloned as a whole unit
  const LENGTH_GROUP_NAMES = ["frame", "frame_R", "frame_L"];

  // Meshes that repeat
  const LENGTH_MESH_NAMES = new Set([
    "r_L_G", "r_L_Win_auto", "r_L_Win_manual",
    "r_R_G", "r_R_Win_auto", "r_R_Win_manual",
    "rama", "shade_veil_center", "decor_roof",
    "side_w_L_G", "side_w_R_G",
    "w_L_G", "w_R_G",
  ]);

  const LENGTH_HIDDEN_NAMES = new Set(["shade_veil_center", "decor_roof"]);

  const storeOrigin = (group) => {
    group.userData.originZ = group.position.z;
    if (group.userData.originX === undefined) group.userData.originX = group.position.x;
    if (group.userData.originScaleX === undefined) group.userData.originScaleX = group.scale.x;
  };


  const WALL_GROUP_NAMES = new Set([...FRONT_WALL_NAMES, ...BACK_WALL_NAMES, "back_wall_doors"]);
  const setEndCapX = (group, x) => {
    let p = group.parent;
    // Stop zeroing at wall groups — they have their own X set by placeBackWall/placeFrontWall
    while (p && p !== model && !WALL_GROUP_NAMES.has(p.name)) { p.position.x = 0; p = p.parent; }
    group.position.x = x;
  };

  const placeFrontWall = (groupName) => {
    const group = model.getObjectByName(groupName);
    if (!group) { console.warn(`buildTheModel: "${groupName}" not found`); return; }
    storeOrigin(group);
    group.position.z = group.userData.originZ - stepSize + (buildParams.frontWallZOffset ?? 0);
    setEndCapX(group, buildParams.frontWallX);
    group.rotation.set(0, -Math.PI / 2, 0);
    group.traverse(o => { if (o.isMesh) o.visible = true; });
  };

  const placeFrontDiagonal = (groupName, visible = true) => {
    const group = model.getObjectByName(groupName);
    if (!group) { console.warn(`buildTheModel: "${groupName}" not found`); return; }
    storeOrigin(group);
    group.position.z = group.userData.originZ;
    setEndCapX(group, buildParams.diagX);
    group.rotation.set(...buildParams.frontDiagRot);
    group.traverse(o => { if (o.isMesh) o.visible = visible; });
  };

  const placeBackWall = (groupName, visible) => {
    const group = model.getObjectByName(groupName);
    if (!group) { console.warn(`buildTheModel: "${groupName}" not found`); return; }
    storeOrigin(group);
    group.position.z = group.userData.originZ + stepSize * copyAmount;
    setEndCapX(group, buildParams.backWallX);
    group.rotation.set(0, Math.PI / 2, 0);
    group.traverse(o => { if (o.isMesh) o.visible = visible; });
    buildBackWallZ = group.position.z;
    buildBackWallX = group.position.x;
  };

  const placeBackDiagonal = (groupName, visible) => {
    const group = model.getObjectByName(groupName);
    if (!group) { console.warn(`buildTheModel: "${groupName}" not found`); return; }
    storeOrigin(group);
    group.position.z = group.userData.originZ + stepSize * (copyAmount - 1);
    setEndCapX(group, buildParams.diagBackX ?? buildParams.diagX);
    group.rotation.set(...buildParams.backDiagRot);
    group.traverse(o => { if (o.isMesh) o.visible = visible; });
  };

  // clean up clones from a previous build
  const toRemove = [];
  model.traverse(o => { if (o.userData.isLengthClone) toRemove.push(o); });
  toRemove.forEach(o => o.parent?.remove(o));

  // Reset veil/decor placement userData so origins are recaptured after rebuild
  model.traverse(o => {
    if (o.name === 'shade_veil_front' || o.name === 'shade_veil_back' || o.name === 'shade_veil_center') {
      delete o.userData.veilOriginZ;
    }
    if (o.name === 'decor_front' || o.name === 'decor_back') {
      // Capture native Y from GLB once; reset each rebuild so the offset never accumulates
      if (o.userData.decorNativeY === undefined) o.userData.decorNativeY = o.position.y;
      o.position.y = o.userData.decorNativeY;
      delete o.userData.decorOriginY;
    }
  });

  const allEndCapNames = [
    ...FRONT_WALL_NAMES, ...FRONT_DIAGONAL_NAMES, ...FRONT_HIDDEN_GROUPS,
    ...BACK_WALL_NAMES, ...BACK_DIAGONAL_NAMES, ...BACK_HIDDEN_GROUPS,
  ];
  allEndCapNames.forEach(name => {
    const g = model.getObjectByName(name);
    if (g?.userData.originZ !== undefined) g.position.z = g.userData.originZ;
  });

  // hide all meshes
  model.traverse(o => { if (o.isMesh) o.visible = false; });

  // Save back_door_wall GLTF X before any hotspot code can change it (XH models)
  const xhBdwNode = model.getObjectByName('back_door_wall');
  if (xhBdwNode && xhBdwNode.userData.originX === undefined) {
    xhBdwNode.userData.originX = xhBdwNode.position.x;
  }

  // collect + show length-repeating groups 
  const lengthGroups = [];
  LENGTH_GROUP_NAMES.forEach(name => {
    const group = model.getObjectByName(name);
    if (!group) { console.warn(`buildTheModel: length group "${name}" not found`); return; }
    group.traverse(o => { if (o.isMesh) o.visible = true; });
    lengthGroups.push(group);
  });

  // + .....length-repeating meshes (and hidden groups like shade_veil_center)
  const lengthMeshes = [];
  const seenLengthNames = new Set();
  model.traverse(o => {
    if (LENGTH_MESH_NAMES.has(o.name) && !seenLengthNames.has(o.name + '_' + o.uuid)) {
      if (o.isMesh) {
        o.visible = !LENGTH_HIDDEN_NAMES.has(o.name);
        lengthMeshes.push(o);
        seenLengthNames.add(o.name + '_' + o.uuid);
      } else if (LENGTH_HIDDEN_NAMES.has(o.name)) {
        // Non-mesh (Group/Object3D) that should be hidden and cloned
        o.traverse(c => { if (c.isMesh) c.visible = false; });
        lengthMeshes.push(o);
        seenLengthNames.add(o.name + '_' + o.uuid);
      }
    }
  });

  // measure module step from "rama" geometry (Z = length axis)
  let stepSize = 0;

  model.traverse(o => {
    if (o.name !== "rama" || !o.isMesh || stepSize !== 0) return;
    o.geometry.computeBoundingBox();
    const localSize = o.geometry.boundingBox.getSize(new THREE.Vector3());
    const worldScale = new THREE.Vector3(); o.getWorldScale(worldScale);
    const parentScale = new THREE.Vector3(); (o.parent ?? model).getWorldScale(parentScale);
    stepSize = (localSize.z * worldScale.z) / parentScale.z;
  });

  // "rama"`s measure its bounding box in world space
  if (!stepSize) {
    const ramaGroup = model.getObjectByName('rama');
    if (ramaGroup && !ramaGroup.isMesh) {
      const ramaBox = new THREE.Box3().setFromObject(ramaGroup);
      const size = ramaBox.getSize(new THREE.Vector3());
      stepSize = size.z;
    }
  }

  if (!stepSize) {
    stepSize = currentSize.length / copyAmount;
    console.warn(`  "rama" not found — fallback step=${stepSize.toFixed(4)} m`);
  }

  FRONT_WALL_NAMES.forEach(name => placeFrontWall(name));
  FRONT_DIAGONAL_NAMES.forEach(name => placeFrontDiagonal(name));
  FRONT_HIDDEN_GROUPS.forEach(name => placeFrontDiagonal(name, false));

  for (let i = 1; i < copyAmount; i++) {
    lengthGroups.forEach(original => {
      const clone = original.clone(true);
      clone.position.copy(original.position);
      clone.position.z += stepSize * i;
      clone.traverse(o => { if (o.isMesh) o.visible = true; });
      clone.userData.isLengthClone = true;
      original.parent.add(clone);
    });

    lengthMeshes.forEach(original => {
      const clone = original.clone(true);
      clone.position.copy(original.position);
      clone.position.z += stepSize * i;
      if (original.isMesh) {
        clone.visible = !LENGTH_HIDDEN_NAMES.has(original.name);
      } else {
        // Group — hide child meshes if in LENGTH_HIDDEN_NAMES
        clone.traverse(c => { if (c.isMesh) c.visible = !LENGTH_HIDDEN_NAMES.has(original.name); });
      }
      clone.userData.isLengthClone = true;
      original.parent.add(clone);
    });
  }


  BACK_WALL_NAMES.forEach(name => placeBackWall(name, true));
  BACK_DIAGONAL_NAMES.forEach(name => placeBackDiagonal(name, true));
  // Preserve GLB rotation for side_w_back before placeBackDiagonal overwrites it
  const sideWBackGroup = model.getObjectByName('side_w_back');
  if (sideWBackGroup && !sideWBackGroup.userData.glbRotation) {
    sideWBackGroup.userData.glbRotation = sideWBackGroup.rotation.clone();
  }
  BACK_HIDDEN_GROUPS.forEach(name => placeBackDiagonal(name, false));

  // Apply to every loaded model so all glass_wave instances stay consistent.
  // Only the active model gets the panel reference update.
  IMPORTED_MODELS.forEach(m => {
    if (m) applyHammeredGlass(m, m === model);
  });

  // Hide accessories
  const DOOR_HIDDEN_NAMES = new Set([
    "door_mosquito", "mesh_frame_front",
    "door_mosquito_back", "mesh_frame_back",
    "back_wall_door",
    "back_wall_doors", // S100H back door group (plural variant of back_wall_door)
    "back_door", "back_door_logo", // XH back door — hidden until user adds extra door
    // back_w_*_G are inside back_wall in S200H/R300HX — placeBackWall shows them; hide here
    "back_w_L_G", "back_w_R_G",
  ]);
  model.traverse(o => {
    if (DOOR_HIDDEN_NAMES.has(o.name)) o.visible = false;
  });

  applyAllColors();

  const hex = state.colorBody || "#C8C8C8";
  const isAluminum = hex.toLowerCase() === "#c8c8c8";
  model.traverse(o => {
    if (!o.isMesh || !o.material || o.material.name !== "Anodized") return;
    o.material.color.set(hex);
    o.material.metalness = isAluminum ? 0.8 : 0;
    o.material.roughness = isAluminum ? 0.2 : 0.4;
    o.material.needsUpdate = true;
  });

  // Force scale=1 and rotation=0 so bbox is in axis-aligned model-local space
  // (rotation.y on the model would otherwise skew world-Z values, making buildGeomFrameZ
  const savedScale = model.scale.clone();
  const savedRotationY = model.rotation.y;
  model.scale.set(1, 1, 1);
  model.rotation.y = 0;
  model.position.x = 0;
  model.position.z = 0;
  model.updateMatrixWorld(true);

  // bbox from visible geometry only
  const visBox = new THREE.Box3();
  let ramaMinZ = Infinity;
  model.traverseVisible(o => {
    if (!o.isMesh || !o.geometry) return;
    o.updateWorldMatrix(true, false);
    const tmp = new THREE.Box3().setFromBufferAttribute(o.geometry.attributes.position);
    tmp.applyMatrix4(o.matrixWorld);
    visBox.union(tmp);
    if (o.name === 'rama' && tmp.min.z < ramaMinZ) ramaMinZ = tmp.min.z;
  });

  if (!visBox.isEmpty()) {
    model.position.x = -(visBox.min.x + visBox.max.x) / 2;
    model.position.z = -(visBox.min.z + visBox.max.z) / 2;
  }

  let ramaMinZLegacy = Infinity;
  if (savedRotationY !== 0) {
    model.rotation.y = savedRotationY;
    model.position.x = 0;
    model.position.z = 0;
    model.updateMatrixWorld(true);
    model.traverseVisible(o => {
      if (o.name !== 'rama' || !o.isMesh || !o.geometry) return;
      o.updateWorldMatrix(true, false);
      const tmpOrg = new THREE.Box3().setFromBufferAttribute(o.geometry.attributes.position);
      tmpOrg.applyMatrix4(o.matrixWorld);
      if (tmpOrg.min.z < ramaMinZLegacy) ramaMinZLegacy = tmpOrg.min.z;
    });
    // Restore centered position from local bbox
    if (!visBox.isEmpty()) {
      model.position.x = -(visBox.min.x + visBox.max.x) / 2;
      model.position.z = -(visBox.min.z + visBox.max.z) / 2;
    }
  }

  model.rotation.y = savedRotationY;
  model.scale.copy(savedScale);
  model.updateMatrixWorld(true);

  // for hotspot placement
  buildStepSize = stepSize;
  buildModelHalfW = currentSize.width / 2;
  buildGeomStartZ = visBox.isEmpty() ? 0 : visBox.min.z;
  buildGeomFrameZ = isFinite(ramaMinZ) ? ramaMinZ : buildGeomStartZ;
  buildGeomFrameZOrg = isFinite(ramaMinZLegacy) ? ramaMinZLegacy : buildGeomFrameZ;

  pergola.createFrom3DModel(model);
}

function applyHammeredGlass(model, updatePanelRef = true) {
  // const hammeredGlassVert = `
  //   varying vec2 vUv_hammered;
  // `;

  // // Voronoi cellular noise — each cell = one hammer mark (rounded dent/dome)
  // const hammeredGlassFrag = `
  //   varying vec2 vUv_hammered;

  //   vec2 hg_hash2(vec2 p) {
  //     p = vec2(dot(p, vec2(127.1, 311.7)), dot(p, vec2(269.5, 183.3)));
  //     return fract(sin(p) * 43758.5453);
  //   }

  //   // Returns vec3(dist_to_cell_center, delta.x, delta.y)
  //   // delta points FROM current position TOWARD cell center
  //   vec3 hg_voronoi(vec2 p) {
  //     vec2 i = floor(p);
  //     vec2 f = fract(p);
  //     float minDist = 8.0;
  //     vec2  minDelta = vec2(0.0);
  //     for (int y = -1; y <= 1; y++) {
  //       for (int x = -1; x <= 1; x++) {
  //         vec2 nb  = vec2(float(x), float(y));
  //         // jitter cell center: 0.5 ± 0.45 so centers stay well inside cell
  //         vec2 pt  = 0.5 + 0.45 * sin(hg_hash2(i + nb) * 6.2831853);
  //         vec2 diff = nb + pt - f;          // toward cell center
  //         float d   = length(diff);
  //         if (d < minDist) { minDist = d; minDelta = diff; }
  //       }
  //     }
  //     return vec3(minDist, minDelta);
  //   }

  //   float hg_hash(vec2 p) {
  //     return fract(sin(dot(p, vec2(127.1, 311.7))) * 43758.5453);
  //   }
  //   float hg_noise(vec2 p) {
  //     vec2 i = floor(p); vec2 f = fract(p);
  //     f = f * f * (3.0 - 2.0 * f);
  //     return mix(mix(hg_hash(i), hg_hash(i+vec2(1,0)), f.x),
  //                mix(hg_hash(i+vec2(0,1)), hg_hash(i+vec2(1,1)), f.x), f.y);
  //   }
  // `;

  model.traverse((o) => {
    if (!o.isMesh) return;
    const mat = o.material;
    if (!mat || mat.name !== "glass_wave") return;

    mat.metalness = 0.30;
    mat.roughness = 0.30;
    mat.opacity = 1.00;
    mat.alphaTest = 0.00;
    mat.ior = 1.80;
    mat.transmission = 1.00;
    mat.thickness = 0.00;
    mat.attenuationDistance = 5.30;
    mat.iridescence = 0.00;
    mat.iridescenceIOR = 2.21;
    mat.clearcoat = 0.00;
    mat.clearcoatRoughness = 0.00;
    mat.sheen = 0.00;
    mat.sheenRoughness = 1.00;
    mat.emissiveIntensity = 1.00;
    mat.specularIntensity = 1.00;
    mat.envMapIntensity = 1.00;
    mat.normalScale?.set(1.00, -1.00);
    mat.transparent = false;
    mat.alphaToCoverage = false;
    mat.wireframe = false;
    window.__glassMat = mat;

    // material modal helper:
    //if (updatePanelRef) buildGlassDebugPanel(mat);

    // mat.onBeforeCompile = (shader) => {
    //   shader.vertexShader = shader.vertexShader.replace(
    //     `#include <uv_pars_vertex>`,
    //     `#include <uv_pars_vertex>\n${hammeredGlassVert}`
    //   );
    //   shader.vertexShader = shader.vertexShader.replace(
    //     `#include <uv_vertex>`,
    //     `#include <uv_vertex>\n  vUv_hammered = uv;`
    //   );

    //   shader.fragmentShader = shader.fragmentShader.replace(
    //     `#include <uv_pars_fragment>`,
    //     `#include <uv_pars_fragment>\n${hammeredGlassFrag}`
    //   );

    //   shader.fragmentShader = shader.fragmentShader.replace(
    //     `#include <normal_fragment_maps>`,
    //     `#include <normal_fragment_maps>
    //     {
    //       // --- Voronoi layer: discrete hammer-mark cells ---
    //       float cellScale = 80.0;     // ~50 marks across UV space
    //       vec3  vor  = hg_voronoi(vUv_hammered * cellScale);
    //       float d    = vor.x;         // 0 = cell center, ~0.5 = cell edge
    //       vec2  dir  = normalize(vor.yz); // direction toward cell center

    //       // Spherical dome profile: flat at center, steepest halfway, flat at edge
    //       float profile = sin(clamp(d / 0.52, 0.0, 1.0) * 3.14159265);
    //       float cellStrength = 0.18;
    //       vec2  cellPerturb  = dir * profile * cellStrength;

    //       // --- Fine noise layer: micro surface irregularity ---
    //       float fine = hg_noise(vUv_hammered * 90.0);
    //       vec2  finePerturb = vec2(fine - 0.3) * 0.03;

    //       normal.xy += cellPerturb + finePerturb;
    //       normal = normalize(normal);
    //     }`
    //   );
    // };

    mat.needsUpdate = true;
  });
}

//#endregion

//#region MESH / MATERIAL utils

export function GetMesh(name, model = theModel) {
  var object = null;
  model?.traverse((o) => {
    if (o.isMesh) {
      if (name == o.name) {
        object = o;
      }
    }
  });

  return object;
}

export function GetGroup(name, model = theModel) {
  var group = null;
  model.traverse((o) => {
    if (o.isGroup) {
      if (name == o.name) {
        group = o;
      }
    }
  });

  return group;
}

//#region HOTSPOTS
function createHotspot(id, normalUrl, hoverUrl, position, groupName = "") {
  const hotspotContainer = document.getElementById("ar_model_viewer");
  if (!hotspotContainer) {
    return;
  }

  const hotspot = document.createElement("div");
  hotspot.classList.add("hotspot");
  hotspot.id = id;
  hotspot.dataset.id = id;
  hotspot.style.backgroundImage = `url(${normalUrl})`;
  hotspot.groupName = groupName;
  hotspot.dataset.group = groupName;

  hotspot.hoverFunction = () => { };
  hotspot.normalFunction = () => { };
  hotspot.clickFunction = () => { };

  hotspot.addEventListener("mouseenter", () => {
    hotspot.style.backgroundImage = `url(${hoverUrl})`;
    hotspot.hoverFunction();
  });

  hotspot.addEventListener("mouseleave", () => {
    hotspot.style.backgroundImage = `url(${normalUrl})`;
    hotspot.normalFunction();
  });

  hotspot.addEventListener("click", () => {
    // console.log(`Hotspot ${id} clicked`);
    hotspot.clickFunction();
  });

  hotspotContainer.appendChild(hotspot);

  return {
    element: hotspot,
    position: position,
    setHoverFunction: (newFunction) => {
      hotspot.hoverFunction = newFunction;
    },
    setNormalFunction: (newFunction) => {
      hotspot.normalFunction = newFunction;
    },
    setClickFunction: (newFunction) => {
      hotspot.clickFunction = newFunction;
    },
  };
}

export function updateHotspots(hotspots) {
  const $canvasContainer = $("#ar_model_viewer");
  hotspots.forEach(({ element, position }) => {
    if (position && element.style.display !== 'none') {
      const screenPosition = position.clone();
      screenPosition.project(camera);
      const x = (screenPosition.x * 0.5 + 0.5) * $canvasContainer.width();
      const y = (screenPosition.y * -0.5 + 0.5) * $canvasContainer.height();
      $(element).css({
        left: `${x}px`,
        top: `${y}px`,
        transform: "translate(-50%, -50%)",
        "-webkit-transform": "translate(-50%, -50%)",
      });
    }
  });
}

function setHotspotVisibility(hotspot, visible) {
  if (!hotspot || !hotspot.element) {
    return;
  }

  hotspot.element.style.display = visible ? "block" : "none";
}

export function setAllHotspotsVisibility(visible) {
  const hotspots = document.querySelectorAll(".hotspot");

  hotspots.forEach((hotspot) => {
    setHotspotVisibility(hotspot, visible);
    // console.log(hotspot);
  });
}

function setHotspotsByGroupVisibility(groupName, visible) {
  const hotspots = document.querySelectorAll(
    `.hotspot[data-group="${groupName}"]`
  );
  hotspots?.forEach((hotspot) => {
    hotspot.style.display = visible ? "block" : "none";
  });
}

window.addEventListener("resize", () => {
  updateHotspots(hotspots);
});

window.addEventListener("orientationchange", function (event) {
  // window.orientation is read-only in modern browsers
});

//#endregion


// eslint-disable-next-line no-unused-vars
function GetMaterial(name) {
  var material = null;
  theModel.traverse((o) => {
    if (o.isMaterial) {
      if (name == o.material.name) {
        material = o.material;
      }
    }
  });

  return material;
}

function GetMaterialFromScene(name) {
  var material = null;
  scene.traverse((o) => {
    if (o.material) {
      if (name == o.material.name) {
        material = o.material;
      }
    }
  });

  return material;
}

// eslint-disable-next-line no-unused-vars
export function ChangeMaterialTilling(materialName, x, y) {
  var materialObject = GetMaterialFromScene(materialName);

  if (materialObject == null) {
    return;
  }

  if (materialObject.map != null) {
    materialObject.map.repeat.set(x, y);
  }

  if (materialObject.normalMap != null) {
    materialObject.normalMap.repeat.set(x, y);
  }

  if (materialObject.roughnessMap != null) {
    materialObject.roughnessMap.repeat.set(x, y);
  }

  if (materialObject.metalnessMap != null) {
    materialObject.metalnessMap.repeat.set(x, y);
  }

  if (materialObject.aoMap != null) {
    materialObject.aoMap.repeat.set(x, y);
  }
}

// eslint-disable-next-line no-unused-vars
export function ChangeMaterialOffset(materialName, x, y) {
  var materialObject = GetMaterialFromScene(materialName);

  if (materialObject == null) {
    return;
  }

  if (materialObject.map != null) {
    materialObject.map.offset.set(x, y);
  }

  if (materialObject.normalMap != null) {
    materialObject.normalMap.offset.set(x, y);
  }

  if (materialObject.roughnessMap != null) {
    materialObject.roughnessMap.offset.set(x, y);
  }

  if (materialObject.metalnessMap != null) {
    materialObject.metalnessMap.offset.set(x, y);
  }

  if (materialObject.aoMap != null) {
    materialObject.aoMap.offset.set(x, y);
  }
}

export function triggerIconClick(iconType) {
  const icon = $(`.icon_wrap`).find(`#${iconType}`);
  icon.show();

  if (icon.length) {
    icon.trigger("click");
  } else {
    console.error("Icon not found");
  }
}

export function showIcon(iconType, trigger = false) {
  const icon = $(`.icon_wrap`).find(`#${iconType}`);
  icon.show();

  if (trigger) {
    icon.trigger("click");
  }
}

export function hideIcon(iconType) {
  const icon = $(`.icon_wrap`).find(`#${iconType}`);

  // REMOVE CLASS "active" from icon
  const classesToRemove = icon
    .attr("class")
    ?.split(" ")
    .filter((className) => className.includes("active"));

  if (classesToRemove?.length) {
    icon.removeClass(classesToRemove.join(" "));
  }

  icon.hide();

  // Only close the portal if the currently open portal belongs to this icon.
  // Calling hideIcon(12) while portal 11 is open must not close portal 11.
  if (state.portalOption === +iconType) {
    $(".portal-container").hide();
    $(".interface-container").removeClass("interface-container-portal");
  }
}
// eslint-disable-next-line no-unused-vars
function setVisibility(model, value, meshArray = [], isInclude = false) {
  if (model) {
    if (value == undefined && value == null) {
      return;
    }

    if (meshArray.length === 0) {
      model.visible = value;
      return;
    }

    for (let i = 0; i < meshArray.length; i++) {
      model.traverse((o) => {
        if (o.name == meshArray[i]) {
          o.visible = value;
        }

        if (isInclude) {
          if (o.name.includes(meshArray[i])) {
            o.visible = value;
          }
        }
      });
    }
  }
}

// eslint-disable-next-line no-unused-vars
function setMaterialColor(materialName, color) {
  const materialObject = GetMaterialFromScene(materialName);
  if (materialObject == null) {
    return;
  }
  materialObject.color.set(color);
  materialObject.needsUpdate = true;
}

const textureLoader = new THREE.TextureLoader();
textureLoader.setCrossOrigin("anonymous");
const textureCache = {};
const texturePool = {};

function setTexture(id, path, material, materialProp, tilling) {
  if (material == null) {
    return;
  }
  if (materialProp == null) {
    return;
  }

  const value = texturePool[id.toLowerCase()];
  if (value != null) {
    assingTexture(material, materialProp, value, tilling);
    return;
  }

  textureLoader.load(
    path,
    (texture) => {
      // console.log("texture is loading");
      texture.magFilter = THREE.NearestFilter;
      texture.minFilter = THREE.NearestMipmapNearestFilter;
      texture.anisotropy = 16;
      texture.flipY = false;
      texture.colorSpace = THREE.SRGBColorSpace;
      texture.wrapS = THREE.RepeatWrapping;
      texture.wrapT = THREE.RepeatWrapping;
      texturePool[id.toLowerCase()] = texture;

      assingTexture(material, materialProp, texture, tilling);
    },
    undefined,
    () => {
      console.error("An error happened.");
    }
  );

  function assingTexture(material, materialProp, texture, tilling) {
    switch (materialProp) {
      case "map":
        material.map = texture;
        if (tilling != null) {
          texture.repeat.set(tilling.x, tilling.y);
        }
        break;
      default:
        break;
    }
    material.needsUpdate = true;
  }
}

//#endregion

//#region CLIPBOARD

// eslint-disable-next-line no-unused-vars
const copyToClipboard = (infoSharingInput) => {
  var aux = document.createElement("input");
  aux.setAttribute("value", infoSharingInput.value);
  document.body.appendChild(aux);
  aux.select();
  document.execCommand("copy");
  document.body.removeChild(aux);
};

//#endregion

//#region QR
function CreateQR() {
  var uri = window.location.href;
  var encoded = encodeURIComponent(uri);
  var qrImg = new Image();
  qrImg.src = "https://quickchart.io/qr?text=" + encoded + "&size=200";
  qrImg.addEventListener("load", () => {
    $(qrImg).addClass("ar__bottom__qr");
    $("#qr-container").html(qrImg);
  });
}

async function CheckQRMobile() {
  // eslint-disable-next-line no-unused-vars
  await waitFor((_) => loaded === true);
  // eslint-disable-next-line no-unused-vars
  await waitFor((_) => modelViewer != undefined);
  await new Promise((r) => setTimeout(r, 2000));

  if (qrScaned == 1) {
    if (["Android", "iOS", "VisionPro"].includes(currentOS)) {
      OpenAR();
    }

    qrScaned = 0;

    WriteURLParameters();
  }
}

//#endregion

//#region AR
function PrepareAR() {
  modelViewer = $("#marevo_model");
  const arPromt = $("#ar-prompt");
  modelViewer[0].addEventListener("ar-status", (event) => {
    if (event.detail.status == "session-started") {
      arPromt[0].style.display = "block";
      if (floor) floor.visible = false;
    } else if (event.detail.status == "not-presenting") {
      arPromt[0].style.display = "none";
      if (floor) floor.visible = true;
      modelViewer[0].resetScene();
      init = true;
    } else {
      arPromt[0].style.display = "none";
    }
  });
}

async function OpenAR() {
  console.log("start");

  if (init) {
    console.log("open", scene, pergola, theModel, modelForExport);

    ParseMorphByModel(theModel);

    ComputeMorphedAttributes();

    // Fix glass panel materials for AR transparency
    scene.traverse((o) => {
      if (!o.isMesh || !o.material) return;
      let isInsideGlassPanel = false;
      let p = o.parent;
      while (p) {
        if (p.name && p.name.startsWith('sliding_glass_panel')) { isInsideGlassPanel = true; break; }
        if (p.userData?.clonedDoor) { isInsideGlassPanel = true; break; }
        p = p.parent;
      }
      if (!isInsideGlassPanel) return;
      const mats = Array.isArray(o.material) ? o.material : [o.material];
      mats.forEach((mat) => {
        if (!mat) return;
        const n = (mat.name || '').toLowerCase();
        if (n.includes('glass') || n.includes('glazing') || n.includes('window') || mat.opacity < 0.99) {
          mat.transparent = true;
          if (mat.opacity >= 0.99) mat.opacity = 0.3;
          mat.side = THREE.DoubleSide;
          mat.depthWrite = false;
          mat.needsUpdate = true;
        }
      });
    });

    await ImportScene(scene);

    if (getMobileOperatingSystem() == "iOS") {
    }

    init = false;
  }

  console.log("end");
}

// eslint-disable-next-line no-unused-vars
export function OpenARorQR() {
  console.log("click AR");
  if (["Android", "iOS", "VisionPro"].includes(currentOS)) {
    init = true;
    OpenAR();
    return;
  }

  console.log("QR");
  CreateQR();

  $(".portal-container__close").trigger("click");
  $("#ar").show();
}

//IMPORT
async function ImportScene(newScene) {
  console.log(modelViewer[0], newScene);
  await modelViewer[0].importScene(newScene);
  modelViewer[0].activateAR();
}
//#endregion

//#region URL PARAMETERS

// eslint-disable-next-line no-unused-vars
var wix_url_base = null;
var wix_current_url = null;
var wix_url_load_params = null;

// eslint-disable-next-line no-unused-vars
function PostMassagesListener(event) {
  let receivedMessage = event.data;
  //console.log("Отримано повідомлення з main сайту:", receivedMessage);

  if (receivedMessage == "undefined") {
    return;
  }
  if (receivedMessage == undefined) {
    return;
  }
  if (receivedMessage == null) {
    return;
  }

  if (receivedMessage.includes("WIX_URL_LOAD|")) {
    return;
  }
  if (receivedMessage.includes("WIX_CURRENT_URL|")) {
    wix_current_url = receivedMessage.replace("WIX_CURRENT_URL|", "");
    return;
  }
  if (receivedMessage.includes("WIX_URL_LOAD_Params|")) {
    wix_url_load_params = receivedMessage.replace("WIX_URL_LOAD_Params|", "");
    var url =
      location.protocol + "//" + location.host + location.pathname + "?";
    history.pushState(null, "marevo", url + "config=" + wix_url_load_params);
    return;
  }
  if (receivedMessage.includes("URL_Params|")) {
    return;
  }
  if (receivedMessage.includes("WIX_URL_BASE|")) {
    wix_url_base = receivedMessage.replace("WIX_URL_BASE|", "");
    return;
  }

  if (receivedMessage.includes("WIX_IS_LOADED|")) {
    return;
  }
}

function WriteURLParameters() {
  if (!paramsLoaded) {
    return;
  }
  if (blockURLWriter) {
    return;
  }

  if (!delayForWriteURL) {
    delayForWriteURL = true;
    promiseDelay(100, function () {
      history.pushState(null, "marevo", GetURLWithParameters());
      if (isWIX == true) {
        window.parent.postMessage(
          "URL_Params|" + GetURLWithParameters("", true),
          "*"
        );
      }
      delayForWriteURL = false;
    });
  }
}

function GetParametersString() {
  parametersValue = "";

  if (pergolaSettings == null) {
    return parametersValue;
  }

  var splitValue = "-";

  parametersValue += pergolaSettings.width + splitValue;
  parametersValue += pergolaSettings.length + splitValue;
  parametersValue += pergolaSettings.height + splitValue;
  parametersValue += pergolaSettings.postSize + splitValue;
  parametersValue += pergolaSettings.colorHex + splitValue;
  parametersValue += pergolaSettings.colorLouveredHex + splitValue;
  parametersValue += pergolaSettings.colorLedHex + splitValue;
  parametersValue += pergolaSettings.colorMoodHex + splitValue;
  parametersValue += pergolaSettings.roofType + splitValue;
  parametersValue +=
    (pergolaSettings.mountingWall_Back == true ? 1 : 0) + splitValue;
  parametersValue +=
    (pergolaSettings.mountingWall_Left == true ? 1 : 0) + splitValue;
  parametersValue +=
    (pergolaSettings.mountingWall_Right == true ? 1 : 0) + splitValue;
  parametersValue +=
    (pergolaSettings.extraOptionLight == true ? 1 : 0) + splitValue;
  parametersValue += pergolaSettings.extraOptionLightSpacing + splitValue;
  parametersValue +=
    (pergolaSettings.extraOptionFan == true ? 1 : 0) + splitValue;
  parametersValue +=
    (pergolaSettings.extraOptionLed == true ? 1 : 0) + splitValue;
  parametersValue +=
    (pergolaSettings.extraOptionHeaters == true ? 1 : 0) + splitValue;
  parametersValue +=
    (pergolaSettings.extraOptionMoodLight == true ? 1 : 0) + splitValue;
  parametersValue += qrScaned;

  parametersValue = parametersValue.SEncode();

  return parametersValue;
}

function GetURLWithParameters(updateURL = null, withoutKey = false) {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const entries = urlParams.entries();

  var url = location.protocol + "//" + location.host + location.pathname + "?";

  if (updateURL != null) {
    url = updateURL + "?";
  }

  var configEmpty = true;

  for (const entry of entries) {
    if (entry[0] == parametersKey) {
      url += parametersKey + "=" + GetParametersString() + "&";
      configEmpty = false;
    } else if (entry[0] == "onlyAR") {
      continue;
    } else {
      url += entry[0] + "=" + entry[1] + "&";
    }
  }

  if (configEmpty) {
    url += parametersKey + "=" + GetParametersString();
  }

  if (withoutKey) {
    url = url.replace("?" + parametersKey + "=", "");
  }

  if (url.endsWith("&")) {
    url = url.substring(0, url.length - 1);
  }

  return url;
}

// eslint-disable-next-line no-unused-vars
function delay(time) {
  return new Promise((resolve) => setTimeout(resolve, time));
}

//#endregion

//#region UTILS
function waitFor(conditionFunction) {
  const poll = (resolve) => {
    if (conditionFunction()) resolve();
    // eslint-disable-next-line no-unused-vars
    else setTimeout((_) => poll(resolve), 400);
  };

  return new Promise(poll);
}

function promiseDelay(time, callback) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve("resolved");
      if (callback != null) {
        callback();
      }
    }, time);
  });
}
//#endregion

//#region SHADER and MORPHS

function Shader_ChangeVertexToWorldpos(object) {
  var vUvSymbol = "vUv";
  var uvTransformSymbol = "uvTransform";

  if (THREE.REVISION >= 150) {
    vUvSymbol = "vMapUv";
    uvTransformSymbol = "mapTransform";
  }

  promiseDelayShaderSettings(500, object, () => {
    if (object.isMesh) {
      if (isWorldposVertexShaderEnabled) {
        if (object.material) {
          if (object.material.name.includes("_Z")) {
            object.material.onBeforeCompile = (shader) => {
              shader.vertexShader = shader.vertexShader
                .replace("#include <uv_vertex>\n", "")
                .replace(
                  "#include <worldpos_vertex>",
                  `vec4 worldPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\nworldPosition = instanceMatrix * worldPosition;\n#endif\nworldPosition = modelMatrix * worldPosition;\n${vUvSymbol} = (${uvTransformSymbol} * vec3(worldPosition.xz, 1)).xy;`
                );
            };
          } else if (object.material.name.includes("_Y")) {
            object.material.onBeforeCompile = (shader) => {
              shader.vertexShader = shader.vertexShader
                .replace("#include <uv_vertex>\n", "")
                .replace(
                  "#include <worldpos_vertex>",
                  `vec4 worldPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\nworldPosition = instanceMatrix * worldPosition;\n#endif\nworldPosition = modelMatrix * worldPosition;\n${vUvSymbol} = (${uvTransformSymbol} * vec3(worldPosition.xy, 1)).xy;`
                );
            };
          } else if (object.material.name.includes("_X")) {
            object.material.onBeforeCompile = (shader) => {
              shader.vertexShader = shader.vertexShader
                .replace("#include <uv_vertex>\n", "")
                .replace(
                  "#include <worldpos_vertex>",
                  `vec4 worldPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\nworldPosition = instanceMatrix * worldPosition;\n#endif\nworldPosition = modelMatrix * worldPosition;\n${vUvSymbol} = (${uvTransformSymbol} * vec3(worldPosition.yz, 1)).xy;`
                );
            };
          }
          object.material.needsUpdate = true;
        }
      }
    }
  });
}

function promiseDelayShaderSettings(time, object, callback) {
  if (time == null) {
    time = 2000;
  }

  return new Promise((resolve) => {
    setTimeout(() => {
      resolve("resolved");
      if (object.material.map == null) {
        promiseDelayShaderSettings(time, object, callback);
      } else {
        if (callback != null) {
          callback();
        }
      }
    }, time);
  });
}

export function ParseMorphByModel(model, callback = null) {
  morphs = [];
  model.traverse((object) => {
    if (object.isMesh) {
      Shader_ChangeVertexToWorldpos(object);

      if (object.morphTargetDictionary != null) {
        for (const [key, value] of Object.entries(
          object.morphTargetDictionary
        )) {
          var morph = {
            name: key,
            object: object,
            key: value,
            value: value,
          };

          if (!morphs.includes(morph)) {
            morphs.push(morph);
          }
        }
      }
    }
  });

  PrepareGlobalMorphs(callback);
}

function PrepareGlobalMorphs(callback = null) {
  globalMorphs = [];

  for (let index = 0; index < morphs.length; index++) {
    const morph = morphs[index];

    var hasMorph = false;

    for (let m = 0; m < globalMorphs.length; m++) {
      const globalMorph = globalMorphs[m];
      if (globalMorph.name != morph.name) {
        continue;
      }
      hasMorph = true;
      break;
    }

    if (!hasMorph) {
      globalMorphs.push(morph);
    }
  }

  if (callback != null) {
    callback();
  }
}

export function ComputeMorphedAttributes() {
  for (let index = 0; index < morphs.length; index++) {
    const morph = morphs[index];
    var computeMorphedAttributesValue = computeMorphedAttributes(morph.object);
    morph.object.geometry.computeMorphedAttributes =
      computeMorphedAttributesValue;
  }

  // console.log(scene);

  scene.traverse((object) => {
    if (object.isMesh) {
      var computeMorphedAttributesValue = computeMorphedAttributes(object);

      console.log(computeMorphedAttributesValue);

      object.geometry.computeMorphedAttributes = computeMorphedAttributesValue;
    }
  });
}

// eslint-disable-next-line no-unused-vars
export function ChangeObjectWithMorph(object, key, inputvalue) {
  if (object == null) {
    return;
  }

  if (object.morphTargetInfluences != null) {
    object.morphTargetInfluences[key] = inputvalue;
  }
}

export function ChangeGlobalMorph(morphName, inputvalue) {
  for (let index = 0; index < morphs.length; index++) {
    const morph = morphs[index];

    if (morph.name != morphName) {
      continue;
    }
    if (morph.object == null) {
      continue;
    }
    if (!morph.object.isMesh) {
      continue;
    }
    if (morph.object.morphTargetInfluences == null) {
      continue;
    }

    morph.object.morphTargetInfluences[morph.key] = inputvalue;
  }
}

export function ClipMeshWithDashedEffectAfterMorph(mesh, step = 1, gap = 0.3) {
  if (
    !mesh ||
    !mesh.geometry ||
    !(mesh.geometry instanceof THREE.BufferGeometry)
  ) {
    console.error("Невалідний меш для обрізання.");
    return;
  }

  mesh.geometry.applyMatrix4(mesh.matrixWorld);
  mesh.geometry = mesh.geometry.toNonIndexed(); // Робимо геометрію неіндексованою
  const geometry = mesh.geometry.clone(); // Клонування геометрії для роботи

  const positions = geometry.attributes.position.array; // Масив позицій
  if (!positions) {
    console.error("Геометрія не містить позицій вершин.");
    return;
  }

  const newPositions = [];
  const vertexStepMap = [];

  const totalLength = step; // Довжина одного сегмента (зубчик + прогалина)
  const gapStart = step - gap; // Межа початку прогалини

  // Обробка вершин для створення штрихованого ефекту по осі Z
  for (let i = 0; i < positions.length; i += 3) {
    const zPos = positions[i + 2]; // Координата Z для поточної вершини

    // Округлення для усунення похибок плаваючої точки
    const normalizedPosition =
      zPos - Math.floor(zPos / totalLength) * totalLength;

    // Перевіряємо, чи вершина знаходиться в зоні штриха
    if (normalizedPosition < gapStart) {
      newPositions.push(positions[i], positions[i + 1], positions[i + 2]);
      vertexStepMap.push(newPositions.length / 3 - 1); // Маркуємо як частину штриха
    } else {
      vertexStepMap.push(-1); // Прогалина
    }
  }

  // Створення нових індексів
  const newIndices = [];
  const oldIndices = geometry.index ? geometry.index.array : null;

  if (oldIndices) {
    for (let j = 0; j < oldIndices.length; j += 3) {
      const v1 = vertexStepMap[oldIndices[j]];
      const v2 = vertexStepMap[oldIndices[j + 1]];
      const v3 = vertexStepMap[oldIndices[j + 2]];

      // Додаємо тільки трикутники, які не містять прогалини
      if (v1 >= 0 && v2 >= 0 && v3 >= 0) {
        newIndices.push(v1, v2, v3);
      }
    }
  }

  // Створення фінальної геометрії
  const dashedGeometry = new THREE.BufferGeometry();
  dashedGeometry.setAttribute(
    "position",
    new THREE.BufferAttribute(new Float32Array(newPositions), 3)
  );

  if (newIndices.length > 0) {
    dashedGeometry.setIndex(newIndices);
  }

  // Оновлення геометрії у меші
  mesh.geometry.dispose(); // Звільнити стару геометрію
  mesh.geometry = dashedGeometry;
  mesh.geometry.computeBoundingBox();
  mesh.geometry.computeBoundingSphere();
}

export function ConvertMorphValue(
  inputval,
  srcStart,
  srcEnd,
  destStart = 0,
  destEnd = 1
) {
  const result =
    destStart +
    ((inputval - srcStart) * (destEnd - destStart)) / (srcEnd - srcStart);
  return result;
}

export function ConvertMorphValueReverse(
  outputVal,
  srcStart,
  srcEnd,
  destStart = 0,
  destEnd = 1
) {
  const result =
    srcStart +
    ((outputVal - destStart) * (srcEnd - srcStart)) / (destEnd - destStart);
  return result;
}

// eslint-disable-next-line no-unused-vars

//#endregion

//#region PROJECT FUNCTIONS 
export function generateMidpoints(
  vectorA,
  vectorB,
  numPoints,
  isFirstLastPointAdded = false
) {
  const points = [];

  if (isFirstLastPointAdded) {
    points.push(vectorA.clone());
  }

  for (let i = 1; i <= numPoints; i++) {
    const t = i / (numPoints + 1);
    const point = new THREE.Vector3().lerpVectors(vectorA, vectorB, t);

    points.push(point);
  }

  if (isFirstLastPointAdded) {
    points.push(vectorB.clone());
  }

  return points;
}

export function generateCenterMidpoints(
  vectorA,
  vectorB,
  numPoints,
  isFirstLastPointAdded = false,
  divide = 1
) {
  const points = [];

  if (isFirstLastPointAdded) {
    points.push(vectorA);
  }

  for (let i = 1; i <= numPoints; i++) {
    const t = i / (numPoints + 1);
    const point = new THREE.Vector3().lerpVectors(vectorA, vectorB, t);
    points.push(point);
  }

  if (isFirstLastPointAdded) {
    points.push(vectorB);
  }

  if (points.length == 1) {
    return points;
  }

  var dividePoints = points;
  for (let index = 0; index < divide; index++) {
    dividePoints = pointDivideProcess(dividePoints);
  }

  return dividePoints;
}

function pointDivideProcess(points) {
  const dividePoint = [];

  for (let i = 0; i < points.length; i++) {
    if (i + 1 >= points.length) {
      continue;
    }

    var point1 = points[i];
    var point2 = points[i + 1];
    const centerPoint = new THREE.Vector3().lerpVectors(point1, point2, 0.5);

    dividePoint.push(centerPoint);
  }

  return dividePoint;
}

function setValueToCoordinates(points, axis, value) {
  for (let i = 0; i < points.length; i++) {
    points[i][axis] = value;
  }
}

var pointLights = [];
var ledLights = [];
var moodLeds = [];
var pointsBeamX = [];
var pointsBeamZ = [];

export function getSubsystemSummary(type) {
  const spans = pergola.span?.objects || [];
  const activeSides = [];
  const seenSides = new Set();

  spans.forEach(span => {
    if (span.isSystemSet && span.activeaccessoriesType === type && !seenSides.has(span.side)) {
      seenSides.add(span.side);
      activeSides.push(span.side);
    }
  });

  return activeSides;
}

export function getSideLabel(side) {
  switch (side) {
    case greenHouseConst.side.Front: return 'Front';
    case greenHouseConst.side.Back: return 'Back';
    case greenHouseConst.side.Left: return 'Left';
    case greenHouseConst.side.Right: return 'Right';
    default: return '';
  }
}

export function removeAllSubsystems() {
  const allTypes = [
    greenHouseConst.accessoriesType.slidingGlassDoor,
    greenHouseConst.accessoriesType.privacyWall,
    greenHouseConst.accessoriesType.autoShade,
  ];

  // Remove all 3D clones
  const clonesToRemove = [];
  scene.traverse((o) => {
    if (o.userData?.clonedDoor || o.userData?.clonedShutter || o.userData?.clonedShade) {
      clonesToRemove.push(o);
    }
  });
  clonesToRemove.forEach(c => c.parent?.remove(c));

  // Clear all span states
  if (pergola?.span?.objects) {
    pergola.span.objects.forEach(span => {
      span.systems?.forEach(system => {
        if (system) {
          system.active = false;
          if (system.object) pergola.changeObjectVisibility(false, system.object);
        }
      });
      span.active = true;
      span.isLocked = false;
      span.isSystemSet = false;
      span.activeaccessoriesType = null;
    });
  }

  // Clear state
  state.subSystemUrl.clear();
  state.subSystem.clear();
  state.currentActiveSystems = null;

  // UI cleanup
  allTypes.forEach(type => hideIcon(type));
  $(`#last-group`).closest(".interface__group").find(".interface__group__head__param").text("-");
  $(`#last-group .option`).removeClass("type_interface_electronic_item--active");
  $(`#last-group input[type='radio']`).prop("checked", false);
  $(".portal-container").hide();
  $(".interface-container").removeClass("interface-container-portal");
}

export function resetToDefaults() {
  // Reset core state
  // state.countryType = 0;
  state.shapeType = 0;
  state.sizeIndex = 0;
  state.installation = false;
  state.colorBody = "#C8C8C8";
  state.subAccessoriesUrl.clear();

  // Update 3D model
  applyAllColors();
  pergola.update();
}

// For organization items that have both a plastic and wood sub-group inside their parent mesh,
//  materialKey: 'pl' | 'wood' | null.
function applyMaterialVariant(obj, materialKey) {
  if (!materialKey) return;
  obj.traverse(child => {
    if (!child.isMesh && !child.isGroup) return;
    const n = child.name.toLowerCase();
    const endsWithPl = n.endsWith('_pl');
    const endsWithWood = n.endsWith('_wood');
    if (!endsWithPl && !endsWithWood) return;
    const keep = materialKey === 'pl' ? endsWithPl : endsWithWood;
    child.visible = keep;
    if (!keep) child.traverse(c => { c.visible = false; });
  });
}

export class PergolaObject {
  constructor(settings) {
    this.theModel = null;
    this.system = new PergolaSystem();
    this.span = new PergolaSpan();
    this.extraOptions = new PergolaExtraOptions();
    this.settings = settings;
  }

  createFrom3DModel(model) {
    pointLights = [];
    ledLights = [];
    moodLeds = [];

    // Clear previous state to avoid duplicates on rebuild
    this.system.objects = [];
    this.span.objects.forEach(span => {
      if (span.hotspot?.element?.parentNode) span.hotspot.element.parentNode.removeChild(span.hotspot.element);
    });
    this.span.objects = [];
    hotspots.length = 0;

    // Remove any accessory clones 
    if (scene) {
      const stale = [];
      scene.traverse(o => { if (o.userData?.accTag) stale.push(o); });
      stale.forEach(o => o.parent?.remove(o));
    }
    this.placedAccessories = new Map();

    this.theModel = model;
    window.model = model;

    const urlParams = window.location.search;
    const hasUrlConfig = urlParams.includes('config=');
    let decodedSubSystemUrl = null;

    if (hasUrlConfig && !this._urlStateLoaded) {
      this._urlStateLoaded = true;
      const stateParam = urlParams.substring(urlParams.indexOf('config=') + 7);
      if (stateParam) {
        const decodedState = decodeURLToState(stateParam);
        decodedSubSystemUrl = decodedState.subSystemUrl ? [...decodedState.subSystemUrl] : [];
        Object.assign(state, decodedState);
      }
    }


    this.prepareSystems();
    this.prepareSpans();
    updateHotspots(hotspots);

    ParseMorphByModel(scene);

    requestAnimationFrame(() => {
      state.currentActiveSystems = null;
      applyAllColors();
      pergola.update();

      {
        const frontWall = model.getObjectByName('front_wall');
        const leftLogo = model.getObjectByName('door_mosquito_logo');
        const rightLogo = model.getObjectByName('door_logo');
        if (frontWall && leftLogo && rightLogo) {
          if (!frontWall.userData.originPos) {
            frontWall.userData.originPos = frontWall.position.clone();
            frontWall.userData.originQuat = frontWall.quaternion.clone();
          }

          const usesRight = getActiveBuildParams().doorLogoLeftUsesRight;
          {
            // Use model's own animations to save rest state — no GLTF[0] dependency.
            const trackRe = /\.(position|quaternion|scale|morphTargetInfluences)$/;
            const ownGltf = IMPORTED_MODELS_GLTF.find(g => g?.scene === model);
            (ownGltf?.animations ?? []).forEach(clip => {
              clip.tracks.forEach(track => {
                const nodeName = track.name.replace(trackRe, '');
                const node = model.getObjectByName(nodeName);
                if (node && node !== model && !node.userData.restQuat) {
                  node.userData.restQuat = node.quaternion.clone();
                  node.userData.restPos = node.position.clone();
                }
              });
            });

            frontWall.scale.z = -Math.abs(frontWall.scale.z);
            frontWall.position.set(
              (frontWall.userData.originPos?.x ?? 0) + 0.085,
              frontWall.userData.originPos?.y ?? 1.438,
              frontWall.userData.originPos?.z ?? -0.375
            );
            model.updateWorldMatrix(true, true);

            if (!usesRight) {
              // For rotating-door models: re-parent logos to door pivot so they follow
              // door animation. Uses 'door' node directly — no GLTF[0] dependency.
              const doorPivInit = model.getObjectByName('door');
              if (doorPivInit && doorPivInit !== model) {
                [leftLogo, rightLogo].forEach(logo => {
                  if (!logo) return;
                  if (logo.parent !== doorPivInit) {
                    doorPivInit.attach(logo);
                    logo.rotation.set(0, logo === leftLogo ? Math.PI : 0, 0);
                  }
                  logo.position.set(0, 0, 0);
                  logo.scale.set(1, 1, 1);
                  logo.userData.restPos = logo.position.clone();
                  logo.userData.restQuat = logo.quaternion.clone();
                  logo.userData.restScale = logo.scale.clone();
                });
              }
            }
            // For S200H (usesRight): logos stay in front_wall's space.
            // scale.x=-1 fixes winding when front_wall.scale.z<0; position.z is compensated
            // to keep the mesh visual center on the door panel despite the scale flip.
          }
          rightLogo.visible = false;
          rightLogo.traverse(o => { if (o.isMesh) o.visible = false; });
          if (usesRight) {
            leftLogo.visible = false;
            leftLogo.traverse(o => { if (o.isMesh) o.visible = false; });
            rightLogo.visible = true;
            rightLogo.traverse(o => { if (o.isMesh) o.visible = true; });

            // Compute and cache mesh center X for scale.x=-1 compensation
            let logoGeomInit = null;
            if (rightLogo.isMesh) { logoGeomInit = rightLogo.geometry; }
            else { rightLogo.traverse(c => { if (!logoGeomInit && c.isMesh) logoGeomInit = c.geometry; }); }
            if (logoGeomInit) {
              logoGeomInit.computeBoundingBox();
              rightLogo.userData.logoMeshCenterX =
                (logoGeomInit.boundingBox.min.x + logoGeomInit.boundingBox.max.x) / 2;
            }

            // Re-parent to door so logo follows door animation (same as R200H/S100H)
            const doorNodeInit = model.getObjectByName('door');
            if (doorNodeInit && doorNodeInit !== model) {
              model.updateWorldMatrix(true, true);
              doorNodeInit.attach(rightLogo);
              // After attach: logo at (0,0,0) identity in door's local space
            }

            // Init forces left side: scale.x=-1 + compensate position.x in door's local space
            rightLogo.scale.x = -1;
            const cxInit = rightLogo.userData.logoMeshCenterX ?? 0;
            rightLogo.position.x = 2 * cxInit; // compensation: door local X → world X via door's rotation
            rightLogo.userData.restPos = rightLogo.position.clone();
            rightLogo.userData.restScale = rightLogo.scale.clone();
            rightLogo.userData.restQuat = rightLogo.quaternion.clone(); // identity after attach
          } else {
            leftLogo.visible = true;
            leftLogo.traverse(o => { if (o.isMesh) o.visible = true; });
          }
        }
      }

      initURLSystem();
    });

    // Place default roof window & back downpipe
    {
      const self = this;

      const tryPlaceAccessories = () => {
        // rebuildAccessoriesForCurrentSize already placed defaults synchronously on model switch —
        // skip here to avoid toggling them back off (placeAccessory is a toggle).
        if (self._defaultsHandledByRebuild) {
          self._defaultsHandledByRebuild = false;
          return;
        }
        if (theModel && Math.abs(theModel.scale.x - 1.0) < 0.01) {
          theModel.updateWorldMatrix(true, true);

          // default roof window(s) — count depends on model size
          placeDefaultRoofWindows();

          // default back downpipe (permanent, non-removable)
          self.placeAccessory('downpipes', 'wallBack', 0, { permanent: true });

          const savedPlacements = state.accessoryPlacements || [];
          savedPlacements.forEach(p => {
            const placeKey = `${p.key}__${p.zone}__${p.span}`;
            if (!self.placedAccessories.has(placeKey)) {
              self.placeAccessory(p.key, p.zone, p.span);
            }
          });
          // Restore selected accessory cards in the interface for replayed placements
          if (savedPlacements.length) {
            savedPlacements.forEach(p => {
              $(`.type_interface_accessories__card[data-key="${p.key}"]`)
                .addClass('type_interface_accessories__card--selected');
            });
          }
        } else {
          requestAnimationFrame(tryPlaceAccessories);
        }
      };
      requestAnimationFrame(tryPlaceAccessories);
    }

    setTimeout(() => {
      const tryInitSubSystem = () => {
        if (theModel && Math.abs(theModel.scale.x - 1.0) < 0.01) {
          initSubSystem();
        } else {
          requestAnimationFrame(tryInitSubSystem);
        }
      };
      requestAnimationFrame(tryInitSubSystem);

      if (!window.meshClickAnimInit) {
        window.meshClickAnimInit = true;
        initMeshClickAnimation();
      }
    }, 500);
  }

  cloneWithMorphs(doorGroup) {
    const clonedGroup = doorGroup.clone();

    clonedGroup.traverse((child) => {
      if (child.isMesh && child.geometry && child.geometry.morphAttributes) {
        // Клонування геометрії та морфів
        child.geometry = child.geometry.clone();

        if (child.morphTargetInfluences) {
          // Копіюємо всі морфи, щоб вони застосовувались коректно
          child.morphTargetInfluences = [...child.morphTargetInfluences];
        }

        if (child.morphTargetDictionary) {
          // Також копіюємо словник морфів, якщо він є
          child.morphTargetDictionary = { ...child.morphTargetDictionary };
        }

        // Переконайтеся, що всі атрибути морфів копіюються в новий об'єкт
        if (child.geometry.morphAttributes.position) {
          child.geometry.morphAttributes.position = [
            ...child.geometry.morphAttributes.position,
          ];
        }
      }
    });

    return clonedGroup;
  }

  cloneMeshWithMorphs(originalMesh) {
    const clonedMesh = originalMesh.clone(true);

    clonedMesh.geometry = originalMesh.geometry.clone();
    clonedMesh.geometry.morphAttributes = {
      ...originalMesh.geometry.morphAttributes,
    };

    clonedMesh.material = originalMesh.material.clone();
    clonedMesh.material.morphTargets = true;

    // Якщо були morphTargetInfluences — скопіювати
    if (originalMesh.morphTargetInfluences) {
      clonedMesh.morphTargetInfluences = [
        ...originalMesh.morphTargetInfluences,
      ];
    }

    return clonedMesh;
  }

  getPergolaBounds() {
    return {
      minX: -state.width / 2,
      maxX: state.width / 2,
      minZ: -state.length / 2,
      maxZ: state.length / 2
    };
  }

  getSideTargetWorldPos(side, offsets = {}) {
    const bounds = this.getPergolaBounds();
    if (!bounds) return new THREE.Vector3(0, 0, 0);

    const {
      front = 0,
      back = 0,
      left = 0,
      right = 0
    } = offsets;

    const pos = new THREE.Vector3(0, 0, 0);

    switch (side) {
      case greenHouseConst.side.Front:
        pos.z = bounds.maxZ - front;
        break;

      case greenHouseConst.side.Back:
        pos.z = bounds.minZ + back;
        break;

      case greenHouseConst.side.Left:
        pos.x = bounds.minX + left;
        break;

      case greenHouseConst.side.Right:
        pos.x = bounds.maxX - right;
        break;
    }

    return pos;
  }

  getSideTargetLocalPos(parent, side, offsets = {}) {
    parent.updateWorldMatrix(true, false);
    const worldPos = this.getSideTargetWorldPos(side, offsets);
    return parent.worldToLocal(worldPos.clone());
  }

  setOptions() {
    pointsBeamX = [];
    pointsBeamZ = [];

    if (!pergola.roof) return;

    if (pergola.roof.headerLed && pergola.roof.headerLed.length > 0) {
      pergola.roof.headerLed[0].object.visible = false;
    }

    if (state.electro.has(greenHouseConst.optionNameString.LEDStrip)) {
      if (pergola.roof.headerLed && pergola.roof.headerLed.length > 0) {
        pergola.roof.headerLed[0].object.visible = true;
      }
    }
  }

  cleanOtherSystemsOnSide(side, currentType) {
    const toRemove = [];

    scene.traverse(o => {
      if (o.userData?.clonedDoor && o.userData?.doorSide === side && currentType !== greenHouseConst.accessoriesType.slidingGlassDoor) {
        toRemove.push(o);
      }
      if (o.userData?.clonedShutter && o.userData?.shutterSide === side && currentType !== greenHouseConst.accessoriesType.privacyWall) {
        toRemove.push(o);
      }
      if (o.userData?.clonedShade && o.userData?.shadeSide === side && currentType !== greenHouseConst.accessoriesType.autoShade) {
        toRemove.push(o);
      }
    });

    toRemove.forEach(o => {
      if (o.parent) o.parent.remove(o);
    });
  };
  cloneExtraOptionObject(type, count) {
    var element = this.extraOptions.elements.find((item) => item.type == type);
    if (element == null && type != PergolaExtraOptionType.moodLight) {
      return;
    }

    if (type != PergolaExtraOptionType.moodLight) {
      for (let index = 0; index < count; index++) {
        var extraOptionElement = new PergolaExtraOptionElement();
        extraOptionElement.type = element.type;

        var clonedMesh = element.object.clone();
        clonedMesh.visible = false;

        if (["Android", "iOS", "VisionPro"].includes(currentOS)) {
          if (type == PergolaExtraOptionType.light) {
            for (let l = 0; l < clonedMesh.children.length; l++) {
              const element = clonedMesh.children[l];
              if (!element.isLight) {
                continue;
              }
              pointLights.push(element);
            }
          }

          if (type == PergolaExtraOptionType.led) {
            for (let l = 0; l < clonedMesh.children.length; l++) {
              const element = clonedMesh.children[l];
              if (!element.isLight) {
                continue;
              }
              ledLights.push(element);
            }
          }

          if (type == PergolaExtraOptionType.moodLed) {
            for (let l = 0; l < clonedMesh.children.length; l++) {
              const element = clonedMesh.children[l];
              if (!element.isLight) {
                continue;
              }
              moodLeds.push(element);
            }
          }
        }

        var parent = scene.getObjectByName("Scene");

        if (parent != null) {
          parent.add(clonedMesh);
        } else {
          scene.add(clonedMesh);
        }

        extraOptionElement.object = clonedMesh;

        this.extraOptions.elements.push(extraOptionElement);
      }
    } else {
      // MOOD LIGHT
      for (let i = 0; i < count; i++) {
        const extraOptionElement = new PergolaExtraOptionElement();
        extraOptionElement.type = type;

        for (let j = 0; j < 4; j++) {
          const rectLight = new THREE.RectAreaLight(0xffffff, 1, 1, 0.05);
          rectLight.power = 3;
          rectLight.visible = false;

          // scene.add(new RectAreaLightHelper(rectLight)); //! TEMP for test

          const parent = scene.getObjectByName("Scene");
          if (parent != null) {
            parent.add(rectLight);
          } else {
            scene.add(rectLight);
          }

          extraOptionElement.objects[j] = rectLight;
        }
        this.extraOptions.elements.push(extraOptionElement);
      }
    }
  }


  animateGroup(group, startAnimation, animationStates) {
    const child = group.children[2] || group;
    //console.log(child);

    if (!child) return;

    const isAnimating = animationStates.get(group);

    if (startAnimation) {
      if (isAnimating) return;
      animationStates.set(group, true);

      const rotateChild = () => {
        if (!animationStates.get(group)) return;
        child.rotation.y += 0.05;
        child.rotation.y %= Math.PI * 2;
        requestAnimationFrame(rotateChild);
      };

      rotateChild();
    } else {
      animationStates.set(group, false);
    }
  }

  prepareExtraOptions() {
    const count_heater = 4;
    const count_led = 5; // 17;
    const count_mood = 6; // 18;
    const count_mood_led = 5; // 17;
    const count_light = 103; // 320;

    this.cloneExtraOptionObject(PergolaExtraOptionType.heater, count_heater);
    this.cloneExtraOptionObject(PergolaExtraOptionType.led, count_led);
    this.cloneExtraOptionObject(PergolaExtraOptionType.moodLight, count_mood);
    this.cloneExtraOptionObject(PergolaExtraOptionType.moodLed, count_mood_led);
    this.cloneExtraOptionObject(PergolaExtraOptionType.light, count_light);


    const fanObjects = this.extraOptions.elements.filter(
      (item) => item.type == PergolaExtraOptionType.fan
    );
    rotateFans(fanObjects, autoRotateSpeed);
  }

  editSystem(span) {
    if (!span) {
      return;
    }
    const system = span.getCurrentSystem();
    if (!system) {
      return;
    }

    state.lastSpan = span;
    this.settings.currentSpan = span;
    this.settings.currentSubsystem = system;
    this.settings.currentSubsystemKey = system.name;

    triggerIconClick(system.type);
  }

  checkSystemInScene(typeSys, side = false) {
    return this.span.objects.some((span) =>
      span.systems.some((system) => {
        const isCorrectSide = this.checkSide(side, system.side);

        const compareGul = this.checkaccessoriesType(typeSys, system.type);

        return system.active && compareGul && isCorrectSide;
      })
    );
  }

  checkSide(side, systemSide) {
    if (side === greenHouseConst.side.Back) {
      return (
        systemSide === greenHouseConst.side.Back ||
        systemSide === greenHouseConst.side.Front
      );
    } else if (side === greenHouseConst.side.Left) {
      return (
        systemSide === greenHouseConst.side.Left ||
        systemSide === greenHouseConst.side.Right
      );
    } else {
      return true;
    }
  }

  checkaccessoriesType(typeSys, accessoriesType) {
    return accessoriesType === typeSys;
  }

  getLastActiveSpan(typeSys) {
    return this.span.objects.filter(
      (span) => span.isSystemSet && span.activeaccessoriesType === typeSys
    );
  }

  checkSystemInAllSpans(typeSys) {
    return this.span.objects.some(
      (span) => span.isSystemSet && span.activeaccessoriesType === typeSys
    );
  }

  resetSpans() {
    const spans = this.span.objects;
    for (let i = 0; i < spans.length; i++) {
      if (spans[i].isSystemSet) continue;
      spans[i].avatar.visible = false;
      spans[i].active = false;
      spans[i].isLocked = false;
    }
  }

  // Maps value from [inMin, inMax] to [outMin, outMax].
  interpolateValue(value, inMin, inMax, outMin, outMax) {
    return outMin + (value - inMin) / (inMax - inMin) * (outMax - outMin);
  }


  getCornerPoints(offsetX = 0, offsetZ = 0) {
    const halfW = state.width / 2;
    const halfL = state.length / 2;
    const y = 0; // floor level; callers set .y themselves when needed

    return {
      FL_point: new THREE.Vector3(-halfW + offsetX, y, halfL + offsetZ),
      FR_point: new THREE.Vector3(halfW + offsetX, y, halfL + offsetZ),
      RL_point: new THREE.Vector3(-halfW + offsetX, y, -halfL - offsetZ),
      RR_point: new THREE.Vector3(halfW + offsetX, y, -halfL - offsetZ),
    };
  }

  getSpanPoints() {
    const offsetX = -0.15;
    const offsetZ = -0.15; // зміщення по осі Z для Front/Back
    const offsetWidth = 0.159;
    const offsetDepth = 0.315;
    const offsetBackZ = 0;

    const { FL_point, FR_point, RL_point, RR_point } = this.getCornerPoints(
      offsetX,
      offsetZ
    );

    // const FL_post_point = FL_point.clone().add(
    //   new THREE.Vector3(0, 0, offsetZ) // Зміщуємо тільки по осі Z для фронту
    // );
    // const FR_post_point = FR_point.clone().add(
    //   new THREE.Vector3(offsetX, 0, 0) // Зміщуємо тільки по осі Z для фронту
    // );
    // const RL_post_point = RL_point.clone().add(
    //   new THREE.Vector3(0, 0, -offsetZ) // Зміщуємо тільки по осі Z для задньої частини
    // );
    // const RR_post_point = RR_point.clone().add(
    //   new THREE.Vector3(offsetX, 0, 0) // Зміщуємо тільки по осі Z для задньої частини
    // );

    const widthInterval = state.postWidthInterval;
    const depthInterval = state.postDepthInterval;
    const currentWidth = state.width;
    const currentDepth = state.length;

    const front_span_points = generateCenterMidpoints(
      FL_point,
      FR_point,
      Math.floor(currentWidth / widthInterval),
      true
    );
    const back_span_points = generateCenterMidpoints(
      RL_point.clone().add(new THREE.Vector3(0, 0, offsetBackZ)),
      RR_point.clone().add(new THREE.Vector3(0, 0, offsetBackZ)),
      Math.floor(currentWidth / widthInterval),
      true
    );
    const left_span_points = generateCenterMidpoints(
      FL_point,
      RL_point,
      Math.floor(currentDepth / depthInterval),
      true
    );
    const right_span_points = generateCenterMidpoints(
      FR_point,
      RR_point,
      Math.floor(currentDepth / depthInterval),
      true
    );

    function calculateDistance(point1, point2, correct) {
      const adjustedPoint1 = point1;
      const adjustedPoint2 = point2;

      let distance = Math.sqrt(Math.pow(adjustedPoint2 - adjustedPoint1, 2));

      if (correct) {
        const additionalOffset = 0.2;
        distance -= additionalOffset;
      }

      return distance;
    }

    const lenghtPoints = [FR_point, RR_point];
    const widthPoints = [FL_point, FR_point];

    const span_width = calculateDistance(widthPoints[0].x, widthPoints[1].x);
    const span_depth = calculateDistance(lenghtPoints[0].z, lenghtPoints[1].z);

    // console.log(span_width, span_depth, "CONSOLE LOG SPAN SIZE");

    return {
      front_span_points,
      back_span_points,
      left_span_points,
      right_span_points,
      span_width,
      span_depth,
    };
  }

  showAvailableSpans() {
    if (
      state.currentActiveSystems !== null &&
      state.currentActiveSystems !== undefined
    ) {
      const spans = this.span.objects;

      for (let i = 0; i < spans.length; i++) {
        setHotspotVisibility(spans[i].hotspot, spans[i].active);
      }
    }
  }

  outlineAvatar(object, active, animate = true) {
    if (!object) {
      return;
    }
    if (active && object.visible) {
      return;
    }
    if (!active && !object.visible) {
      return;
    }

    if (!active) {
      object.material.opacity = 0;
      object.material.needsUpdate = true;
      object.visible = false;
    } else {
      object.visible = true;

      if (animate) {
        object.material.opacity = 0;
        object.material.needsUpdate = true;
        animateProperty(
          object.material,
          "opacity",
          spanOpacity + 0.2,
          250,
          () => {
            object.material.needsUpdate = true;
          }
        );
      } else {
        object.material.opacity = spanOpacity + 0.2;
        object.material.needsUpdate = true;
      }
    }
  }

  //#region SPAN LOGIC

  putCurrentMenuSystemToCurrentSpan(span) {
    const currentSubsystem = state.currentActiveSystems;
    const targetSide = span.side;

    this.span.objects.forEach((otherSpan) => {
      if (otherSpan.side === targetSide) {
        otherSpan.activeaccessoriesType = null;
        otherSpan.systems.forEach((system) => {
          const usedByOtherSide = this.span.objects.some(
            (s) => s.side !== targetSide && s.isSystemSet && s.activeaccessoriesType === system.type && s.systems.includes(system)
          );
          if (!usedByOtherSide) {
            system.active = false;
            system.activeSide = null;
            this.changeObjectVisibility(false, system.object);
          }
        });
        otherSpan.isSystemSet = false;
      }
    });

    const activeSystem = span.systems.find((system) => {
      return system.type === currentSubsystem;
    });

    if (activeSystem) {
      activeSystem.active = true;
      activeSystem.activeSide = targetSide;
      state.currentActiveSystems = activeSystem.type;
      span.activeaccessoriesType = currentSubsystem;
      span.isSystemSet = true;
      span.isLocked = true;
      this.changeObjectVisibility(true, activeSystem.object);

      state.subSystemUrl.add({
        spanNumber: span.number,
        type: activeSystem.type,
        side: targetSide,
      });
    }

    this.update();
  }

  putCurrentMenuSystemToAllFreeSpans() {
    const currentSubsystem = this.settings.currentSubsystem;
    const spans = this.span.objects;

    spans.forEach((span) => {
      if (span.active && !span.isSystemSet) {
        span.systems.forEach((system) => {
          system.active = false;
          this.changeObjectVisibility(false, system.object);
          this.changeObjectVisibility(false, system.windowObject);
        });

        const activeSystem = span.systems.find((system) => {
          return system.type === currentSubsystem;
        });

        if (activeSystem) {
          activeSystem.active = true;
          span.active = false;
          span.isSystemSet = true;
          this.changeObjectVisibility(true, activeSystem.object);
        }
      }
    });

    this.update();
  }

  getSpanBySideAndNumber(side, number) {
    return this.span.objects.find(
      (span) => span.side === side && span.number === number
    );
  }

  removeSystemFromSpanType(type) {
    const spans = this.span.objects;
    const sidesToRemove = new Set();
    spans.forEach(span => {
      if (span.isSystemSet && span.activeaccessoriesType === type) {
        sidesToRemove.add(span.side);
      }
    });

    sidesToRemove.forEach(side => {
      const clonesToRemove = [];
      scene.traverse((o) => {
        // Sliding doors
        if (o.userData?.clonedDoor && o.userData?.doorSide === side) {
          clonesToRemove.push(o);
        }
        // shutters
        if (o.userData?.clonedShutter && o.userData?.shutterSide === side) {
          clonesToRemove.push(o);
        }
        // blinds
        if (o.userData?.clonedShade && o.userData?.shadeSide === side) {
          clonesToRemove.push(o);
        }
      });
      clonesToRemove.forEach(c => c.parent?.remove(c));
    });

    spans.forEach(span => {
      span.systems.forEach(system => {
        if (system && system.type === type) {
          system.active = false;
          system.openingside = true;
          system.openValue = 0;
          if (system.object) this.changeObjectVisibility(false, system.object);
        }
      });
      if (span.isSystemSet && span.activeaccessoriesType === type && sidesToRemove.has(span.side)) {
        span.active = true;
        span.isLocked = false;
        span.isSystemSet = false;
        span.activeaccessoriesType = null;
      }
    });
    this.update();
  }

  removeSystemFromSpan(spanRef) {
    // spanRef (state.lastSpan) may be stale after a setSpans() call — resolve to the live object
    const span = this.span.objects.find(
      (s) => s.side === spanRef.side && s.number === spanRef.number
    ) || spanRef;

    const type = span.activeaccessoriesType;
    if (type === null || type === undefined) return;

    const side = span.side;
    const clonesToRemove = [];

    scene.traverse((o) => {
      if (o.userData?.clonedDoor && o.userData?.doorSide === side) clonesToRemove.push(o);
      if (o.userData?.clonedShutter && o.userData?.shutterSide === side) clonesToRemove.push(o);
      if (o.userData?.clonedShade && o.userData?.shadeSide === side) clonesToRemove.push(o);
    });
    clonesToRemove.forEach(c => c.parent?.remove(c));

    span.systems.forEach(system => {
      if (system && system.type === type) {
        system.active = false;
        system.openingside = true;
        system.openValue = 0;
        if (system.object) this.changeObjectVisibility(false, system.object);
        if (system.windowObject) this.changeObjectVisibility(false, system.windowObject);
      }
    });

    span.active = true;
    span.isLocked = false;
    span.isSystemSet = false;
    span.activeaccessoriesType = null;

    this.update();
  }

  //#endregion

  setSpans() {
    const {
      front_span_points,
      back_span_points,
      left_span_points,
      right_span_points,
      span_width,
      span_depth,
    } = this.getSpanPoints();

    if (state.backWall) {
      this.span.objects.forEach((span) => {
        if (span.side === greenHouseConst.side.Back) {
          span.isSystemSet = false;
          span.isLocked = false;
          span.systems.forEach((s) => { if (s) s.active = false; });
        }
      });
    }

    this.resetSpans();

    const height = state.height;
    const offsetZ =
      this.originZ == greenHouseConst.side.Front ? (state.length * 0.0254) / 2 : 0;

    const configureSpan = (points, side, width, thickness) => {
      points.forEach((point, pointIndex) => {
        const span = this.getSpan(side);

        if (!span) {
          return;
        }

        span.active = span.isSystemSet ? false : true;

        if (
          (state.backWall && side === greenHouseConst.side.Back)
        ) {
          span.active = false;
          span.isSystemSet = false;
          span.systems.forEach((system) => {
            if (!system) return;
            system.active = false;
            if (system.object) this.changeObjectVisibility(false, system.object);
          });
        }

        if (!span.isLocked && !span.isSystemSet) {
          span.isSystemSet = false;
          span.systems.forEach((system) => {
            if (!system) return;
            system.active = false;
            if (system.object) this.changeObjectVisibility(false, system.object);
          });
        }

        span.posX = point.x;
        span.posZ = point.z;
        span.width = width;
        span.height = height;

        if (span.systems.length > 0) {
          span.systems.forEach((system) => {
            if (system && system.object) {
              // console.log(span.posX, span.posY, span.posZ);
              system.object.position.set(span.posX, span.posY, span.posZ);
              system.spanWidth = width;
              system.spanHeight = height;
            }
          });
        }

        span.avatar.position.set(span.posX, span.height / 2, span.posZ);
        span.avatar.scale.set(
          side === greenHouseConst.side.Left || side === greenHouseConst.side.Right
            ? thickness
            : width,
          span.height,
          side === greenHouseConst.side.Left || side === greenHouseConst.side.Right
            ? width
            : thickness
        );
        span.avatar.visible = false;

        span.hotspot.position.set(span.posX, -1.0, span.posZ);
        setHotspotVisibility(span.hotspot, false);

        // span.hotspot.setHoverFunction(() => {
        //   this.outlineAvatar(span.avatar, true);
        // });

        span.hotspot.setNormalFunction(() => {
          this.outlineAvatar(span.avatar, false);
        });

        span.hotspot.setClickFunction(() => {
          state.lastSpan = span;
          this.putCurrentMenuSystemToCurrentSpan(span);
          triggerIconClick(state.currentActiveSystems);
        });

      });
    };

    configureSpan(
      front_span_points,
      greenHouseConst.side.Front,
      span_width,
      spanAvatarThickness
    );
    configureSpan(
      back_span_points,
      greenHouseConst.side.Back,
      span_width,
      spanAvatarThickness
    );
    configureSpan(
      left_span_points,
      greenHouseConst.side.Left,
      span_depth,
      spanAvatarThickness
    );
    configureSpan(
      right_span_points,
      greenHouseConst.side.Right,
      span_depth,
      spanAvatarThickness
    );

    this.checkAllSpans();

    // Position roof spans
    {
      const n = buildCopyAmount || 1;
      const halfL = state.length / 2;
      const stepZ = state.length / n;
      const roofY = state.height > 0 ? state.height * 0.95 : 2.2;
      const roofSpans = this.span.objects.filter(s => s.zone === 'roof');
      roofSpans.forEach((span, i) => {
        const moduleIndex = Math.floor(i / 2);
        const x = i % 2 === 0 ? -halfL * 0.5 : halfL * 0.5;
        const z = -halfL + stepZ * moduleIndex + stepZ / 2;
        span.hotspot.position.set(x, roofY, z);
        span.posX = x;
        span.posZ = z;
      });
    }
  }

  checkAllSpans() {
    const spans = this.span.objects;
    spans.forEach((span) => {
      if (!span.isLocked && !span.isSystemSet) {
        span.isSystemSet = false;
        span.systems.forEach((system) => {
          if (!system) return;
          system.active = false;
          if (system.object) this.changeObjectVisibility(false, system.object);
          if (system.windowObject) this.changeObjectVisibility(false, system.windowObject);
        });
      }
    });
  }

  getSpan(side) {
    const spans = this.span.objects;

    for (let i = 0; i < spans.length; i++) {
      const span = spans[i];

      if (span.side === side && !span.isLocked) {
        span.isLocked = true;
        return span;
      }
    }

    return null;
  }

  updateHotspots() {

    this.span.objects.forEach(span => {
      setHotspotVisibility(span.hotspot, false);
    });

    const sides = [greenHouseConst.side.Left, greenHouseConst.side.Right, greenHouseConst.side.Front, greenHouseConst.side.Back];
    const hw = state.width / 2;
    const hl = state.length / 2;

    const _fbSides = [greenHouseConst.side.Front, greenHouseConst.side.Back];
    const _lrSides = [greenHouseConst.side.Left, greenHouseConst.side.Right];
    const _isNarrow = state.width === 1 || state.length === 1;
    const _fbHasSystem = this.span.objects.some(s => _fbSides.includes(s.side) && s.isSystemSet);
    const _lrHasSystem = this.span.objects.some(s => _lrSides.includes(s.side) && s.isSystemSet);

    sides.forEach(side => {
      if (state.backWall && side === greenHouseConst.side.Back) return;

      const sideHasSystem = this.span.objects.some(s => s.side === side && s.isSystemSet);
      const _isFB = _fbSides.includes(side);
      const isBlockedByNarrow = _isNarrow && (_isFB ? _lrHasSystem : _fbHasSystem);
      let firstShown = false;

      this.span.objects.forEach(span => {
        if (span.side === side) {
          if (!firstShown && !sideHasSystem && !isBlockedByNarrow && state.currentActiveSystems !== null) {
            const centerX = side === greenHouseConst.side.Left ? -hw
              : side === greenHouseConst.side.Right ? hw
                : 0;
            const centerZ = side === greenHouseConst.side.Front ? hl
              : side === greenHouseConst.side.Back ? -hl
                : 0;

            span.hotspot.position.set(centerX, -1.0, centerZ);
            setHotspotVisibility(span.hotspot, true);

            const self = this;
            span.hotspot.setClickFunction(() => {
              state.lastSpan = span;
              self.putCurrentMenuSystemToCurrentSpan(span);
              triggerIconClick(state.currentActiveSystems);
            });

            firstShown = true;
          }
        }
      });
    });
  }

  async update() {

    if (state.heaters && window.updateHeaterVisibility) {
      window.updateHeaterVisibility(true);
    }

    this.setOptions();

    if (state.width < 1 && this.span.objects.some(s => s.isSystemSet)) {
      removeAllSubsystems();
    }

    if (state.width === 1 || state.length === 1) {
      const _fbSides = [greenHouseConst.side.Front, greenHouseConst.side.Back];
      const _lrSides = [greenHouseConst.side.Left, greenHouseConst.side.Right];
      const _fbHas = this.span.objects.some(s => _fbSides.includes(s.side) && s.isSystemSet);
      const _lrHas = this.span.objects.some(s => _lrSides.includes(s.side) && s.isSystemSet);
      if (_fbHas && _lrHas) removeAllSubsystems();
    }

    const savedSystems = [];
    this.span.objects.forEach((span) => {
      if (span.isSystemSet) {
        savedSystems.push({
          side: span.side,
          activeType: span.activeaccessoriesType,
          isSystemSet: true,
          isLocked: true
        });
      }
    });

    this.setSpans();

    savedSystems.forEach((saved) => {
      if (state.backWall && saved.side === greenHouseConst.side.Back) return;

      const span = this.span.objects.find((s) => s.side === saved.side);
      if (!span) return;

      span.isSystemSet = true;
      span.isLocked = true;
      span.activeaccessoriesType = saved.activeType;
    });

    this.updateHotspots();
    WriteURLParameters();

    requestDelayedRender();
  }

  reset() {
    //this.changeDimensions(8, 8);
  }

  rgbToHex(rgb) {
    // Перевірка на формат rgb або rgba
    var result = rgb.match(/^rgba?\((\d+), (\d+), (\d+)(?:, (\d+\.?\d*))?\)$/);

    if (result) {
      var r = parseInt(result[1]);
      var g = parseInt(result[2]);
      var b = parseInt(result[3]);

      // Перетворення значень RGB в HEX
      var hex =
        "#" +
        ((1 << 24) | (r << 16) | (g << 8) | b)
          .toString(16)
          .slice(1)
          .toUpperCase();

      return hex;
    }

    // Якщо значення не підходить, просто повертаємо порожній рядок
    return null;
  }



  getAvaliableExtraLightObject(objects) {
    for (let index = 0; index < objects.length; index++) {
      const element = objects[index];
      if (element.active == true) {
        continue;
      }
      return element;
    }
  }

  getAvaliableObjectFromArray(objects) {
    for (let index = 0; index < objects.length; index++) {
      const element = objects[index];
      if (element.active == true) {
        continue;
      }
      return element;
    }
    return null;
  }


  cloneMaterialTexture(name) {
    if (this.theModel == null) {
      return;
    }
    var mat = null;
    this.theModel.traverse((o) => {
      if (o.isMesh) {
        if (o.material.name == name) {
          mat = o.material;
          if (mat.map != null) {
            mat.map = mat.map.clone();
          }
        }
      }
    });
  }

  changeMaterialTilling(name, x, y) {
    if (this.theModel == null) {
      return;
    }
    var mat = null;
    this.theModel.traverse((o) => {
      if (o.isMesh) {
        if (o.material.name == name) {
          mat = o.material;
          if (mat.map != null) {
            mat.map.repeat.set(x, y);
          }
        }
      }
    });
  }

  changeMaterialOffset(name, x, y) {
    if (this.theModel == null) {
      return;
    }
    var mat = null;
    this.theModel.traverse((o) => {
      if (o.isMesh) {
        if (o.material.name == name) {
          mat = o.material;
          if (mat.map != null) {
            mat.map.offset.set(x, y);
          }
        }
      }
    });
  }

  changeExtraOptions() {
    const fanObjects = this.extraOptions.elements.filter(
      (item) => item.type == PergolaExtraOptionType.fan
    );
    const heaterObjects = this.extraOptions.elements.filter(
      (item) => item.type == PergolaExtraOptionType.heater
    );
    const fanBeams = this.roof.beams.filter((item) => item.isFanBeam === true);
    const lightObjects = this.extraOptions.elements.filter(
      (item) => item.type == PergolaExtraOptionType.light
    );
    const ledObjects = this.extraOptions.elements.filter(
      (item) => item.type == PergolaExtraOptionType.led
    );
    const moodLightObjects = this.extraOptions.elements.filter(
      (item) => item.type == PergolaExtraOptionType.moodLight
    );
    const moodLedsObjects = this.extraOptions.elements.filter(
      (item) => item.type == PergolaExtraOptionType.moodLed
    );

    this.changeObjectArrayVisibility(false, fanObjects);
    this.changeObjectArrayVisibility(false, heaterObjects);
    this.changeObjectArrayVisibility(false, fanBeams);
    this.changeObjectArrayVisibility(false, ledObjects);
    this.changeObjectArrayVisibility(false, moodLedsObjects);
    this.changeObjectArrayVisibility(false, lightObjects);

    //! HEATERS
    if (this.settings.extraOptionHeaters) {
      const { FL_point, FR_point, RL_point, RR_point } = this.getCornerPoints();
      const heaterOffset = 0.2;
      const heaterHight = this.totalHeight - 0.3;

      FL_point.x += heaterOffset;
      FL_point.y = heaterHight;
      FL_point.z -= heaterOffset;
      FR_point.x -= heaterOffset;
      FR_point.y = heaterHight;
      FR_point.z -= heaterOffset;
      RL_point.x += heaterOffset;
      RL_point.y = heaterHight;
      RL_point.z += heaterOffset;
      RR_point.x -= heaterOffset;
      RR_point.y = heaterHight;
      RR_point.z += heaterOffset;

      let leftPoints = [];
      let rightPoints = [];
      let frontPoints = [];
      let rearPoints = [];

      if (this.dimensions.length > this.settings.postLengthInterval) {
        leftPoints = generateMidpoints(FL_point, RL_point, 3, false);
        rightPoints = generateMidpoints(FR_point, RR_point, 3, false);
        leftPoints.splice(1, 1);
        rightPoints.splice(1, 1);
      } else {
        leftPoints = generateMidpoints(FL_point, RL_point, 1, false);
        rightPoints = generateMidpoints(FR_point, RR_point, 1, false);
      }

      if (this.dimensions.width > this.settings.postWidthInterval) {
        frontPoints = generateMidpoints(FL_point, FR_point, 3, false);
        rearPoints = generateMidpoints(RL_point, RR_point, 3, false);
        frontPoints.splice(1, 1);
        rearPoints.splice(1, 1);
      } else {
        frontPoints = generateMidpoints(FL_point, FR_point, 1, false);
        rearPoints = generateMidpoints(RL_point, RR_point, 1, false);
      }

      function setHeaters(points, rotationAngle) {
        points.forEach((point) => {
          const heater = this.getAvaliableObjectFromArray(heaterObjects);
          heater.object.position.set(point.x, point.y, point.z);
          heater.object.rotation.y = THREE.MathUtils.degToRad(rotationAngle);
          this.changeObjectVisibility(true, heater.object);
          heater.active = true;
        });
      }

      setHeaters.call(this, leftPoints, 90);
      setHeaters.call(this, rightPoints, -90);
      setHeaters.call(this, frontPoints, 180);
      setHeaters.call(this, rearPoints, 0);

      // this.lastSettings.extraOptionLight = this.settings.extraOptionLight;
    }

    //! LED STRIPS
    if (this.settings.extraOptionLed) {
      for (let index = 0; index < framesPoints.length; index++) {
        const point = framesPoints[index];
        const ledStrip = this.getAvaliableObjectFromArray(ledObjects);
        // console.log("🚀 ~ ledStrip:", ledStrip);
        ledStrip.object.position.x = point.x;
        ledStrip.object.position.z = point.z;
        this.changeObjectVisibility(true, ledStrip.object);
        ledStrip.active = true;
      }
    }

    //! POINTLIGHTS
    if (this.settings.extraOptionLight) {
      const minLightQty = this.getPointLightpositions(8).length;
      const maxLightQty = this.getPointLightpositions(2).length;

      const lightGap = this.settings.extraOptionLightSpacing;

      const lightPoints = this.getPointLightpositions(lightGap);
      const pointY = 2.185;

      for (let i = 0; i < lightPoints.length; i++) {
        const element = lightObjects[i];
        const light = element.object;
        light.position.set(lightPoints[i].x, pointY, lightPoints[i].z);
        // light.children[1].material.emissiveIntensity = 3;
        element.active = true;
        this.changeObjectVisibility(true, light);
      }

      this.lastSettings.extraOptionFan = this.settings.extraOptionFan;
    }
  }


  getSystem(name = null, type = null, direction = null, side = null) {
    if (!this.system?.objects) return;
    return this.system.objects.find(el =>
      (name == null || el.name === name) &&
      (type == null || el.type === type) &&
      (direction == null || el.direction === direction) &&
      (side == null || el.side === side)
    );
  }

  static getAccessoryData(key) {
    for (const section of ACCESSORIES_DATA) {
      const item = section.items.find(i => i.key === key);
      if (item) return item;
    }
    return null;
  }

  placeAccessory(accessoryKey, zone, spanIndex, { permanent = false } = {}) {
    const item = PergolaObject.getAccessoryData(accessoryKey);
    if (!item) return null;

    // roof: even spanIndex = left slope, odd = right slope
    const roofSlope = zone === 'roof'
      ? (spanIndex % 2 === 0 ? 'left' : 'right')
      : null;

    if (!this.placedAccessories) this.placedAccessories = new Map();
    const placeKey = `${accessoryKey}__${zone}__${spanIndex}`;

    if (this.placedAccessories.has(placeKey)) {
      // Toggle off — remove placement
      this.placedAccessories.delete(placeKey);
      this.applyAccessoryMeshVisibility(item, zone, spanIndex, false, roofSlope);
      // Remove from persisted state
      state.accessoryPlacements = (state.accessoryPlacements || []).filter(
        p => !(p.key === accessoryKey && p.zone === zone && p.span === spanIndex)
      );
      return null;
    }

    const entry = { accessoryKey, item, zone, spanIndex, roofSlope, permanent };
    this.placedAccessories.set(placeKey, entry);
    this.applyAccessoryMeshVisibility(item, zone, spanIndex, true, roofSlope);
    // Only persist user-initiated (non-permanent) placements for URL encoding
    if (!permanent) {
      state.accessoryPlacements = [
        ...(state.accessoryPlacements || []).filter(
          p => !(p.key === accessoryKey && p.zone === zone && p.span === spanIndex)
        ),
        { key: accessoryKey, zone, span: spanIndex, slope: roofSlope ?? null },
      ];
      window.dispatchEvent(new CustomEvent('accessoryPlaced', { detail: { key: accessoryKey, zone, spanIndex } }));
    }
    return entry;
  }

  // `name`, sorted by world Z ascending. Clones share the same name — sorted so index 0 = back, last = front.
  getAllByName(name) {
    const results = [];
    if (!theModel) return results;
    theModel.traverse(o => { if (o.name === name) results.push(o); });
    results.sort((a, b) => {
      const wa = new THREE.Vector3(); a.getWorldPosition(wa);
      const wb = new THREE.Vector3(); b.getWorldPosition(wb);
      return wa.z - wb.z;
    });
    return results;
  }

  // roofSlope: 'left' | 'right' | null
  applyAccessoryMeshVisibility(item, zone, spanIndex, visible, roofSlope = null) {
    if (!theModel) return;

    // module that was clicked
    const moduleIndex = zone === 'roof' ? Math.floor(spanIndex / 2) : spanIndex;

    const setVis = (name, show) => {
      const list = this.getAllByName(name);
      const target = list[moduleIndex] ?? list[0];
      if (!target) { console.warn(`[acc] mesh not found: "${name}"`); return; }
      target.visible = show;
      target.traverse(c => { c.visible = show; });
    };

    const placeWindowAtSlot = (templateName, refName, tag) => {
      const existing = [];
      scene.traverse(o => { if (o.userData?.accTag === tag) existing.push(o); });
      existing.forEach(o => o.parent?.remove(o));

      if (!visible) return;

      const template = this.getAllByName(templateName)[0];
      const refList = this.getAllByName(refName);
      const ref = refList[moduleIndex] ?? refList[0];
      if (!template || !ref) { console.warn(`[acc] missing template="${templateName}" or ref="${refName}"`); return; }

      const clone = template.clone(true);
      clone.userData.accTag = tag;

      // match world position/rotation/scale of the reference slot
      const refWorld = new THREE.Vector3();
      const refQuat = new THREE.Quaternion();
      const refScale = new THREE.Vector3();
      ref.matrixWorld.decompose(refWorld, refQuat, refScale);

      // Add to same parent as template so local→world math stays simple
      const parent = template.parent ?? theModel;
      parent.add(clone);

      // Convert world transform to parent-local
      const parentWorldInv = new THREE.Matrix4().copy(parent.matrixWorld).invert();
      const localPos = refWorld.clone().applyMatrix4(parentWorldInv);

      // Keep template's local rotation/scale; just replacing position Z to match slot
      clone.position.copy(template.position);
      clone.position.z = localPos.z;
      clone.rotation.copy(template.rotation);
      clone.scale.copy(template.scale);

      clone.visible = true;
      clone.traverse(c => { c.visible = true; });
    };

    // accessories cloned from tables.glb
    if (ORG_KEYS.has(item.key)) {
      this.applyOrgItemMesh(item, zone, spanIndex, visible);
      return;
    }

    // cloned from own GLTF file
    if (HEATER_KEYS.has(item.key)) {
      this.applyHeaterMesh(item, zone, spanIndex, visible);
      return;
    }

    switch (item.key) {
      case 'extraDoor': {
        // XH models: side walls use dedicated side door meshes
        const XH_SIDE_CODES = new Set(['R306XH', 'R308XH']);
        if (XH_SIDE_CODES.has(getCurrentSizeCode()) && (zone === 'wallLeft' || zone === 'wallRight')) {
          // L/R names are physically swapped vs zone (consistent with extraDoubleDoor and mosquito code)
          const meshName = zone === 'wallLeft' ? 'side_door_R' : 'side_door_L';
          const sideDoor = theModel?.getObjectByName(meshName);
          if (!sideDoor) { requestDelayedRender(); break; }
          const wallGlassName = zone === 'wallLeft' ? 'w_L_G' : 'w_R_G';
          const wallGlassList = this.getAllByName(wallGlassName);
          const wallGlassSlot = wallGlassList[spanIndex] ?? wallGlassList[0];
          if (visible) {
            if (wallGlassSlot) {
              wallGlassSlot.visible = false;
              wallGlassSlot.traverse(c => { c.visible = false; });
            }
            const params = getActiveBuildParams();
            const zOffset = zone === 'wallLeft'
              ? (params.sideDoorZOffsetLeft ?? 0)
              : (params.sideDoorZOffset ?? 0);
            {
              theModel.updateMatrixWorld(true);
              const hw = buildModelHalfW || state.width / 2;
              const origParent = sideDoor.parent;

              // Compute target Z from glass slot world position or span fallback
              const glassWorldPos = new THREE.Vector3();
              if (wallGlassSlot) {
                wallGlassSlot.getWorldPosition(glassWorldPos);
              } else {
                const n = buildCopyAmount || 3;
                const step = buildStepSize || (state.length / n);
                theModel.localToWorld(glassWorldPos.set(0, 0, buildGeomFrameZ + step * spanIndex + step / 2));
              }

              // Save authored parent-local rotation.y once (before any modification)
              if (sideDoor.userData.xhOrigRotY === undefined) {
                sideDoor.userData.xhOrigRotY = sideDoor.rotation.y;
              }
              const origRotY = sideDoor.userData.xhOrigRotY;

              if (origParent) {
                // Use scene.attach so position/rotation are in world space.
                // Use rotation.y flip (not scale.x) to avoid reversing face winding.
                scene.attach(sideDoor);
                sideDoor.position.z = glassWorldPos.z;
                if (zone === 'wallRight') {
                  sideDoor.position.x = hw;
                  sideDoor.rotation.y = origRotY + Math.PI;
                } else {
                  sideDoor.position.x = -hw;
                  sideDoor.rotation.y = origRotY;
                }
                origParent.attach(sideDoor);
                sideDoor.position.z += zOffset; // apply span offset in parent-local space
              } else {
                const localPos = theModel.worldToLocal(glassWorldPos.clone());
                sideDoor.position.z = localPos.z + zOffset;
              }
            }
            sideDoor.visible = true;
            sideDoor.traverse(o => { o.visible = true; });
            sideDoor.traverse(o => {
              if (o.name.includes('mosquito')) o.visible = false;
            });
            {
              const suffix = meshName.replace('side_door_', ''); // 'L' or 'R'
              const doorPanel = sideDoor.getObjectByName(`door_${suffix}`);
              const doorLogo = sideDoor.getObjectByName(`door_logo_${suffix}`);
              if (doorPanel && doorLogo && doorLogo.parent !== doorPanel) {
                doorPanel.attach(doorLogo);
                doorLogo.userData.restPos = doorLogo.position.clone();
                doorLogo.userData.restQuat = doorLogo.quaternion.clone();
                doorLogo.userData.restScale = doorLogo.scale.clone();
              }
            }
          } else {
            if (wallGlassSlot) {
              wallGlassSlot.visible = true;
              wallGlassSlot.traverse(c => { c.visible = true; });
            }
            // Restore rotation.y before hiding so re-placement on left wall is clean
            if (zone === 'wallRight' && sideDoor.userData.xhOrigRotY !== undefined && sideDoor.parent) {
              const prevParent = sideDoor.parent;
              scene.attach(sideDoor);
              sideDoor.rotation.y = sideDoor.userData.xhOrigRotY;
              prevParent.attach(sideDoor);
            }
            sideDoor.visible = false;
            sideDoor.traverse(o => { if (o.isMesh) o.visible = false; });
            const doubleMeshName = zone === 'wallLeft' ? 'side_door_double_R' : 'side_door_double_L';
            const sideDouble = theModel?.getObjectByName(doubleMeshName);
            if (sideDouble) sideDouble.traverse(o => { if (o.isMesh) o.visible = false; });
          }
          requestDelayedRender();
          break;
        }

        // XH models: back wall uses back_door_wall group (contains back_door mesh + glass siblings)
        const XH_BACK_WALL_CODES = new Set(['R306XH', 'R308XH']);
        if (XH_BACK_WALL_CODES.has(getCurrentSizeCode()) && zone === 'wallBack') {
          const backDoorWall = theModel?.getObjectByName('back_door_wall');
          if (!backDoorWall) { requestDelayedRender(); break; }
          const backDoor = backDoorWall.getObjectByName('back_door');
          if (visible) {
            if (backDoor) {
              // Stop any active mixer animations on back_door so they don't override position reset
              const propRe = /\.(position|quaternion|scale)$/;
              const bdNames = new Set();
              backDoor.traverse(o => { if (o.name) bdNames.add(o.name); });
              (window._meshClickMixers ?? []).forEach(m => {
                m._actions?.slice().forEach(a => {
                  const clip = a._clip;
                  if (clip?.tracks?.some(t => bdNames.has(t.name.replace(propRe, '')))) a.stop();
                });
              });

              if (backDoor.userData.restPos) backDoor.position.copy(backDoor.userData.restPos);
              if (backDoor.userData.restQuat) backDoor.quaternion.copy(backDoor.userData.restQuat);
            }
            // Solving for parent X so that door world X = buildBackWallX:
            const closedLocalZ = backDoor?.userData.restPos?.z ?? backDoor?.position.z ?? 0;
            // Position back_door_wall: apply the same X delta that placeBackWall applied to the ref back wall
            const xhRefGroup = theModel?.getObjectByName('back_wall') ?? theModel?.getObjectByName('back_wall_door');
            const xhRefOriginX = xhRefGroup?.userData.originX ?? buildBackWallX;
            const xhBdwOriginX = backDoorWall.userData.originX ?? buildBackWallX;
            backDoorWall.position.x = xhBdwOriginX + (buildBackWallX - xhRefOriginX) + (getActiveBuildParams().backDoorWallXOffset ?? 0);
            backDoorWall.position.z = buildBackWallZ;
            backDoorWall.rotation.set(0, Math.PI / 2, 0);
            if (backDoor) {
              // Hide glass/wall siblings — keep frame and logo, hide only the plain glass panel
              const backDoorLogo = backDoorWall.getObjectByName('back_door_logo');
              const meshFrameBack = backDoorWall.getObjectByName('mesh_frame_back');
              backDoorWall.children.forEach(child => {
                const keep = child === backDoor
                  || child === meshFrameBack
                  || child.name.includes('mosquito');
                if (!keep) child.traverse(o => { if (o.isMesh) o.visible = false; });
              });
              // Show door, frame, logo — hide mosquito net
              backDoor.visible = true;
              backDoor.traverse(o => { o.visible = true; });
              backDoor.traverse(o => { if (o.name.includes('mosquito')) o.visible = false; });
              if (meshFrameBack) {
                meshFrameBack.visible = true;
                meshFrameBack.traverse(o => { if (o.isMesh) o.visible = true; });
              }
              if (backDoorLogo) {
                backDoorLogo.visible = true;
                backDoorLogo.traverse(o => { if (o.isMesh) o.visible = true; });
              }
              // Apply the last-chosen opening side immediately on placement
              this.applyBackDoorSide(window._backDoorSide ?? 'left');
            }
          } else {
            // Reset scale flip when hiding so next placement starts at default
            if (backDoorWall.userData.origScaleZ !== undefined) {
              backDoorWall.scale.z = backDoorWall.userData.origScaleZ;
            }
            if (backDoor) {
              backDoor.visible = false;
              backDoor.traverse(o => { if (o.isMesh) o.visible = false; });
            }
            // Restore glass panel siblings; keep door-only elements hidden
            const KEEP_HIDDEN = new Set(['back_door', 'back_door_logo', 'mesh_frame_back']);
            backDoorWall.children.forEach(child => {
              if (child.name.includes('mosquito') || KEEP_HIDDEN.has(child.name)) {
                child.visible = false;
                child.traverse(o => { if (o.isMesh) o.visible = false; });
              } else {
                child.visible = true;
                child.traverse(o => { if (o.isMesh) o.visible = true; });
              }
            });
          }
          requestDelayedRender();
          break;
        }

        const backDoor = theModel?.getObjectByName('back_wall_door') ?? theModel?.getObjectByName('back_wall_doors');
        const solidBack = theModel?.getObjectByName('back_wall');
        if (!backDoor) { requestDelayedRender(); break; }

        // Double-door mesh name depends on model
        const XH_BACK_CODES = new Set(['R306XH', 'R308XH']);
        const doubleDoorMeshName = XH_BACK_CODES.has(getCurrentSizeCode()) ? 'back_wall_double_door' : 'back_wall_double';
        const doubleDoorMesh = theModel?.getObjectByName(doubleDoorMeshName);

        // Check if a DIFFERENT back-wall extraDoor is already recorded (not the one being placed now)
        const placed = this.placedAccessories ?? new Map();
        const currentKey = `extraDoor__wallBack__${spanIndex}`;
        const backDoorAlreadyPlaced = [...placed.keys()].some(k => k.startsWith('extraDoor__wallBack__') && k !== currentKey);

        const BACK_HIDDEN = new Set(['mesh_frame_back', 'door_mosquito_back']);
        if (visible) {
          if (zone === 'wallBack' && backDoorAlreadyPlaced && doubleDoorMesh) {
            // Second back door: swap to the double-door mesh
            {
              const bp2 = getActiveBuildParams();
              const bdblRot = bp2.backDoubleDoorRot;
              if (Array.isArray(bdblRot)) doubleDoorMesh.rotation.set(bdblRot[0], bdblRot[1], bdblRot[2]);
              if (solidBack) {
                doubleDoorMesh.position.z = solidBack.position.z;
                doubleDoorMesh.position.x = bp2.backDoorX ?? solidBack.position.x;
              }
            }
            doubleDoorMesh.traverse(o => { if (o.isMesh) o.visible = true; });
            if (solidBack) solidBack.traverse(o => { if (o.isMesh) o.visible = false; });
            backDoor.visible = false;
            backDoor.traverse(o => { if (o.isMesh) o.visible = false; });
          } else {
            // First back door (or non-back zone): existing single-door logic
            let bdp = backDoor.parent;
            while (bdp && bdp !== theModel) { bdp.position.x = 0; bdp = bdp.parent; }
            backDoor.position.z = buildBackWallZ;
            {
              const SPAN_BASED_CODES = new Set(['S206H', 'S208H']);
              const bp2 = getActiveBuildParams();
              const solidBackX = solidBack?.position.x ?? buildBackWallX;
              const baseX = bp2.backDoorX ?? solidBackX;
              const doorX = SPAN_BASED_CODES.has(getCurrentSizeCode())
                ? (spanIndex === 0 ? baseX : -baseX)
                : baseX;
              backDoor.position.x = doorX;
              backDoor.userData.spanX = doorX;
            }
            const bdRot = getActiveBuildParams().backDoorRot;
            if (bdRot !== null) {
              const r = bdRot ?? [0, Math.PI / 2, 0];
              backDoor.rotation.set(r[0], r[1], r[2]);
            }
            if (!backDoor.userData.originQuat) {
              backDoor.userData.originQuat = backDoor.quaternion.clone();
              backDoor.userData.originPos = backDoor.position.clone();
            }
            backDoor.visible = true;
            backDoor.traverse(o => { if (o.isMesh) o.visible = !BACK_HIDDEN.has(o.name) && !o.name.includes('logo'); });
            // Suppress mosquito subtrees — covers both 'door_mosquito_back' (R200H) and 'door_mosquito.001' (S100H)
            backDoor.traverse(o => {
              if (o.name.includes('mosquito')) { o.visible = false; o.traverse(c => { c.visible = false; }); }
            });
            // back_door is an Object3D (non-mesh) wrapper hidden by DOOR_HIDDEN_NAMES at init;
            // the isMesh traverse above skips it, so restore it explicitly here.
            const innerDoor = backDoor.getObjectByName('back_door');
            if (innerDoor) innerDoor.visible = true;
            // S100H (back_wall_doors): line 3952 hides logo meshes — restore door_logo001 explicitly
            // (Three.js strips the dot from Blender's .001 suffix → "door_logo001" not "door_logo.001")
            if (backDoor.name === 'back_wall_doors') {
              const logoMesh = backDoor.getObjectByName('door_logo001');
              if (logoMesh) logoMesh.visible = true;
            }
            // Store solidBack mesh visibility before hiding so removal can restore exact previous state
            if (solidBack) solidBack.traverse(o => { if (o.isMesh) { o.userData.preExtraDoorVisible = o.visible; o.visible = false; } });
            const leftBackLogo = theModel.getObjectByName('door_mosquito_back_logo');
            const rightBackLogo = theModel.getObjectByName('back_door_logo');
            [leftBackLogo, rightBackLogo].forEach(logo => {
              if (logo && logo.parent !== theModel) {
                theModel.attach(logo);
                // Only record rest position on first attach (when logo is at its GLTF position
                // with door at spanX). Re-captures after applyBackDoorSide would store the
                // already-corrected position, causing xDelta to double-correct on next call.
                if (!logo.userData.restModelPos) {
                  logo.userData.restModelPos = logo.position.clone();
                  logo.userData.restModelQuat = logo.quaternion.clone();
                  // Save backDoor scale.z at capture time — needed to restore it correctly
                  // when computing worldToLocal in applyBackDoorSide (scale.z may differ there).
                  logo.userData.restBackDoorScaleZ = backDoor.scale.z;
                }
              }
            });
            pergola.applyBackDoorSide(window._backDoorSide ?? 'left');
          }
        } else {
          // Removing: always hide double door first
          if (doubleDoorMesh) doubleDoorMesh.traverse(o => { if (o.isMesh) o.visible = false; });
          backDoor.visible = false;
          backDoor.traverse(o => { if (o.isMesh) o.visible = false; });
          const leftBackLogo = theModel.getObjectByName('door_mosquito_back_logo');
          const rightBackLogo = theModel.getObjectByName('back_door_logo');
          if (leftBackLogo) { leftBackLogo.visible = false; leftBackLogo.traverse(o => { o.visible = false; }); }
          if (rightBackLogo) { rightBackLogo.visible = false; rightBackLogo.traverse(o => { o.visible = false; }); }
          // Restore solidBack to its state before extraDoor was placed (avoids un-hiding unrelated meshes)
          if (solidBack) solidBack.traverse(o => {
            if (o.isMesh) o.visible = o.userData.preExtraDoorVisible ?? true;
          });
        }
        requestDelayedRender();
        break;
      }

      case 'extraDoubleDoor': {
        const frontWall = theModel?.getObjectByName('front_wall');
        const frontDouble = theModel?.getObjectByName('front_wall_double');
        const frontLogoLeft = theModel?.getObjectByName('door_mosquito_logo');
        const frontLogoRight = theModel?.getObjectByName('door_logo');

        const backWall = theModel?.getObjectByName('back_wall');
        const backDouble = theModel?.getObjectByName('back_wall_double');
        const backLogoLeft = theModel?.getObjectByName('door_mosquito_back_logo');
        const backLogoRight = theModel?.getObjectByName('back_door_logo');

        const rightDoubleDoor = theModel?.getObjectByName('side_door_double_R');
        const leftDouble = theModel?.getObjectByName('side_door_double_L');

        const hideLogo = (logo) => {
          if (!logo) return;
          logo.visible = false;
          logo.traverse(o => { o.visible = false; });
        };
        const showLogo = (logo) => {
          if (!logo) return;
          logo.visible = true;
          logo.traverse(o => { o.visible = true; });
        };

        const FRONT_LOGO_PANEL_PAIRS = [
          { logo: 'door1_F_logo', panel: 'door1_F' },
          { logo: 'door2_F_logo', panel: 'door2_F' },
          { logo: 'door_1_double_logo', panel: 'door_1_double' },
          { logo: 'door_2_double_logo', panel: 'door_2_double' },
        ];
        const BACK_LOGO_PANEL_PAIRS = [
          { logo: 'door1_F_back_logo', panel: 'door1_F_back' },
          { logo: 'door2_F_back_logo', panel: 'door2_F_back', scaleX: -1 },
        ];

        const LEFT_LOGO_PANEL_PAIRS = [
          { logo: 'door_1_double_logo_L', panel: 'door_1_double_L' },
          { logo: 'door_2_double_logo_L', panel: 'door_2_double_L' },
        ];

        const RIGHT_LOGO_PANEL_PAIRS = [
          { logo: 'door_1_double_logo_R', panel: 'door_1_double_R' },
          { logo: 'door_2_double_logo_R', panel: 'door_2_double_R' },
        ];

        const attachLogosToPanel = (pairs) => {
          pairs.forEach(({ logo: logoName, panel: panelName, scaleX = 1 }) => {
            const logo = theModel?.getObjectByName(logoName);
            const panel = theModel?.getObjectByName(panelName);
            if (!logo || !panel) return;
            if (logo.parent !== panel) {
              // attach() preserves world position/rotation/scale when reparenting
              theModel.updateWorldMatrix(true, true);
              panel.attach(logo);
            }
            if (scaleX !== 1) logo.scale.x = scaleX;
            logo.userData.restPos = logo.position.clone();
            logo.userData.restQuat = logo.quaternion.clone();
            logo.userData.restScale = logo.scale.clone();
            showLogo(logo);
          });
        };

        // Detach logos back to the double-door group and hide them
        const detachLogosFromPanel = (pairs, group) => {
          pairs.forEach(({ logo: logoName }) => {
            const logo = theModel?.getObjectByName(logoName);
            if (!logo || !group) return;
            if (logo.parent !== group) group.attach(logo);
            hideLogo(logo);
          });
        };

        if (zone === 'wallBack') {
          const XH_DBL_BACK_CODES = new Set(['R306XH', 'R308XH']);
          if (XH_DBL_BACK_CODES.has(getCurrentSizeCode())) {
            // XH: back_wall_double_door replaces back_door_wall (which holds back_door)
            const backDblDoor = theModel?.getObjectByName('back_wall_double_door');
            if (!backDblDoor) break;
            const backDoorWall = theModel?.getObjectByName('back_door_wall');
            const XH_BACK_DOUBLE_LOGO_PAIRS = [
              { logo: 'door_1_back_logo', panel: 'door_1_back' },
              { logo: 'door_2_back_logo', panel: 'door_2_back' },
            ];
            if (visible) {
              if (backWall) backWall.traverse(o => { if (o.isMesh) o.visible = false; });
              if (backDoorWall) {
                backDblDoor.position.copy(backDoorWall.position);
                backDblDoor.rotation.copy(backDoorWall.rotation);
                backDoorWall.visible = false;
                backDoorWall.traverse(o => { if (o.isMesh) o.visible = false; });
              }
              backDblDoor.visible = true;
              backDblDoor.traverse(o => { if (o.isMesh) o.visible = true; });
              attachLogosToPanel(XH_BACK_DOUBLE_LOGO_PAIRS);
            } else {
              detachLogosFromPanel(XH_BACK_DOUBLE_LOGO_PAIRS, backDblDoor);
              backDblDoor.visible = false;
              backDblDoor.traverse(o => { if (o.isMesh) o.visible = false; });
              if (backDoorWall) {
                backDoorWall.visible = true;
                const xhBackDoor = backDoorWall.getObjectByName('back_door');
                const xhBackDoorLogo = backDoorWall.getObjectByName('back_door_logo');
                const xhMeshFrameBack = backDoorWall.getObjectByName('mesh_frame_back');
                const placedMap = this.placedAccessories ?? new Map();
                const extraDoorOnBack = [...placedMap.values()].some(e => e.accessoryKey === 'extraDoor' && e.zone === 'wallBack');
                if (extraDoorOnBack) {
                  if (backWall) backWall.traverse(o => { if (o.isMesh) o.visible = true; });
                  if (xhBackDoor) { xhBackDoor.visible = true; xhBackDoor.traverse(o => { o.visible = true; }); }
                  if (xhMeshFrameBack) { xhMeshFrameBack.visible = true; xhMeshFrameBack.traverse(o => { if (o.isMesh) o.visible = true; }); }
                  if (xhBackDoorLogo) { xhBackDoorLogo.visible = true; xhBackDoorLogo.traverse(o => { if (o.isMesh) o.visible = true; }); }
                  const KEEP_SHOWN = new Set(['back_door', 'back_door_logo', 'mesh_frame_back']);
                  backDoorWall.children.forEach(child => {
                    if (!KEEP_SHOWN.has(child.name) && !child.name.includes('mosquito')) {
                      child.traverse(o => { if (o.isMesh) o.visible = false; });
                    }
                  });
                  if (xhBackDoor) xhBackDoor.traverse(o => { if (o.name.includes('mosquito')) o.visible = false; });
                } else {
                  const KEEP_HIDDEN = new Set(['back_door', 'back_door_logo', 'mesh_frame_back']);
                  backDoorWall.children.forEach(child => {
                    if (child.name.includes('mosquito') || KEEP_HIDDEN.has(child.name)) {
                      child.visible = false;
                      child.traverse(o => { if (o.isMesh) o.visible = false; });
                    } else {
                      child.visible = true;
                      child.traverse(o => { if (o.isMesh) o.visible = true; });
                    }
                  });
                  if (backWall) backWall.traverse(o => { if (o.isMesh) o.visible = true; });
                }
              }
            }
            break;
          }

          // Back wall double door (non-XH R300H): back_wall_double replaces back_wall_door
          if (backDouble) {
            const backDoor = theModel?.getObjectByName('back_wall_door');
            if (visible) {
              const bdblRot = getActiveBuildParams().backDoubleDoorRot;
              if (Array.isArray(bdblRot)) backDouble.rotation.set(bdblRot[0], bdblRot[1], bdblRot[2]);
              if (backWall) {
                const bp2 = getActiveBuildParams();
                backDouble.position.z = backWall.position.z;
                backDouble.position.x = bp2.backDoorX ?? backWall.position.x;
              }
              backDouble.traverse(o => { if (o.isMesh) o.visible = true; });
              if (backDoor) { backDoor.visible = false; backDoor.traverse(o => { if (o.isMesh) o.visible = false; }); }
              if (backWall) backWall.traverse(o => { if (o.isMesh) o.visible = false; });
              hideLogo(backLogoLeft);
              hideLogo(backLogoRight);
              attachLogosToPanel(BACK_LOGO_PANEL_PAIRS);
            } else {
              detachLogosFromPanel(BACK_LOGO_PANEL_PAIRS, backDouble);
              backDouble.traverse(o => { if (o.isMesh) o.visible = false; });
              const placedMap = this.placedAccessories ?? new Map();
              const extraDoorOnBack = [...placedMap.values()].some(e => e.accessoryKey === 'extraDoor' && e.zone === 'wallBack');
              if (backDoor && extraDoorOnBack) {
                backDoor.visible = true;
                backDoor.traverse(o => { if (o.isMesh) o.visible = true; });
              } else if (backWall) {
                backWall.traverse(o => { if (o.isMesh) o.visible = true; });
              }
              const side = window._backDoorSide ?? 'left';
              if (side === 'left') { showLogo(backLogoLeft); hideLogo(backLogoRight); }
              else { showLogo(backLogoRight); hideLogo(backLogoLeft); }
            }
          }
        } else if (zone === 'wallFront') {
          if (frontDouble) {
            if (visible) {
              if (frontWall) frontWall.traverse(o => { if (o.isMesh) o.visible = false; });
              let p = frontDouble.parent;
              while (p && p !== theModel) { p.position.x = 0; p = p.parent; }
              if (frontWall) {
                frontDouble.position.x = getActiveBuildParams().frontWallXRight ?? 0;
                frontDouble.position.z = frontWall.position.z;
              }
              frontDouble.rotation.set(0, -Math.PI / 2, 0);
              frontDouble.traverse(o => { if (o.isMesh) o.visible = true; });
              hideLogo(frontLogoLeft);
              hideLogo(frontLogoRight);
              theModel.updateWorldMatrix(true, true);
              attachLogosToPanel(FRONT_LOGO_PANEL_PAIRS);
            } else {
              detachLogosFromPanel(FRONT_LOGO_PANEL_PAIRS, frontDouble);
              frontDouble.traverse(o => { if (o.isMesh) o.visible = false; });
              if (frontWall) frontWall.traverse(o => { if (o.isMesh) o.visible = true; });
              const side = window._backDoorSide ?? 'left';
              if (side === 'left') { showLogo(frontLogoLeft); hideLogo(frontLogoRight); }
              else { showLogo(frontLogoRight); hideLogo(frontLogoLeft); }
            }
          }
        } else {
          // Side walls (wallLeft / wallRight)
          const XH_DBL_CODES = new Set(['R306XH', 'R308XH']);
          if (XH_DBL_CODES.has(getCurrentSizeCode())) {
            // XH: use dedicated side double-door meshes (L/R names are physically swapped vs zone)
            const doubleMeshName = zone === 'wallLeft' ? 'side_door_double_R' : 'side_door_double_L';
            const singleMeshName = zone === 'wallLeft' ? 'side_door_R' : 'side_door_L';
            const sideDouble = theModel?.getObjectByName(doubleMeshName);
            const sideSingle = theModel?.getObjectByName(singleMeshName);
            const wallGlassNameDbl = zone === 'wallLeft' ? 'w_L_G' : 'w_R_G';
            const wallGlassListDbl = this.getAllByName(wallGlassNameDbl);
            const wallGlassSlotDbl = wallGlassListDbl[spanIndex] ?? wallGlassListDbl[0];
            const xhSideLogoPairs = doubleMeshName === 'side_door_double_R' ? RIGHT_LOGO_PANEL_PAIRS : LEFT_LOGO_PANEL_PAIRS;
            if (sideDouble) {
              if (visible) {
                {
                  theModel.updateMatrixWorld(true);
                  const glassWorldPosDbl = new THREE.Vector3();
                  if (wallGlassSlotDbl) {
                    wallGlassSlotDbl.getWorldPosition(glassWorldPosDbl);
                  } else {
                    const n = buildCopyAmount || 3;
                    const step = buildStepSize || (state.length / n);
                    theModel.localToWorld(glassWorldPosDbl.set(0, 0, buildGeomFrameZ + step * spanIndex + step / 2));
                  }
                  const originalParentDbl = sideDouble.parent;
                  if (originalParentDbl) {
                    scene.attach(sideDouble);
                    sideDouble.position.z = glassWorldPosDbl.z;
                    originalParentDbl.attach(sideDouble);
                  } else {
                    sideDouble.position.z = glassWorldPosDbl.z;
                  }
                }
                if (wallGlassSlotDbl) {
                  wallGlassSlotDbl.visible = false;
                  wallGlassSlotDbl.traverse(c => { c.visible = false; });
                }
                // Don't override position.x or rotation — authored values handle wall side/facing
                sideDouble.traverse(o => { if (o.isMesh) o.visible = true; });
                if (sideSingle) sideSingle.traverse(o => { if (o.isMesh) o.visible = false; });
                attachLogosToPanel(xhSideLogoPairs);
              } else {
                detachLogosFromPanel(xhSideLogoPairs, sideDouble);
                sideDouble.visible = false;
                sideDouble.traverse(o => { if (o.isMesh) o.visible = false; });
                const placedMapSide = this.placedAccessories ?? new Map();
                const singleDoorStillPlaced = [...placedMapSide.values()].some(e => e.accessoryKey === 'extraDoor' && e.zone === zone);
                if (!singleDoorStillPlaced && wallGlassSlotDbl) {
                  wallGlassSlotDbl.visible = true;
                  wallGlassSlotDbl.traverse(c => { c.visible = true; });
                }
                if (sideSingle && singleDoorStillPlaced) {
                  sideSingle.visible = true;
                  sideSingle.traverse(o => { o.visible = true; });
                  sideSingle.traverse(o => { if (o.name.includes('mosquito')) o.visible = false; });
                }
              }
            }
          } else {
            // Non-XH: reposition back_wall_double to side wall
            if (backDouble && backWall) {
              if (visible) {
                const n = buildCopyAmount || 3;
                const step = buildStepSize || (state.length / n);
                const hw = buildModelHalfW || (state.width / 2);
                const lz = buildGeomFrameZ + step * spanIndex + step / 2;
                let p = backDouble.parent;
                while (p && p !== theModel) { p.position.x = 0; p = p.parent; }
                backDouble.position.x = zone === 'wallLeft' ? -hw : hw;
                backDouble.position.z = lz;
                backDouble.rotation.set(0, zone === 'wallLeft' ? Math.PI : 0, 0);
                backDouble.traverse(o => { if (o.isMesh) o.visible = true; });
                backWall.traverse(o => { if (o.isMesh) o.visible = false; });
                hideLogo(backLogoLeft);
                hideLogo(backLogoRight);
                attachLogosToPanel(BACK_LOGO_PANEL_PAIRS);
              } else {
                detachLogosFromPanel(BACK_LOGO_PANEL_PAIRS, backDouble);
                backDouble.traverse(o => { if (o.isMesh) o.visible = false; });
                backWall.traverse(o => { if (o.isMesh) o.visible = true; });
                const side = window._backDoorSide ?? 'left';
                if (side === 'left') { showLogo(backLogoLeft); hideLogo(backLogoRight); }
                else { showLogo(backLogoRight); hideLogo(backLogoLeft); }
              }
            }
          }
        }
        requestDelayedRender();
        break;
      }

      case 'roofWindow': {
        if (roofSlope === 'right') {
          setVis('r_R_G', !visible);
          placeWindowAtSlot('r_R_Win_manual', 'r_R_G', `roofWindow__right__${moduleIndex}`);
        } else if (roofSlope === 'left') {
          setVis('r_L_G', !visible);
          placeWindowAtSlot('r_L_Win_manual', 'r_L_G', `roofWindow__left__${moduleIndex}`);
        }
        requestDelayedRender();
        break;
      }

      case 'automateOpening': {
        if (!roofSlope) break;
        const autoMesh = roofSlope === 'left' ? 'r_L_Win_auto' : 'r_R_Win_auto';
        const refName = roofSlope === 'left' ? 'r_L_G' : 'r_R_G';
        const autoTag = `automateOpening__${roofSlope}__${moduleIndex}`;
        const manualTag = `roofWindow__${roofSlope}__${moduleIndex}`;

        // Hide manual window clone when auto is placed, restore when removed
        scene.traverse(o => {
          if (o.userData?.accTag === manualTag) {
            o.visible = !visible;
            o.traverse(c => { c.visible = !visible; });
          }
        });

        // Clone the auto window mesh and position it at the correct module slot
        placeWindowAtSlot(autoMesh, refName, autoTag);
        requestDelayedRender();
        break;
      }

      case 'mosquitoDoor': {
        // Small codes: mosquito on OPPOSITE side from door opening.
        // Medium codes: mosquito on SAME side as door opening.
        const MEDIUM_CODES = new Set(['R305H', 'R306H', 'R308H', 'S206H', 'S208H']);
        const R300H_CODES = new Set(['R305H', 'R306H', 'R308H']);
        const currentCode = getCurrentSizeCode();
        const isMedium = MEDIUM_CODES.has(currentCode);
        const isR300H = R300H_CODES.has(currentCode);

        if (zone === 'wallFront') {
          const frontWall = theModel?.getObjectByName('front_wall');
          const mosquito = theModel?.getObjectByName('door_mosquito');
          const frameFront = theModel?.getObjectByName('mesh_frame_front');
          // scale.z < 0 → opens left
          if (mosquito) {
            mosquito.visible = visible;
            mosquito.traverse(o => { if (o.isMesh) o.visible = visible; });
            if (visible) {
              // The parent wall's scale.z already flips the mosquito directionally.
              // Always keep mosquito's own scale.z positive so it follows the wall naturally:
              //   left wall (scale.z=-1) × mosquito(+abs) = world -1 (mirrored)
              //   right wall (scale.z=+1) × mosquito(+abs) = world +1 (mirror of left)
              mosquito.scale.z = isMedium
                ? -Math.abs(mosquito.scale.z)  // medium: counter-flip within the wall
                : Math.abs(mosquito.scale.z);  // small: follow wall naturally
              // R300H mesh is authored facing inward — rotate 180° around Y to face the camera
              if (!mosquito.userData.originRotY) mosquito.userData.originRotY = mosquito.rotation.y;
              mosquito.rotation.y = mosquito.userData.originRotY + (isR300H ? Math.PI : 0);
              // Save rest quaternion once for reset on popup open/close
              if (!mosquito.userData.originQuat) {
                mosquito.userData.originQuat = mosquito.quaternion.clone();
              }
            }
          }
          if (frameFront) {
            frameFront.visible = visible;
            frameFront.traverse(o => { if (o.isMesh) o.visible = visible; });
          }
        } else {
          // wallBack / wallLeft / wallRight — back door mosquito meshes
          const backOpensLeft = window._backDoorSide !== 'right';
          const mosquitoFlipped = isMedium ? !backOpensLeft : backOpensLeft;
          const backMosquito = theModel?.getObjectByName('door_mosquito_back')
            ?? theModel?.getObjectByName('door_mosquito001');
          const frameBack = theModel?.getObjectByName('mesh_frame_back');

          if (backMosquito) {
            backMosquito.visible = visible;
            backMosquito.traverse(o => { if (o.isMesh) o.visible = visible; });
            if (visible) {
              backMosquito.scale.z = mosquitoFlipped
                ? Math.abs(backMosquito.scale.z)
                : -Math.abs(backMosquito.scale.z);
              if (!backMosquito.userData.originRotY) backMosquito.userData.originRotY = backMosquito.rotation.y;
              backMosquito.rotation.y = backMosquito.userData.originRotY + (isR300H ? Math.PI : 0);
              if (!backMosquito.userData.originQuat) {
                backMosquito.userData.originQuat = backMosquito.quaternion.clone();
              }
            }
          }
          if (frameBack) {
            frameBack.visible = visible;
            frameBack.traverse(o => { if (o.isMesh) o.visible = visible; });
          }

          // XH models: update mosquito groups inside side_door_L / side_door_R
          const XH_MOS_CODES = new Set(['R306XH', 'R308XH']);
          if (XH_MOS_CODES.has(getCurrentSizeCode())) {
            ['side_door_L', 'side_door_R'].forEach(name => {
              const sd = theModel?.getObjectByName(name);
              if (!sd || !sd.visible) return;
              sd.traverse(o => { if (o.name.includes('mosquito')) o.visible = visible; });
            });
          }
        }

        requestDelayedRender();
        break;
      }

      case 'sideWindow': {
        const sideWinTag = `sideWindow__${zone}__${spanIndex}`;

        const sideWinStale = [];
        scene.traverse(o => { if (o.userData?.accTag === sideWinTag) sideWinStale.push(o); });
        sideWinStale.forEach(o => o.parent?.remove(o));

        const templateName = zone === 'wallLeft' ? 'side_w_L_G' : 'side_w_R_G';
        const wallGlassName = zone === 'wallLeft' ? 'w_L_G' : 'w_R_G';

        const wallGlassList = this.getAllByName(wallGlassName);
        const wallGlassSlot = wallGlassList[spanIndex] ?? wallGlassList[0];
        if (wallGlassSlot) {
          wallGlassSlot.visible = !visible;
          wallGlassSlot.traverse(c => { c.visible = !visible; });
        }

        if (visible) {
          const template = this.getAllByName(templateName)[0];
          if (!template) { console.warn(`[acc] missing template: "${templateName}"`); break; }

          const clone = template.clone(true);
          clone.userData.accTag = sideWinTag;
          clone.visible = true;
          clone.traverse(c => { c.visible = true; });

          clone.position.copy(template.position);
          clone.rotation.copy(template.rotation);
          clone.scale.copy(template.scale);

          const cloneParent = template.parent ?? theModel ?? scene;
          cloneParent.add(clone);

          if (wallGlassSlot) {
            const slotWorldPos = new THREE.Vector3();
            wallGlassSlot.getWorldPosition(slotWorldPos);
            const parentInv = new THREE.Matrix4().copy(cloneParent.matrixWorld).invert();
            const localPos = slotWorldPos.clone().applyMatrix4(parentInv);
            clone.position.z = localPos.z;
          }
        }

        requestDelayedRender();
        break;
      }

      case 'backWindow': {
        const R300_CODES = new Set(['R305H', 'R306H', 'R308H']);
        const BACK_WIN_NESTED_CODES = new Set(['S206H', 'S208H', 'R306XH', 'R308XH']);

        // back_wall_glass_L and back_wall_glass_R are direct siblings inside back_wall.
        // Use children.find (direct-children only) to guarantee we never touch the sibling.
        const setBackGlassVisible = (backWall, side, show) => {
          const glass = backWall.children.find(c => c.name === `back_wall_glass_${side}`);
          if (!glass) return;
          glass.visible = show;
          glass.traverse(c => { c.visible = show; });
        };

        if (R300_CODES.has(getCurrentSizeCode())) {
          // spanIndex 0 = left, spanIndex 1 = right
          const side = spanIndex === 1 ? 'R' : 'L';
          const hideSide = spanIndex === 0 ? 'R' : 'L';

          const winMesh = theModel?.getObjectByName(`back_w_${side}_G`);
          if (winMesh) {
            if (visible) {
              // back_w_*_G are top-level (except S200 and R300Xh)
              if (winMesh.userData.originZ === undefined) winMesh.userData.originZ = winMesh.position.z;
              winMesh.position.z = winMesh.userData.originZ + (buildStepSize || 0) * (buildCopyAmount || 1);
              winMesh.rotation.y = Math.PI;
            }
            winMesh.visible = visible;
            winMesh.traverse(c => { c.visible = visible; });
          }
          // Toggle the corresponding glass panel inside back_wall
          const backWall = theModel?.getObjectByName('back_wall');
          if (backWall) setBackGlassVisible(backWall, hideSide, !visible);
          requestDelayedRender();
          break;
        }

        if (BACK_WIN_NESTED_CODES.has(getCurrentSizeCode())) {
          // back_w_*_G live inside back_wall — position inherited from parent, just toggle visibility
          const side = spanIndex === 0 ? 'R' : 'L';
          const hideSide = spanIndex === 1 ? 'R' : 'L';
          const winMesh = theModel?.getObjectByName(`back_w_${side}_G`);
          if (winMesh) {
            winMesh.visible = visible;
            winMesh.traverse(c => { c.visible = visible; });
          }
          // Toggle the corresponding glass panel inside back_wall
          const backWall = theModel?.getObjectByName('back_wall');
          if (backWall) setBackGlassVisible(backWall, hideSide, !visible);
          requestDelayedRender();
          break;
        }

        const backWinTag = 'backWindow__wallBack__0';

        const backWinStale = [];
        scene.traverse(o => { if (o.userData?.accTag === backWinTag) backWinStale.push(o); });
        backWinStale.forEach(o => o.parent?.remove(o));

        // Hide/show the back wall glass
        const backWall = theModel?.getObjectByName('back_wall');
        let backGlass = null;
        if (backWall) {
          backGlass = backWall.getObjectByName('back_wall_glass');
          if (backGlass) { backGlass.visible = !visible; backGlass.traverse(c => { c.visible = !visible; }); }
        }

        if (visible) {
          const template = this.getAllByName('side_w_back')[0];
          if (!template) { console.warn('[acc] missing template: "side_w_back"'); break; }

          const clone = template.clone(true);
          clone.userData.accTag = backWinTag;
          clone.visible = true;
          clone.traverse(c => { c.visible = true; });

          clone.scale.copy(template.scale);

          const cloneParent = template.parent ?? theModel ?? scene;
          cloneParent.add(clone);

          const bp = getActiveBuildParams();
          let posZ = template.position.z + (bp.backWinX ?? 0);
          const R200H_BACK_WIN = new Set(['R204H', 'R205H']);
          if (R200H_BACK_WIN.has(getCurrentSizeCode()) && backGlass) {
            cloneParent.updateWorldMatrix(true, false);
            const gWorldPos = new THREE.Vector3();
            backGlass.getWorldPosition(gWorldPos);
            posZ = cloneParent.worldToLocal(gWorldPos).z;
          }
          let cloneX = template.position.x;
          if (bp.backWinUseWallX && backGlass) {
            cloneParent.updateWorldMatrix(true, false);
            const glassBox = new THREE.Box3().setFromObject(backGlass);
            const glassCenter = glassBox.getCenter(new THREE.Vector3());
            const bgLocal = cloneParent.worldToLocal(glassCenter);
            cloneX = bgLocal.x;
            posZ = bgLocal.z + (bp.backWinX ?? 0);
          }

          clone.position.set(cloneX, template.position.y, posZ);

          const glbRot = template.userData.glbRotation;
          if (glbRot) clone.rotation.copy(glbRot);
        }

        requestDelayedRender();
        break;
      }

      case 'veil': {
        const applyVis = (o, show) => {
          if (show) {
            o.rotation.set(-2 * Math.PI, 0, 0);
          }
          o.visible = show;
          o.traverse(c => {
            c.visible = show;
            if (show && c.isMesh && c.material && !c.userData.veilMatApplied) {
              const m = c.material.clone();
              // boosting original color saturation 
              const hsl = {};
              m.color.getHSL(hsl);
              m.color.setHSL(hsl.h, Math.min(1, hsl.s + 2.5), Math.min(1, hsl.l + 2.15));
              m.transparent = true;
              m.opacity = 0.75;
              m.depthWrite = false;
              c.material = m;
              c.userData.veilMatApplied = true;
            }
          });
        };
        const VEIL_Z_INSET = 0.07; // front/back panels towards centre
        const veilX = getActiveBuildParams().veilX;
        this.getAllByName('shade_veil_front').forEach(o => {
          applyVis(o, visible);
          if (o.userData.veilOriginZ === undefined) o.userData.veilOriginZ = o.position.z;
          o.position.z = visible ? o.userData.veilOriginZ + VEIL_Z_INSET : o.userData.veilOriginZ;
          if (veilX !== undefined) o.position.x = veilX;
        });
        this.getAllByName('shade_veil_back').forEach(o => {
          applyVis(o, visible);
          if (o.userData.veilOriginZ === undefined) o.userData.veilOriginZ = o.position.z;
          o.position.z = visible ? o.userData.veilOriginZ - VEIL_Z_INSET : o.userData.veilOriginZ;
          if (veilX !== undefined) o.position.x = veilX;
        });

        const centers = this.getAllByName('shade_veil_center');
        centers.forEach((o, i) => {
          const isCenterSlot = i > 0 && i < centers.length - 1;
          applyVis(o, visible && isCenterSlot);
        });

        requestDelayedRender();
        break;
      }

      case 'roofDecor': {
        const bp = getActiveBuildParams();
        this.getAllByName('decor_front').forEach(o => {
          o.visible = visible;
          o.traverse(c => { c.visible = visible; });
          if (visible) {
            if (bp.decorFrontX != null) o.position.x = bp.decorFrontX;
            if (bp.decorFrontRot != null) o.rotation.set(...bp.decorFrontRot);
            if (bp.decorFrontZDelta != null) {
              const originZ = o.userData.originZ ?? o.position.z;
              o.position.z = originZ + bp.decorFrontZDelta * buildStepSize;
            }
            if (bp.decorFrontYOffset != null) {
              if (o.userData.decorOriginY === undefined) o.userData.decorOriginY = o.position.y;
              o.position.y = o.userData.decorOriginY + bp.decorFrontYOffset;
            }
          }
        });
        this.getAllByName('decor_roof').forEach(o => { o.visible = visible; o.traverse(c => { c.visible = visible; }); });
        this.getAllByName('decor_back').forEach(o => {
          o.visible = visible;
          o.traverse(c => { c.visible = visible; });
          if (visible) {
            if (bp.decorBackX != null) o.position.x = bp.decorBackX;
            if (bp.decorBackRot != null) o.rotation.set(...bp.decorBackRot);
            if (bp.decorBackZDelta != null) {
              const originZ = o.userData.originZ ?? o.position.z;
              o.position.z = originZ + (buildCopyAmount - 1 + bp.decorBackZDelta) * buildStepSize;
            }
            if (bp.decorBackYOffset != null) {
              if (o.userData.decorOriginY === undefined) o.userData.decorOriginY = o.position.y;
              o.position.y = o.userData.decorOriginY + bp.decorBackYOffset;
            }
          }
        });
        requestDelayedRender();
        break;
      }

      case 'downpipes': {
        const isFront = zone === 'wallFront';
        const mat = state.downpipeMaterial ?? 'grey_plastic';
        const isAlum = mat === 'black_alum';
        const meshName = isAlum ? `drain_alum_front` : `drain_plastic_front`;

        if (!visible) {
          const otherZonePlaced = [...(this.placedAccessories ?? new Map()).values()]
            .some(e => e.accessoryKey === 'downpipes' && e.zone !== zone);
          if (otherZonePlaced) { requestDelayedRender(); break; }
        }

        const hideName = isAlum ? `drain_plastic_front` : `drain_alum_front`;
        const hideObj = theModel?.getObjectByName(hideName);
        if (hideObj) { hideObj.visible = false; hideObj.traverse(o => { o.visible = false; }); }
        const obj = theModel?.getObjectByName(meshName);
        if (obj) {
          if (visible) {
            let p = obj.parent;
            while (p && p !== theModel) { p.position.x = 0; p = p.parent; }
            const bp = getActiveBuildParams();
            if (state.shapeType === 0) {
              if (isFront) {
                obj.position.z = isAlum ? -0.4 : (obj.userData.originZ ?? 0) - buildStepSize + 0.055;
                obj.position.x = isAlum ? 0.0 : 1.145;
                if (isAlum) {
                  obj.rotation.set(-Math.PI / 2, -Math.PI / 1.085, 0);
                } else {
                  obj.rotation.set(-Math.PI / 2, -Math.PI / 1.086, 0);
                }
              } else {
                obj.position.z = (obj.userData.originZ ?? 0) + buildStepSize * (buildCopyAmount - 1);
                obj.position.x = isAlum ? 0.0 : -1.145;
                obj.position.y = isAlum ? 0.85 : 1.755;
                if (isAlum) {
                  obj.rotation.set(-Math.PI / 2, Math.PI / 1.086, -Math.PI);
                } else {
                  obj.rotation.set(-Math.PI / 2, Math.PI / 1.086, -Math.PI);
                }
              }
            } else if (state.shapeType === 1) {
              if (isFront) {
                obj.position.z = isAlum ? -0.4 : (obj.userData.originZ ?? 0) - buildStepSize;
                obj.position.x = isAlum ? 0.0 : -0.082;
                if (isAlum) {
                  obj.rotation.set(0, Math.PI, 2 * Math.PI);
                } else {
                  obj.rotation.set(0, -Math.PI / 2, 2 * Math.PI);
                }
              } else {
                obj.position.z = (obj.userData.originZ ?? 0) + buildStepSize * (buildCopyAmount - 1);
                obj.position.x = isAlum ? 0.0 : 0.085;
                // obj.position.y = isAlum ? 0.85 : 1.755;
                if (isAlum) {
                  obj.rotation.set(0, 0, 2 * Math.PI);
                } else {
                  obj.rotation.set(0, Math.PI / 2, 2 * Math.PI);
                }
              }
            } else if (state.shapeType === 2) {
              if (isFront) {
                obj.position.z = isAlum ? -0.4 : (obj.userData.originZ ?? 0) - buildStepSize + 0.055;
                obj.position.x = isAlum ? 0.0 : 1.145;
                if (isAlum) {
                  obj.rotation.set(-Math.PI / 2, -Math.PI / 1.085, 0);
                } else {
                  obj.rotation.set(-Math.PI / 2, -Math.PI / 1.085, 0);
                  obj.position.y = 1.995;
                }
              } else {
                obj.position.z = (obj.userData.originZ ?? 0) + buildStepSize * (buildCopyAmount - 1);
                obj.position.x = isAlum ? 0.0 : -1.145;
                if (isAlum) {
                  obj.rotation.set(-Math.PI / 2, Math.PI / 1.086, -Math.PI);
                } else {
                  obj.rotation.set(-Math.PI / 2, Math.PI / 1.085, -Math.PI);
                  obj.position.y = 1.995;
                }
              }
            }
          }
          // Save original GLTF color before applyAllColors() tints the mesh (model-switch safe)
          obj.traverse(o => {
            if (o.isMesh && o.material && o.userData.origColor == null) {
              o.userData.origColor = o.material.color?.getHex?.() ?? null;
            }
          });
          obj.visible = visible;
          applyAllColors();
          obj.traverse(o => { o.visible = visible; });
          if (visible && mat === 'black_plastic') {
            obj.traverse(o => {
              if (o.isMesh && o.material) {
                const m = o.material.clone();
                m.color.set(0x1a1a1a);
                o.material = m;
              }
            });
          } else if (visible && mat === 'black_alum') {
            obj.traverse(o => {
              if (o.isMesh && o.material) {
                const m = o.material.clone();
                m.color.set(0x111111);
                m.metalness = 0.85;
                m.roughness = 0.25;
                m.envMapIntensity = 1.2;
                o.material = m;
              }
            });
          } else if (visible && mat === 'grey_plastic') {
            const isBlackBody = state.colorBody === '#000000';
            obj.traverse(o => {
              if (o.isMesh && o.material) {
                const m = o.material.clone();
                if (isBlackBody) {
                  m.color.set(0x1a1a1a);
                } else {
                  m.color.setHex(o.userData.origColor);
                }
                m.metalness = 0;
                m.roughness = m.roughness ?? 0.8;
                o.material = m;
              }
            });
          }
        }
        requestDelayedRender();
        break;
      }

      default: {
        const keys = Array.isArray(item.meshKey) ? item.meshKey : (item.meshKey ? [item.meshKey] : []);
        keys.forEach(name => setVis(name, visible));
        requestDelayedRender();
        break;
      }
    }
  }

  getPlacedAccessories() {
    if (!this.placedAccessories) return [];
    return [...this.placedAccessories.values()];
  }

  isAccessoryPlaced(accessoryKey, zone, spanIndex) {
    const key = `${accessoryKey}__${zone}__${spanIndex}`;
    return this.placedAccessories?.has(key) ?? false;
  }

  removeAccessory(accessoryKey) {
    if (!this.placedAccessories) return;
    for (const [k, entry] of this.placedAccessories) {
      if (entry.accessoryKey === accessoryKey && !entry.permanent) {
        this.applyAccessoryMeshVisibility(entry.item, entry.zone, entry.spanIndex, false, entry.roofSlope ?? null);
        this.placedAccessories.delete(k);
      }
    }
    // Remove all placements of this key from persisted state
    state.accessoryPlacements = (state.accessoryPlacements || []).filter(p => p.key !== accessoryKey);
    state.subAccessoriesUrl.delete(accessoryKey);
    this.hideAllAccessoryHotspots();
    // Notify UI listeners (syncAccessoryUI updates section-param and head__param)
    window.dispatchEvent(new CustomEvent('accessoryPlaced', { detail: { key: accessoryKey } }));
    requestDelayedRender();
  }

  removePlacedAccessory(accessoryKey, zone, spanIndex) {
    if (!this.placedAccessories) return;
    const mapKey = `${accessoryKey}__${zone}__${spanIndex}`;
    const entry = this.placedAccessories.get(mapKey);
    if (!entry) return;
    this.applyAccessoryMeshVisibility(entry.item, zone, spanIndex, false, entry.roofSlope ?? null);
    this.placedAccessories.delete(mapKey);
    state.accessoryPlacements = (state.accessoryPlacements || []).filter(
      p => !(p.key === accessoryKey && p.zone === zone && p.span === spanIndex)
    );
    const remainingNonPermanent = [...this.placedAccessories.values()].filter(e => e.accessoryKey === accessoryKey && !e.permanent);
    if (remainingNonPermanent.length === 0) {
      state.subAccessoriesUrl.delete(accessoryKey);
    }
    window.dispatchEvent(new CustomEvent('accessoryPlaced', { detail: { key: accessoryKey } }));
    this.hideAllAccessoryHotspots();
    requestDelayedRender();
  }

  // Re-apply user-placed (non-permanent) accessories on the current theModel.
  // Permanent accessories (default roof window) are re-placed separately in
  // changeShapeType because their slot depends on the current buildCopyAmount.
  reapplyAccessories() {
    if (!this.placedAccessories) return;
    theModel?.updateWorldMatrix(true, true);
    for (const entry of this.placedAccessories.values()) {
      if (entry.permanent) continue;
      this.applyAccessoryMeshVisibility(entry.item, entry.zone, entry.spanIndex, true, entry.roofSlope ?? null);
    }
    requestDelayedRender();
  }

  // hotspots per particular accessory
  showHotspotsForAccessory(accessoryKey) {
    // Organization items (tables, shelves, etc.) use their own hotspot logic
    if (ORG_KEYS.has(accessoryKey)) {
      this.showHotspotsForOrganization(accessoryKey);
      return;
    }
    // automateOpening can only go on top of existing windows — use restricted logic
    if (accessoryKey === 'automateOpening') {
      this.showHotspotsForAutomatedOpening();
      return;
    }
    // extraDoor uses size-aware back/side hotspot logic
    if (accessoryKey === 'extraDoor') {
      this.showHotspotsForExtraDoor();
      return;
    }
    // extraDoubleDoor uses size-aware front/side hotspot logic
    if (accessoryKey === 'extraDoubleDoor') {
      this.showHotspotsForExtraDoubleDoor();
      return;
    }
    // sideWindow: left/right walls only (no corners, center of each module)
    if (accessoryKey === 'sideWindow') {
      this.hideAllAccessoryHotspots();
      const n = buildCopyAmount || 1;
      const step = buildStepSize || (state.length / n);
      const hw = buildModelHalfW || (state.width / 2);
      const midY = state.height > 0 ? state.height * 0.5 : 1.2;
      const toWorld = (lx, ly, lz) => {
        const v = new THREE.Vector3(lx, ly, lz);
        return theModel ? theModel.localToWorld(v) : v;
      };
      const modCenterZ = (i) => buildGeomFrameZ + step * i + step / 2;

      const placedSW = this.placedAccessories ?? new Map();
      this.span.objects.forEach(span => {
        if (span.zone !== 'wallLeft' && span.zone !== 'wallRight') {
          setHotspotVisibility(span.hotspot, false); return;
        }
        const i = span.number;
        // Skip corners
        if (i === 0 || i === n - 1) { setHotspotVisibility(span.hotspot, false); return; }
        // Skip already placed
        if (placedSW.has(`sideWindow__${span.zone}__${i}`)) {
          setHotspotVisibility(span.hotspot, false); return;
        }
        // Skip if a door occupies this module on this side
        if (placedSW.has(`extraDoor__${span.zone}__${i}`) || placedSW.has(`extraDoubleDoor__${span.zone}__${i}`)) {
          setHotspotVisibility(span.hotspot, false); return;
        }
        const lx = span.zone === 'wallLeft' ? -hw : hw;
        const lz = modCenterZ(i);
        span.hotspot.position.copy(toWorld(lx, midY, lz));
        const zone = span.zone;
        span.hotspot.setClickFunction(() => {
          this.placeAccessory('sideWindow', zone, i);
          this.showHotspotsForAccessory('sideWindow');
        });
        setHotspotVisibility(span.hotspot, true);
      });
      updateHotspots(hotspots);
      requestDelayedRender();
      return;
    }
    // backWindow: single hotspot on the back wall center (two for R300)
    if (accessoryKey === 'backWindow') {
      this.hideAllAccessoryHotspots();
      const n = buildCopyAmount || 1;
      const step = buildStepSize || (state.length / n);
      const midY = state.height > 0 ? state.height * 0.5 : 1.2;
      const backZ = buildGeomStartZ + step * n;
      const toWorld = (lx, ly, lz) => {
        const v = new THREE.Vector3(lx, ly, lz);
        return theModel ? theModel.localToWorld(v) : v;
      };

      const R300_CODES = new Set(['R305H', 'R306H', 'R308H', 'S206H', 'S208H', 'R306XH', 'R308XH']);
      if (R300_CODES.has(getCurrentSizeCode())) {
        const hw = buildModelHalfW || (state.width / 2);
        const offset = hw * 0.3;
        const placed = this.placedAccessories ?? new Map();
        // Use buildBackWallZ — the actual Z of the back wall group for this model
        const r300BackZ = buildBackWallZ || backZ;

        const backDoorOnBack = [...placed.values()].some(
          e => (e.accessoryKey === 'extraDoor' || e.accessoryKey === 'extraDoubleDoor') && e.zone === 'wallBack'
        );

        // Left hotspot (user's left = -X) → back_w_L_G (spanIndex 0)
        const backSpan = this.span.objects.find(s => s.zone === 'wallBack' && s.number === 0);
        if (backSpan?.hotspot) {
          if (!placed.has('backWindow__wallBack__0') && !backDoorOnBack) {
            backSpan.hotspot.position.copy(toWorld(-offset, midY, r300BackZ));
            backSpan.hotspot.setClickFunction(() => {
              this.placeAccessory('backWindow', 'wallBack', 0);
              this.showHotspotsForAccessory('backWindow');
            });
            setHotspotVisibility(backSpan.hotspot, true);
          } else {
            setHotspotVisibility(backSpan.hotspot, false);
          }
        }

        // Right hotspot (user's right = +X) → back_w_R_G (spanIndex 1)
        const front0 = this.span.objects.find(s => s.zone === 'wallFront' && s.number === 0);
        if (front0?.hotspot) {
          if (!placed.has('backWindow__wallBack__1') && !backDoorOnBack) {
            front0.hotspot.position.copy(toWorld(offset, midY, r300BackZ));
            front0.hotspot.setClickFunction(() => {
              this.placeAccessory('backWindow', 'wallBack', 1);
              this.showHotspotsForAccessory('backWindow');
            });
            setHotspotVisibility(front0.hotspot, true);
          } else {
            setHotspotVisibility(front0.hotspot, false);
          }
        }

        updateHotspots(hotspots);
        requestDelayedRender();
        return;
      }

      const placedBW = this.placedAccessories ?? new Map();
      const backDoorBlocksBW = [...placedBW.values()].some(
        e => (e.accessoryKey === 'extraDoor' || e.accessoryKey === 'extraDoubleDoor') && e.zone === 'wallBack'
      );
      this.span.objects.forEach(span => {
        // Use wallFront span which physically sits at high z (the far/back wall side)
        if (span.zone !== 'wallFront' || span.number !== 0) {
          setHotspotVisibility(span.hotspot, false); return;
        }
        if (placedBW.has('backWindow__wallBack__0') || backDoorBlocksBW) {
          setHotspotVisibility(span.hotspot, false); return;
        }
        span.hotspot.position.copy(toWorld(0, midY, backZ));
        span.hotspot.setClickFunction(() => {
          this.placeAccessory('backWindow', 'wallBack', 0);
          this.showHotspotsForAccessory('backWindow');
        });
        setHotspotVisibility(span.hotspot, true);
      });
      updateHotspots(hotspots);
      requestDelayedRender();
      return;
    }
    // Heaters: single fixed placement, no hotspot selection needed
    if (accessoryKey === 'standHeater') {
      this.placeAccessory('standHeater', 'wallLeft', 1);
      this.hideAllAccessoryHotspots();
      return;
    }
    if (accessoryKey === 'phoenixHeater') {
      this.placeAccessory('phoenixHeater', 'center', 0);
      this.hideAllAccessoryHotspots();
      return;
    }
    // veil / roofDecor
    if (accessoryKey === 'veil') {
      this.placeAccessory('veil', 'roof', 0);
      this.hideAllAccessoryHotspots();
      return;
    }
    if (accessoryKey === 'roofDecor') {
      this.placeAccessory('roofDecor', 'roof', 0);
      this.hideAllAccessoryHotspots();
      return;
    }
    // downpipes: one hotspot on front wall, one on back wall
    if (accessoryKey === 'downpipes') {
      this.showHotspotsForDownpipes();
      return;
    }

    // mosquitoDoor: if only front door exists → auto-place; if extra door also placed → show hotspots
    if (accessoryKey === 'mosquitoDoor') {
      // XH models: side door mosquito — show hotspot at the hidden mosquito mesh, click makes it visible
      const XH_MOS_CODES = new Set(['R306XH', 'R308XH']);
      if (XH_MOS_CODES.has(getCurrentSizeCode())) {
        this.hideAllAccessoryHotspots();
        const placed = this.placedAccessories ?? new Map();
        const allSpans = this.span.objects;
        let spanIdx = 0;
        for (const [, entry] of placed) {
          if (entry.accessoryKey !== 'extraDoor') continue;
          if (entry.zone !== 'wallLeft' && entry.zone !== 'wallRight') continue;
          const meshName = entry.zone === 'wallLeft' ? 'side_door_R' : 'side_door_L';
          const sideDoor = theModel?.getObjectByName(meshName);
          if (!sideDoor || !sideDoor.visible) continue;
          // Find the mosquito group inside this door (it is hidden — still has world position)
          let mosquitoObj = null;
          sideDoor.traverse(o => {
            if (!mosquitoObj && o.name.includes('mosquito') && !o.name.includes('logo')) mosquitoObj = o;
          });
          if (!mosquitoObj) continue;
          if (mosquitoObj.visible) continue; // already shown — no hotspot needed
          const span = allSpans[spanIdx++];
          if (!span) break;
          const mosPos = new THREE.Vector3();
          mosquitoObj.getWorldPosition(mosPos);
          span.hotspot.position.copy(mosPos);
          const capturedDoor = sideDoor;
          span.hotspot.setClickFunction(() => {
            capturedDoor.traverse(o => { if (o.name.includes('mosquito')) o.visible = true; });
            this.hideAllAccessoryHotspots();
            requestDelayedRender();
          });
          setHotspotVisibility(span.hotspot, true);
        }
        updateHotspots(hotspots);
        requestDelayedRender();
        return;
      }

      const extraDoorPlaced = this.placedAccessories
        ? [...this.placedAccessories.values()].some(e => e.accessoryKey === 'extraDoor')
        : false;

      if (!extraDoorPlaced) {
        // Only one door → auto-place on front if not yet placed (guard: placeAccessory is a toggle)
        if (!this.placedAccessories?.has('mosquitoDoor__wallFront__0')) {
          this.placeAccessory('mosquitoDoor', 'wallFront', 0);
        }
        return;
      }

      // Two doors (front + back) → show one hotspot per door wall so user picks
      this.hideAllAccessoryHotspots();

      const n = buildCopyAmount || 1;
      const step = buildStepSize || (state.length / n);
      const midY = state.height > 0 ? state.height * 0.5 : 1.2;

      const toWorld = (lx, ly, lz) => {
        const v = new THREE.Vector3(lx, ly, lz);
        return theModel ? theModel.localToWorld(v) : v;
      };

      const frontAlreadyPlaced = this.placedAccessories?.has('mosquitoDoor__wallFront__0');
      const backAlreadyPlaced = this.placedAccessories?.has('mosquitoDoor__wallBack__0');

      // wallBack zone sits at low Z (near front_wall) → clicking places FRONT mosquito
      const backSpan = this.span.objects.find(s => s.zone === 'wallBack' && s.number === 0);
      if (backSpan?.hotspot) {
        if (!frontAlreadyPlaced) {
          backSpan.hotspot.position.copy(toWorld(0, midY, buildGeomStartZ));
          backSpan.hotspot.setClickFunction(() => {
            this.placeAccessory('mosquitoDoor', 'wallFront', 0);
            this.showHotspotsForAccessory('mosquitoDoor');
          });
        }
        setHotspotVisibility(backSpan.hotspot, !frontAlreadyPlaced);
      }

      // wallFront zone sits at high Z (near back_wall_door) → clicking places BACK mosquito
      const frontSpan = this.span.objects.find(s => s.zone === 'wallFront' && s.number === 0);
      if (frontSpan?.hotspot) {
        if (!backAlreadyPlaced) {
          frontSpan.hotspot.position.copy(toWorld(0, midY, buildGeomStartZ + step * n));
          frontSpan.hotspot.setClickFunction(() => {
            this.placeAccessory('mosquitoDoor', 'wallBack', 0);
            this.showHotspotsForAccessory('mosquitoDoor');
          });
        }
        setHotspotVisibility(frontSpan.hotspot, !backAlreadyPlaced);
      }
      updateHotspots(hotspots);
      requestDelayedRender();
      return;
    }

    const zones = ACCESSORY_ZONE_CONFIG[accessoryKey] || [];
    const model = theModel;

    const n = buildCopyAmount || 1;
    console.log(`[hotspots] key=${accessoryKey} n=${n} step=${buildStepSize?.toFixed(4)} startZ=${buildGeomStartZ?.toFixed(4)} frameZ=${buildGeomFrameZ?.toFixed(4)} delta=${(buildGeomFrameZ - buildGeomStartZ)?.toFixed(4)} modZ(1)=${(buildGeomFrameZ + buildStepSize * 1 + buildStepSize / 2)?.toFixed(4)}`);
    const step = buildStepSize || (state.length / n);
    const hw = buildModelHalfW || (state.width / 2);

    const midY = state.height > 0 ? state.height * 0.5 : 1.2;
    const roofY = state.height > 0 ? state.height * 0.95 + 0.2 : 2.5;

    const modZ = (i) => buildGeomFrameZ + step * i + step / 2;

    // Rules for roof:
    const isRoofSpanAllowed = (spanNumber) => {
      const mi = Math.floor(spanNumber / 2);
      const slope = spanNumber % 2 === 0 ? 'left' : 'right';

      // Rule 1: block corners
      if (mi === 0 || mi === n - 1) return false;

      // Rule 2: block if adjacent module on same slope is already placed
      const prevKey = `${accessoryKey}__roof__${(mi - 1) * 2 + (slope === 'left' ? 0 : 1)}`;
      const nextKey = `${accessoryKey}__roof__${(mi + 1) * 2 + (slope === 'left' ? 0 : 1)}`;
      const placed = this.placedAccessories ?? new Map();
      if (placed.has(prevKey) || placed.has(nextKey)) return false;

      return true;
    };

    this.span.objects.forEach(span => {
      let show = zones.includes(span.zone);

      //  roof-specific placement rules
      if (show && span.zone === 'roof') {
        const alreadyPlaced = (this.placedAccessories ?? new Map())
          .has(`${accessoryKey}__roof__${span.number}`);
        show = !alreadyPlaced && isRoofSpanAllowed(span.number);
      }

      if (show) {
        let lx = 0, ly = midY, lz = 0;

        if (span.zone === 'wallLeft') { lx = -hw; lz = modZ(span.number); }
        if (span.zone === 'wallRight') { lx = hw; lz = modZ(span.number); }
        if (span.zone === 'wallFront') { lx = 0; lz = buildGeomStartZ + step * n; }
        if (span.zone === 'wallBack') { lx = 0; lz = buildGeomStartZ; }
        if (span.zone === 'roof') {
          const mi = Math.floor(span.number / 2);
          lx = span.number % 2 === 0 ? -hw * 0.45 : hw * 0.45;
          ly = roofY;
          lz = modZ(mi);
        }

        const worldPos = model
          ? model.localToWorld(new THREE.Vector3(lx, ly, lz))
          : new THREE.Vector3(lx, ly, lz);

        span.hotspot.position.copy(worldPos);

        const _key = accessoryKey;
        const _zone = span.zone;
        const _idx = span.number;
        span.hotspot.setClickFunction(() => {
          this.placeAccessory(_key, _zone, _idx);
          // Refresh hotspot visibility after placement to enforce adjacency rules
          this.showHotspotsForAccessory(_key);
        });
      }
      setHotspotVisibility(span.hotspot, show);
    });
    updateHotspots(hotspots);
    requestDelayedRender();
  }

  hideAllAccessoryHotspots() {
    this.span.objects.forEach(span => setHotspotVisibility(span.hotspot, false));
  }

  showHotspotsForExtraDoor() {
    const code = getCurrentSizeCode();

    const SMALL_CODES = new Set(['R204H', 'R205H', 'S104H', 'S106H']);
    const MEDIUM_CODES = new Set(['R305H', 'R306H', 'R308H', 'S206H', 'S208H']);
    const XH_CODES = new Set(['R306XH', 'R308XH']);


    this.hideAllAccessoryHotspots();

    if (SMALL_CODES.has(code)) {
      const placedSmall = this.placedAccessories ?? new Map();
      // Only auto-place if not already placed — removal goes via removeAccessory(), not toggle.
      // Without this guard, the onAccessoryPlacedGlobal handler would call showHotspotsForAccessory
      // again immediately after placement and the placeAccessory toggle would remove the door.
      if (!placedSmall.has('extraDoor__wallBack__0') && !placedSmall.has('backWindow__wallBack__0')) {
        this.placeAccessory('extraDoor', 'wallBack', 0);
      }
      return;
    }

    if (!MEDIUM_CODES.has(code) && !XH_CODES.has(code)) return;

    const n = buildCopyAmount || 3;
    const step = buildStepSize || (state.length / n);
    const hw = buildModelHalfW || (state.width / 2);
    const midY = state.height > 0 ? state.height * 0.5 : 1.2;

    // back face is at the far end: buildGeomStartZ + step * n (same as wallFront hotspot zone)
    const backZ = buildGeomStartZ + step * n;
    const offset = hw * 0.3; // offset from center for 2 hotspots

    // convert local model positions to world for hotspot placement
    const toWorld = (lx, ly, lz) => {
      const v = new THREE.Vector3(lx, ly, lz);
      return theModel ? theModel.localToWorld(v) : v;
    };

    const placedED = this.placedAccessories ?? new Map();
    const SPOT_BLOCKERS = ['extraDoor', 'extraDoubleDoor', 'sideWindow', 'backWindow'];
    const isSpotTaken = (zone, idx) => SPOT_BLOCKERS.some(k => placedED.has(`${k}__${zone}__${idx}`));

    //  single wallBack span for left-center position
    const backSpan = this.span.objects.find(s => s.zone === 'wallBack' && s.number === 0);
    if (backSpan?.hotspot) {
      const blocked0 = isSpotTaken('wallBack', 0);
      if (!blocked0) {
        const wp = toWorld(-offset, midY, backZ);
        backSpan.hotspot.position.copy(wp);
        backSpan.hotspot.setClickFunction(() => {
          this.placeAccessory('extraDoor', 'wallBack', 0);
          this.showHotspotsForExtraDoor();
        });
      }
      setHotspotVisibility(backSpan.hotspot, !blocked0);
    }

    // ...for right-center position (spanIndex 1 so second click triggers double-door logic)
    const front0 = this.span.objects.find(s => s.zone === 'wallFront' && s.number === 0);
    if (front0?.hotspot) {
      const blocked1 = isSpotTaken('wallBack', 1);
      if (!blocked1) {
        const wp = toWorld(offset, midY, backZ);
        front0.hotspot.position.copy(wp);
        front0.hotspot.setClickFunction(() => {
          this.placeAccessory('extraDoor', 'wallBack', 1);
          this.showHotspotsForExtraDoor();
        });
      }
      setHotspotVisibility(front0.hotspot, !blocked1);
    }

    if (XH_CODES.has(code)) {
      // skip corners hotspots (0 and n-1)
      for (let i = 1; i < n - 1; i++) {
        const lz = buildGeomFrameZ + step * i + step / 2;

        const leftSpan = this.span.objects.find(s => s.zone === 'wallLeft' && s.number === i);
        const rightSpan = this.span.objects.find(s => s.zone === 'wallRight' && s.number === i);

        if (leftSpan?.hotspot) {
          const blockedLeft = isSpotTaken('wallLeft', i);
          if (!blockedLeft) {
            const _i = i;
            leftSpan.hotspot.position.copy(toWorld(-hw, midY, lz));
            leftSpan.hotspot.setClickFunction(() => {
              this.placeBackDoorOnSide('left', _i);
              this.showHotspotsForExtraDoor();
            });
          }
          setHotspotVisibility(leftSpan.hotspot, !blockedLeft);
        }

        if (rightSpan?.hotspot) {
          const blockedRight = isSpotTaken('wallRight', i);
          if (!blockedRight) {
            const _i = i;
            rightSpan.hotspot.position.copy(toWorld(hw, midY, lz));
            rightSpan.hotspot.setClickFunction(() => {
              this.placeBackDoorOnSide('right', _i);
              this.showHotspotsForExtraDoor();
            });
          }
          setHotspotVisibility(rightSpan.hotspot, !blockedRight);
        }
      }
    }
  }

  showHotspotsForExtraDoubleDoor() {
    const code = getCurrentSizeCode();

    const NON_XH_CODES = new Set(['R305H', 'R306H', 'R308H', 'S206H', 'S208H']);
    const XH_CODES = new Set(['R306XH', 'R308XH']);

    this.hideAllAccessoryHotspots();

    const n = buildCopyAmount || 3;
    const step = buildStepSize || (state.length / n);
    const hw = buildModelHalfW || (state.width / 2);
    const midY = state.height > 0 ? state.height * 0.5 : 1.2;

    const toWorld = (lx, ly, lz) => {
      const v = new THREE.Vector3(lx, ly, lz);
      return theModel ? theModel.localToWorld(v) : v;
    };

    if (NON_XH_CODES.has(code)) {
      const placed = this.placedAccessories ?? new Map();
      const backHasExtraDoor = [...placed.values()].some(e => e.accessoryKey === 'extraDoor' && e.zone === 'wallBack');

      if (!backHasExtraDoor) {
        // No back door placed: auto-place on front (only one option)
        this.placeAccessory('extraDoubleDoor', 'wallFront', 0);
        return;
      }

      // Back door is placed: let user choose front or back
      const frontSpan = this.span.objects.find(s => s.zone === 'wallFront' && s.number === 0);
      const backSpan = this.span.objects.find(s => s.zone === 'wallBack' && s.number === 0);
      const frontZ = buildGeomStartZ;
      const backZ = buildGeomStartZ + step * n;

      if (frontSpan?.hotspot) {
        const frontBlocked = ['extraDoor', 'extraDoubleDoor', 'sideWindow', 'backWindow'].some(k => placed.has(`${k}__wallFront__0`));
        if (!frontBlocked) {
          frontSpan.hotspot.position.copy(toWorld(0, midY, frontZ));
          frontSpan.hotspot.setClickFunction(() => {
            this.placeAccessory('extraDoubleDoor', 'wallFront', 0);
            this.showHotspotsForExtraDoubleDoor();
          });
        }
        setHotspotVisibility(frontSpan.hotspot, !frontBlocked);
      }

      if (backSpan?.hotspot) {
        const backBlocked = placed.has('backWindow__wallBack__0') || placed.has('backWindow__wallBack__1')
          || placed.has('extraDoubleDoor__wallBack__0');
        if (!backBlocked) {
          backSpan.hotspot.position.copy(toWorld(0, midY, backZ));
          backSpan.hotspot.setClickFunction(() => {
            this.placeAccessory('extraDoubleDoor', 'wallBack', 0);
            this.showHotspotsForExtraDoubleDoor();
          });
        }
        setHotspotVisibility(backSpan.hotspot, !backBlocked);
      }

      updateHotspots(hotspots);
      requestDelayedRender();
      return;
    }

    if (!XH_CODES.has(code)) return;

    const placed = this.placedAccessories ?? new Map();

    // Front wall — always show unless blocked
    const xhFrontSpan = this.span.objects.find(s => s.zone === 'wallFront' && s.number === 0);
    const frontZ = buildGeomStartZ;
    if (xhFrontSpan?.hotspot) {
      const frontBlocked = ['extraDoor', 'extraDoubleDoor', 'sideWindow', 'backWindow'].some(k => placed.has(`${k}__wallFront__0`));
      if (!frontBlocked) {
        xhFrontSpan.hotspot.position.copy(toWorld(0, midY, frontZ));
        xhFrontSpan.hotspot.setClickFunction(() => {
          this.placeAccessory('extraDoubleDoor', 'wallFront', 0);
          this.showHotspotsForExtraDoubleDoor();
        });
      }
      setHotspotVisibility(xhFrontSpan.hotspot, !frontBlocked);
    }

    // Back wall — only if extraDoor already placed there
    const xhBackHasExtraDoor = placed.has('extraDoor__wallBack__0') || placed.has('extraDoor__wallBack__1');
    const xhBackSpan = this.span.objects.find(s => s.zone === 'wallBack' && s.number === 0);
    const backZ = buildGeomStartZ + step * n;
    if (xhBackSpan?.hotspot) {
      const backBlocked = !xhBackHasExtraDoor || placed.has('extraDoubleDoor__wallBack__0');
      if (!backBlocked) {
        xhBackSpan.hotspot.position.copy(toWorld(0, midY, backZ));
        xhBackSpan.hotspot.setClickFunction(() => {
          this.placeAccessory('extraDoubleDoor', 'wallBack', 0);
          this.showHotspotsForExtraDoubleDoor();
        });
      }
      setHotspotVisibility(xhBackSpan.hotspot, !backBlocked);
    }

    // Side walls — only where extraDoor is already placed on that side
    for (let i = 1; i < n - 1; i++) {
      const lz = buildGeomFrameZ + step * i + step / 2;
      const capturedI = i;

      const leftHasExtraDoor = placed.has(`extraDoor__wallLeft__${i}`);
      const rightHasExtraDoor = placed.has(`extraDoor__wallRight__${i}`);
      const leftHasSideWindow = placed.has(`sideWindow__wallLeft__${i}`);
      const rightHasSideWindow = placed.has(`sideWindow__wallRight__${i}`);
      const leftHasExtraDoubleDoor = placed.has(`extraDoubleDoor__wallLeft__${i}`);
      const rightHasExtraDoubleDoor = placed.has(`extraDoubleDoor__wallRight__${i}`);

      const leftSpan = this.span.objects.find(s => s.zone === 'wallLeft' && s.number === i);
      const rightSpan = this.span.objects.find(s => s.zone === 'wallRight' && s.number === i);

      if (leftSpan?.hotspot) {
        const showLeft = leftHasExtraDoor && !leftHasSideWindow && !leftHasExtraDoubleDoor;
        if (showLeft) {
          leftSpan.hotspot.position.copy(toWorld(-hw, midY, lz));
          leftSpan.hotspot.setClickFunction(() => {
            this.placeAccessory('extraDoubleDoor', 'wallLeft', capturedI);
            this.showHotspotsForExtraDoubleDoor();
          });
        }
        setHotspotVisibility(leftSpan.hotspot, showLeft);
      }

      if (rightSpan?.hotspot) {
        const showRight = rightHasExtraDoor && !rightHasSideWindow && !rightHasExtraDoubleDoor;
        if (showRight) {
          rightSpan.hotspot.position.copy(toWorld(hw, midY, lz));
          rightSpan.hotspot.setClickFunction(() => {
            this.placeAccessory('extraDoubleDoor', 'wallRight', capturedI);
            this.showHotspotsForExtraDoubleDoor();
          });
        }
        setHotspotVisibility(rightSpan.hotspot, showRight);
      }
    }
    updateHotspots(hotspots);
    requestDelayedRender();
  }

  showHotspotsForDownpipes() {
    this.hideAllAccessoryHotspots();

    const n = buildCopyAmount || 1;
    const step = buildStepSize || (state.length / n);
    const midY = state.height > 0 ? state.height * 0.5 : 1.2;

    const toWorld = (lx, ly, lz) => {
      const v = new THREE.Vector3(lx, ly, lz);
      return theModel ? theModel.localToWorld(v) : v;
    };

    // wallFront zone → drain_plastic_front; place hotspot at visual front (low Z)
    const frontSpan = this.span.objects.find(s => s.zone === 'wallFront' && s.number === 0);
    if (frontSpan?.hotspot) {
      frontSpan.hotspot.position.copy(toWorld(0, midY, buildGeomStartZ));
      frontSpan.hotspot.setClickFunction(() => {
        this.placeAccessory('downpipes', 'wallFront', 0);
        this.showHotspotsForDownpipes();
      });
      const alreadyFront = (this.placedAccessories ?? new Map()).has('downpipes__wallFront__0');
      setHotspotVisibility(frontSpan.hotspot, !alreadyFront);
    }

    // wallBack zone → drain_plastic_back; place hotspot at visual back (high Z)
    const backSpan = this.span.objects.find(s => s.zone === 'wallBack' && s.number === 0);
    if (backSpan?.hotspot) {
      backSpan.hotspot.position.copy(toWorld(0, midY, buildGeomStartZ + step * n));
      backSpan.hotspot.setClickFunction(() => {
        this.placeAccessory('downpipes', 'wallBack', 0);
        this.showHotspotsForDownpipes();
      });
      const alreadyBack = (this.placedAccessories ?? new Map()).has('downpipes__wallBack__0');
      setHotspotVisibility(backSpan.hotspot, !alreadyBack);
    }

    updateHotspots(hotspots);
    requestDelayedRender();
  }

  // Show hotspots for organization accessories (tables, shelves, etc.)
  // Allows corners on side walls; allows back wall center if no ventilation element blocks it.
  showHotspotsForOrganization(key) {
    this.hideAllAccessoryHotspots();

    const k = ORG_WINDOW_COUNT[key] ?? 1;
    const n = buildCopyAmount || 1;
    const step = buildStepSize || (state.length / n);
    const hw = buildModelHalfW || (state.width / 2);
    const midY = state.height > 0 ? state.height * 0.4 : 1.0;
    const placed = this.placedAccessories ?? new Map();

    const VENTILATION_KEYS = new Set(['extraDoor', 'extraDoubleDoor', 'sideWindow', 'backWindow']);
    const placedVentilation = [...placed.values()].filter(e => VENTILATION_KEYS.has(e.accessoryKey));
    const allPlacedOrg = [...placed.values()].filter(e => ORG_KEYS.has(e.accessoryKey));

    this.span.objects.forEach(span => {
      const zone = span.zone;

      // Back wall: 1 hotspot (center) for SMALL_CODES, 2 hotspots (±offset) for MEDIUM_CODES
      if (zone === 'wallBack') {
        const i = span.number;
        const code = getCurrentSizeCode();
        const isSmall = SMALL_CODES.has(code);
        const isMedium = MEDIUM_CODES.has(code);

        // Only show back wall org hotspots for small and medium codes
        if (!isSmall && !isMedium) {
          setHotspotVisibility(span.hotspot, false);
          return;
        }

        const offset = hw * 0.3;
        // SMALL: 1 position at center (span 0 only)
        // MEDIUM: 2 positions at ±offset (spans 0 and 1 only)
        const backPositions = isSmall ? [{ lx: 0 }] : [{ lx: -offset }, { lx: offset }];

        if (i >= backPositions.length || i + k - 1 >= backPositions.length) {
          setHotspotVisibility(span.hotspot, false);
          return;
        }

        // Block if any org item already occupies any position in [i, i+k-1]
        // Exception: a table and a shelf can share the same span
        const spotTaken = allPlacedOrg.some(oi => {
          if (oi.zone !== 'wallBack') return false;
          if (isTableShelfPair(oi.accessoryKey, key)) return false;
          const oiK = ORG_WINDOW_COUNT[oi.accessoryKey] ?? 1;
          const oiI = oi.spanIndex;
          return i <= oiI + oiK - 1 && i + k - 1 >= oiI;
        });
        if (spotTaken) {
          setHotspotVisibility(span.hotspot, false);
          return;
        }

        // Blocked if extraDoor, extraDoubleDoor, or backWindow is placed on wallBack
        const blockedByVentilation = placedVentilation.some(
          e => e.zone === 'wallBack' && ['extraDoor', 'extraDoubleDoor', 'backWindow'].includes(e.accessoryKey)
        );
        if (blockedByVentilation) {
          setHotspotVisibility(span.hotspot, false);
          return;
        }

        // Different type needs 1-position gap; same type can be directly adjacent
        // Exception: table+shelf pair needs no gap and can share the same span
        const blockedByOrg = allPlacedOrg.some(oi => {
          if (oi.zone !== 'wallBack' || oi.accessoryKey === key) return false;
          if (isTableShelfPair(oi.accessoryKey, key)) return false;
          const oiK = ORG_WINDOW_COUNT[oi.accessoryKey] ?? 1;
          const oiI = oi.spanIndex;
          return i <= oiI + oiK && i + k - 1 >= oiI - 1;
        });
        if (blockedByOrg) {
          setHotspotVisibility(span.hotspot, false);
          return;
        }

        // Center the hotspot across the k-span range
        const startLx = backPositions[i].lx;
        const endLx = backPositions[i + k - 1].lx;
        const lx = (startLx + endLx) / 2;
        const lz = buildGeomStartZ + step * n;
        const worldPos = theModel
          ? theModel.localToWorld(new THREE.Vector3(lx, midY, lz))
          : new THREE.Vector3(lx, midY, lz);
        span.hotspot.position.copy(worldPos);
        const capturedKey = key;
        const capturedIdx = i;
        span.hotspot.setClickFunction(() => {
          this.placeAccessory(capturedKey, 'wallBack', capturedIdx);
          this.showHotspotsForAccessory(capturedKey);
        });
        setHotspotVisibility(span.hotspot, true);
        return;
      }

      if (zone !== 'wallLeft' && zone !== 'wallRight') {
        setHotspotVisibility(span.hotspot, false);
        return;
      }

      const i = span.number;
      // Item occupies modules [i … i+k-1]; must fit within [0, n-1]
      if (i + k - 1 > n - 1) {
        setHotspotVisibility(span.hotspot, false);
        return;
      }

      // Block if any org item already occupies any module in [i, i+k-1]
      // Exception: a table and a shelf can share the same span
      const spotTaken = allPlacedOrg.some(oi => {
        if (oi.zone !== zone) return false;
        if (isTableShelfPair(oi.accessoryKey, key)) return false;
        const oiK = ORG_WINDOW_COUNT[oi.accessoryKey] ?? 1;
        const oiI = oi.spanIndex;
        return i <= oiI + oiK - 1 && i + k - 1 >= oiI;
      });
      if (spotTaken) {
        setHotspotVisibility(span.hotspot, false);
        return;
      }

      // Block if any ventilation element occupies any module in [i, i+k-1] on this zone
      const blockedByVentilation = placedVentilation.some(e => {
        if (e.zone !== zone) return false;
        return e.spanIndex >= i && e.spanIndex <= i + k - 1;
      });
      if (blockedByVentilation) {
        setHotspotVisibility(span.hotspot, false);
        return;
      }

      // Different type needs 1-window gap; same type can be directly adjacent
      // Exception: table+shelf pair needs no gap and can share the same span
      const blockedByOrg = allPlacedOrg.some(oi => {
        if (oi.zone !== zone || oi.accessoryKey === key) return false;
        if (isTableShelfPair(oi.accessoryKey, key)) return false;
        const oiK = ORG_WINDOW_COUNT[oi.accessoryKey] ?? 1;
        const oiI = oi.spanIndex;
        return i <= oiI + oiK && i + k - 1 >= oiI - 1;
      });
      if (blockedByOrg) {
        setHotspotVisibility(span.hotspot, false);
        return;
      }

      // Position hotspot at the center of the occupied span range
      const lz = buildGeomFrameZ + step * i + step * k / 2;
      const lx = zone === 'wallLeft' ? -hw : hw;
      const worldPos = theModel
        ? theModel.localToWorld(new THREE.Vector3(lx, midY, lz))
        : new THREE.Vector3(lx, midY, lz);

      span.hotspot.position.copy(worldPos);

      const capturedKey = key;
      const capturedZone = zone;
      const capturedIdx = i;
      span.hotspot.setClickFunction(() => {
        this.placeAccessory(capturedKey, capturedZone, capturedIdx);
        this.showHotspotsForAccessory(capturedKey);
      });

      setHotspotVisibility(span.hotspot, true);
    });

    updateHotspots(hotspots);
    requestDelayedRender();
  }

  // organization meshs logic:
  applyOrgItemMesh(item, zone, spanIndex, visible) {
    const tag = `${item.key}__${zone}__${spanIndex}`;

    // Remove any existing clone for this placement slot
    const stale = [];
    scene.traverse(o => { if (o.userData?.accTag === tag) stale.push(o); });
    stale.forEach(o => o.parent?.remove(o));

    if (!visible) { requestDelayedRender(); return; }

    if (!TABLES_GLTF) {
      console.warn('[org] tables.glb not loaded yet');
      requestDelayedRender();
      return;
    }

    // pick shape type 
    const isSloping = +state.shapeType === 1;
    const meshKeyArr = Array.isArray(item.meshKey) ? item.meshKey : [item.meshKey, item.meshKey];
    const parentName = isSloping ? meshKeyArr[1] : meshKeyArr[0];

    let source = null;
    TABLES_GLTF.scene.traverse(o => { if (o.name === parentName && !source) source = o; });
    if (!source) {
      requestDelayedRender();
      return;
    }

    const clone = source.clone(true);
    clone.userData.accTag = tag;

    // Make everything visible, then apply material variant
    clone.visible = true;
    clone.traverse(o => {
      o.visible = true;
      if (o.isMesh) {
        o.castShadow = true;
        o.receiveShadow = true;
      }
    });

    //material variant: keys starting with 'plastic' → 'pl'
    const matKey = item.key.startsWith('plastic') ? 'pl'
      : item.key.startsWith('wood') ? 'wood'
        : null;
    applyMaterialVariant(clone, matKey);

    // Apply frame color (colorBody) to metall_paint material on items whose metal parts should match
    const ORG_METAL_PAINT_KEYS = new Set(['plasticTable1Win', 'plasticTable3Win', 'plasticShelf1Win', 'plasticShelf3Win', 'cultivationTable3Win', 'set2Shelves']);
    if (ORG_METAL_PAINT_KEYS.has(item.key)) {
      const hex = state.colorBody || '#C8C8C8';
      clone.traverse(c => {
        if (!c.isMesh || !c.material || c.material.name !== 'metall_paint') return;
        c.material = c.material.clone();
        c.material.color.set(hex);
        c.material.needsUpdate = true;
      });
    }

    const hw = buildModelHalfW || (state.width / 2);
    const k = ORG_WINDOW_COUNT[item.key] ?? 1;

    let posX, posZ, rotY;
    if (zone === 'wallBack') {
      const code = getCurrentSizeCode();
      const isSmall = SMALL_CODES.has(code);
      const offset = hw * 0.3;
      const backPositions = isSmall ? [0] : [-offset, offset];
      const startX = backPositions[spanIndex] ?? 0;
      const endX = backPositions[Math.min(spanIndex + k - 1, backPositions.length - 1)] ?? startX;
      posX = (startX + endX) / 2;
      const backWallNode = theModel?.getObjectByName('back_wall') ?? theModel?.getObjectByName('back_wall_door');
      if (backWallNode) {
        const wp = new THREE.Vector3();
        backWallNode.getWorldPosition(wp);
        const parentInv = new THREE.Matrix4().copy((theModel ?? scene).matrixWorld).invert();
        posZ = wp.clone().applyMatrix4(parentInv).z;
      } else {
        posZ = buildGeomStartZ + buildStepSize * (buildCopyAmount || 1);
      }
      rotY = Math.PI;
    } else {
      const bp = getActiveBuildParams();
      const orgZFraction = bp.orgZFraction ?? 0.27;
      const orgXFraction = bp.orgXFraction ?? 0.038;
      posX = zone === 'wallLeft' ? -(hw - orgXFraction) : (hw - orgXFraction);
      posZ = buildGeomFrameZOrg + buildStepSize * spanIndex + buildStepSize * (k / 2 + orgZFraction);
      rotY = zone === 'wallLeft' ? Math.PI / 2 : -Math.PI / 2;
    }

    clone.position.set(posX, 0, posZ);
    clone.rotation.set(0, rotY, 0);

    (theModel ?? scene).add(clone);
    requestDelayedRender();
  }

  // Heater mesh logic: clones from HEATER_PALMA_GLTF or HEATER_PHOENIX_GLTF
  applyHeaterMesh(item, zone, spanIndex, visible) {
    const tag = `${item.key}__${zone}__${spanIndex}`;

    // Remove any existing clone for this placement slot
    const stale = [];
    scene.traverse(o => { if (o.userData?.accTag === tag) stale.push(o); });
    stale.forEach(o => o.parent?.remove(o));

    if (!visible) { requestDelayedRender(); return; }

    const heaterGltf = item.key === 'standHeater' ? HEATER_PALMA_GLTF : HEATER_PHOENIX_GLTF;
    if (!heaterGltf) {
      requestDelayedRender();
      return;
    }

    const meshName = Array.isArray(item.meshKey) ? item.meshKey[0] : item.meshKey;
    let source = null;
    heaterGltf.scene.traverse(o => { if (o.name === meshName && !source) source = o; });
    if (!source) {
      source = heaterGltf.scene;
    }

    const clone = source.clone(true);
    clone.userData.accTag = tag;
    clone.visible = true;
    clone.traverse(o => {
      o.visible = true;
      if (o.isMesh) { o.castShadow = true; o.receiveShadow = true; }
    });

    const n = buildCopyAmount || 1;
    const step = buildStepSize || (state.length / n);
    const hw = buildModelHalfW || (state.width / 2);

    if (item.key === 'standHeater') {
      const lx = hw / 1.2;
      const lz = buildGeomFrameZ + step * 1 + step / 2;
      clone.position.set(lx, 0, lz);
      clone.rotation.set(0, -Math.PI / 2, 0);
    } else {
      // phoenixHeater: 
      const roofY = state.height > 0 ? state.height - 0.3 : 2.2;
      const lz = buildGeomFrameZ + step * n / 2;
      clone.position.set(0, roofY, lz);
      clone.rotation.set(0, 0, 0);
    }

    (theModel ?? scene).add(clone);
    requestDelayedRender();
  }

  // Place back door on a side wall (XH models only)
  placeBackDoorOnSide(wallSide, moduleIndex) {
    window._backDoorSide = wallSide;
    const sideZone = wallSide === 'left' ? 'wallLeft' : 'wallRight';
    this.placeAccessory('extraDoor', sideZone, moduleIndex);
  }

  // Show hotspots only on already-placed roof windows that do NOT yet have an automated opening
  showHotspotsForAutomatedOpening() {
    const model = theModel;
    const placed = this.placedAccessories ?? new Map();

    const n = buildCopyAmount || 1;
    const step = buildStepSize || (state.length / n);
    const hw = buildModelHalfW || (state.width / 2);
    const roofY = state.height > 0 ? state.height * 0.95 + 0.2 : 2.5;
    const modZ = (i) => buildGeomFrameZ + step * i + step / 2;

    // Collect spanIndexes where roofWindow is placed but automateOpening is not
    const availableSpans = new Set();
    for (const [, entry] of placed) {
      if (entry.accessoryKey !== 'roofWindow') continue;
      const autoKey = `automateOpening__${entry.zone}__${entry.spanIndex}`;
      if (!placed.has(autoKey)) {
        availableSpans.add(entry.spanIndex);
      }
    }

    this.span.objects.forEach(span => {
      const show = span.zone === 'roof' && availableSpans.has(span.number);

      if (show) {
        const mi = Math.floor(span.number / 2);
        const lx = span.number % 2 === 0 ? -hw * 0.45 : hw * 0.45;
        const lz = modZ(mi);

        const worldPos = model
          ? model.localToWorld(new THREE.Vector3(lx, roofY, lz))
          : new THREE.Vector3(lx, roofY, lz);

        span.hotspot.position.copy(worldPos);

        const _idx = span.number;
        span.hotspot.setClickFunction(() => {
          this.placeAccessory('automateOpening', 'roof', _idx);
          // Refresh: only show remaining available positions
          this.showHotspotsForAutomatedOpening();
        });
      }

      setHotspotVisibility(span.hotspot, show);
    });

    updateHotspots(hotspots);
    requestDelayedRender();
  }

  cloneSystemObject(type, direction, side, count) {
    const element = this.getSystem(null, type, direction);

    if (!element) {
      return;
    }

    for (let i = 0; i < count; i++) {
      const clonedMesh = element.object.clone();
      clonedMesh.visible = false;
      const parent = scene.getObjectByName("Scene");

      if (parent) {
        parent.add(clonedMesh);
      } else {
        scene.add(clonedMesh);
      }

      if (side === greenHouseConst.side.Right || side === greenHouseConst.side.Back) {
        clonedMesh.scale.z = -1;
      }

      const systemObject = new PergolaSystemObject();
      systemObject.name = element.name;
      systemObject.object = clonedMesh;
      systemObject.type = type;
      systemObject.direction = direction;
      systemObject.side = side;

      this.system.objects.push(systemObject);
    }
  }

  prepareSystems() {
    const n = buildCopyAmount || 3;

    this.cloneSystemObject(greenHouseConst.accessoriesType.autoShade, greenHouseConst.direction.Straight, greenHouseConst.side.Front, n - 1);
    this.cloneSystemObject(greenHouseConst.accessoriesType.privacyWall, greenHouseConst.direction.Straight, greenHouseConst.side.Front, n - 1);
    this.cloneSystemObject(greenHouseConst.accessoriesType.autoShade, greenHouseConst.direction.Straight, greenHouseConst.side.Back, n);
    this.cloneSystemObject(greenHouseConst.accessoriesType.privacyWall, greenHouseConst.direction.Straight, greenHouseConst.side.Back, n);
    this.cloneSystemObject(greenHouseConst.accessoriesType.autoShade, greenHouseConst.direction.Perpendicular, greenHouseConst.side.Left, n - 1);
    this.cloneSystemObject(greenHouseConst.accessoriesType.privacyWall, greenHouseConst.direction.Perpendicular, greenHouseConst.side.Left, n - 1);
    this.cloneSystemObject(greenHouseConst.accessoriesType.autoShade, greenHouseConst.direction.Perpendicular, greenHouseConst.side.Right, n);
    this.cloneSystemObject(greenHouseConst.accessoriesType.privacyWall, greenHouseConst.direction.Perpendicular, greenHouseConst.side.Right, n);
  }

  getSubsystemByTypeAndSide(type, side) {
    // Right/Back share objects with Left/Front (mirrored clones)
    const searchSide = (side === greenHouseConst.side.Right) ? greenHouseConst.side.Left
      : (side === greenHouseConst.side.Back) ? greenHouseConst.side.Front
        : side;
    return this.system.objects.find(s => s.type === type && s.side === searchSide) ?? null;
  }

  prepareSpans() {
    const spanColor = "#629A33";
    const spanGeometry = new THREE.BoxGeometry(1, 1, 1);
    const n = buildCopyAmount || 3;

    // zone → { side, qty }
    // wallFront / wallBack: single hotspot centered on the face
    // wallLeft / wallRight / roof: one hotspot per module (n total)
    const zoneDefs = [
      { zone: 'wallLeft', side: greenHouseConst.side.Left, qty: n },
      { zone: 'wallRight', side: greenHouseConst.side.Right, qty: n },
      { zone: 'wallFront', side: greenHouseConst.side.Front, qty: 1 },
      { zone: 'wallBack', side: greenHouseConst.side.Back, qty: n },
      { zone: 'roof', side: null, qty: n * 2 },
    ];

    zoneDefs.forEach(({ zone, side, qty }) => {
      for (let i = 0; i < qty; i++) {
        const span = new PergolaSpanObject();
        span.side = side;
        span.zone = zone;
        span.number = i;

        const spanMaterial = new THREE.MeshBasicMaterial({
          color: spanColor, transparent: true, depthWrite: false, opacity: 0,
        });
        const spanAvatar = new THREE.Mesh(spanGeometry, spanMaterial);
        spanAvatar.position.set(0, 0, 0);
        spanAvatar.visible = false;
        spanAvatar.name = `avatar_${zone}_${i}`;
        spanAvatar.parentSpan = span;

        if (side !== null) {
          clickableObjects.push(spanAvatar);
          theModel.add(spanAvatar);
        }
        span.avatar = spanAvatar;

        span.hotspot = createHotspot(
          `span_hotspot_${zone}_${i}`,
          labelObjects.addObject.url,
          labelObjects.addObjectHover.url,
          new THREE.Vector3(0, 0, 0),
          "subsystems"
        );
        setHotspotVisibility(span.hotspot, false);
        hotspots.push(span.hotspot);

        // Link wall-side spans to their system objects
        if (side !== null) {
          const subsystems = Object.values(greenHouseConst.accessoriesType)
            .map(type => this.getSubsystemByTypeAndSide(type, side))
            .filter(Boolean);
          span.systems.push(...subsystems);
        }

        this.span.objects.push(span);
      }
    });
  }


  applyBackDoorSide(side) {
    window._backDoorSide = side;
    const model = theModel;
    if (!model) return;

    // XH models use side_door_L / side_door_R — re-apply wall position + rotation flip
    const XH_SIDE_CODES_APPLY = new Set(['R306XH', 'R308XH']);
    if (XH_SIDE_CODES_APPLY.has(getCurrentSizeCode())) {
      const sideDoor = [model.getObjectByName('side_door_R'), model.getObjectByName('side_door_L')]
        .find(d => d?.visible);
      if (sideDoor?.visible) {
        const hw = buildModelHalfW || state.width / 2;
        const isRight = side === 'right';
        const origParent = sideDoor.parent;
        const origRotY = sideDoor.userData.xhOrigRotY ?? sideDoor.rotation.y;
        if (origParent) {
          scene.attach(sideDoor);
          sideDoor.position.x = isRight ? hw : -hw;
          sideDoor.rotation.y = isRight ? origRotY + Math.PI : origRotY;
          origParent.attach(sideDoor);
        }
        requestDelayedRender();
        return;
      }

      const xhBackDoorWall = model.getObjectByName('back_door_wall');
      const xhBackDoor = xhBackDoorWall?.getObjectByName('back_door');
      if (xhBackDoor?.visible) {
        if (xhBackDoorWall.userData.origScaleZ === undefined) {
          xhBackDoorWall.userData.origScaleZ = xhBackDoorWall.scale.z || 1;
        }
        const origZ = xhBackDoorWall.userData.origScaleZ;
        xhBackDoorWall.scale.z = side === 'left' ? origZ : -Math.abs(origZ);

        // Shift the entire back_door_wall in world X to fine-tune position after flip.
        // position.x is unambiguous world X regardless of rotation/scale transforms on children.
        if (xhBackDoorWall.userData.origPosX === undefined) xhBackDoorWall.userData.origPosX = xhBackDoorWall.position.x;
        const origPosX = xhBackDoorWall.userData.origPosX;
        xhBackDoorWall.position.x = side === 'right'
          ? origPosX + (getActiveBuildParams().xhBackDoorWallRightX ?? 0.1)
          : origPosX;

        requestDelayedRender();
      }
      return;
    }

    const backDoor = model.getObjectByName('back_wall_door') ?? model.getObjectByName('back_wall_doors');
    if (!backDoor || !backDoor.visible) return;

    // Mirror entire back_wall_door group.
    // R300H has its back-door mesh oriented opposite to other models — flip scale.z for that model only.
    const bp = getActiveBuildParams();
    const flip = bp.backDoorFlipSide ?? false;
    const opensLeft = flip ? side !== 'left' : side === 'left';
    backDoor.scale.z = opensLeft
      ? -Math.abs(backDoor.scale.z || 1)
      : Math.abs(backDoor.scale.z || 1);

    // Models where bp.backDoorXLeft/Right should take priority over userData.spanX:
    // R200H and R300H both need explicit per-side X positioning (not span-based).
    // R300H was broken when XH code introduced userData.spanX priority for non-R200H models.
    const R200H_BACK_CODES = new Set(['R204H', 'R205H']);
    const isR200HBack = R200H_BACK_CODES.has(getCurrentSizeCode());
    const BP_X_PRIORITY_CODES = new Set(['R204H', 'R205H', 'R305H', 'R306H', 'R308H']);
    const useBpXFirst = BP_X_PRIORITY_CODES.has(getCurrentSizeCode());
    if (side === 'left') {
      backDoor.position.x = useBpXFirst
        ? (bp.backDoorXLeft ?? backDoor.userData.spanX ?? -0.08)
        : (backDoor.userData.spanX ?? bp.backDoorXLeft ?? -0.08);
    } else {
      backDoor.position.x = useBpXFirst
        ? (bp.backDoorXRight ?? backDoor.userData.spanX ?? (backDoor.userData.originPos?.x ?? 0) + 0.04)
        : (backDoor.userData.spanX ?? bp.backDoorXRight ?? (backDoor.userData.originPos?.x ?? 0) + 0.04);
    }

    // S100H (back_wall_doors): when scale.z = -1 (opensLeft), flip scale.x instead of scale.z.
    // Parent Z=-1 + child X=-1 → combined det = +1 → winding preserved (logo visible).
    // Net X scale = -1 → logo content is horizontally mirrored, which is the correct appearance
    // for a left-side door. Position.z is counteracted so world Z stays the same.
    if (backDoor.name === 'back_wall_doors') {
      const logoMesh = backDoor.getObjectByName('door_logo001');
      if (logoMesh) {
        if (logoMesh.userData.origScaleX === undefined) {
          logoMesh.userData.origScaleX = logoMesh.scale.x;
          logoMesh.userData.origScaleZ = logoMesh.scale.z;
          logoMesh.userData.origPosZ = logoMesh.position.z;
        }
        if (opensLeft) {
          logoMesh.scale.x = -Math.abs(logoMesh.userData.origScaleX || 1);
          logoMesh.scale.z = Math.abs(logoMesh.userData.origScaleZ || 1);
          logoMesh.position.z = -logoMesh.userData.origPosZ;
        } else {
          logoMesh.scale.x = Math.abs(logoMesh.userData.origScaleX || 1);
          logoMesh.scale.z = Math.abs(logoMesh.userData.origScaleZ || 1);
          logoMesh.position.z = logoMesh.userData.origPosZ;
        }
      }
      requestDelayedRender();
      return;
    }

    const mosquitoBackLogo = model.getObjectByName('door_mosquito_back_logo');
    const backDoorLogo = model.getObjectByName('back_door_logo');
    const activeLogo = opensLeft ? (mosquitoBackLogo ?? backDoorLogo) : (backDoorLogo ?? mosquitoBackLogo);
    const inactiveLogo = opensLeft
      ? (mosquitoBackLogo ? backDoorLogo : null)
      : (backDoorLogo ? mosquitoBackLogo : null);

    if (inactiveLogo) {
      inactiveLogo.visible = false;
      inactiveLogo.traverse(o => { o.visible = false; });
    }

    if (activeLogo) {
      const propRe = /\.(position|quaternion|scale|morphTargetInfluences)$/;
      const gltf = IMPORTED_MODELS_GLTF.find(g => g?.scene === model) ?? IMPORTED_MODELS_GLTF[0];
      let backDoorPivot = null;
      if (gltf?.animations) {
        const backDoorNames = new Set();
        backDoor.traverse(o => { if (o.name) backDoorNames.add(o.name); });
        outer: for (const clip of gltf.animations) {
          for (const track of clip.tracks) {
            const objName = track.name.replace(propRe, '');
            if (backDoorNames.has(objName)) {
              const obj = model.getObjectByName(objName);
              if (obj && obj !== backDoor) { backDoorPivot = obj; break outer; }
            }
          }
        }
      }

      if (backDoorPivot) {
        const needsReparent = activeLogo.parent !== backDoorPivot;
        if (needsReparent) backDoorPivot.attach(activeLogo);
        if (needsReparent && activeLogo.userData.restModelPos) {
          const spanX = backDoor.userData.spanX;
          const savedX = backDoor.position.x;
          const savedScaleZ = backDoor.scale.z;
          const restScaleZ = activeLogo.userData.restBackDoorScaleZ ?? 1;
          const xChanged = spanX != null && savedX !== spanX;
          const szChanged = savedScaleZ !== restScaleZ;
          if (xChanged) backDoor.position.x = spanX;
          if (szChanged) backDoor.scale.z = restScaleZ;
          if (xChanged || szChanged) backDoor.updateWorldMatrix(true, true);
          backDoorPivot.updateWorldMatrix(true, false);
          activeLogo.position.copy(
            backDoorPivot.worldToLocal(activeLogo.userData.restModelPos.clone().applyMatrix4(model.matrixWorld))
          );
          if (xChanged) backDoor.position.x = savedX;
          if (szChanged) backDoor.scale.z = savedScaleZ;
          if (xChanged || szChanged) backDoor.updateWorldMatrix(true, true);
        }
        {
          backDoorPivot.updateWorldMatrix(true, false);
          const logoWorldX = backDoorPivot.localToWorld(activeLogo.position.clone()).x;
          const invE = new THREE.Matrix4().copy(backDoorPivot.matrixWorld).invert().elements;
          // R200H: pivot is at door center → snap to pivot world X.
          // Other models (e.g. S200H): pivot is at the hinge edge, not door center →
          // snap to bounding-box center of the door panel instead.
          let targetX;
          let pivotBox = null;
          if (isR200HBack) {
            targetX = backDoorPivot.getWorldPosition(new THREE.Vector3()).x;
          } else {
            // backDoorPivot bbox reflects scale.z=±1 flip → true panel center per side.
            pivotBox = new THREE.Box3().setFromObject(backDoorPivot);
            targetX = (pivotBox.min.x + pivotBox.max.x) / 2;
          }
          const xErr = logoWorldX - targetX;
          if (Math.abs(xErr) > 0.001) {
            activeLogo.position.addScaledVector(new THREE.Vector3(invE[0], invE[1], invE[2]), -xErr);
          }
          if (isR200HBack && opensLeft) {
            const R200H_BACK_LOGO_Z_OFFSET = 0.036;
            activeLogo.position.addScaledVector(new THREE.Vector3(invE[8], invE[9], invE[10]), R200H_BACK_LOGO_Z_OFFSET);
          } else if (!isR200HBack && bp.backLogoZ !== undefined) {
            // Use door panel bbox center Z — always tracks current door position (S206H↔S208H safe)
            pivotBox ??= new THREE.Box3().setFromObject(backDoorPivot);
            const doorCenterZ = (pivotBox.min.z + pivotBox.max.z) / 2;
            const targetWorldZ = doorCenterZ + (bp.backLogoZ ?? 0);
            const logoWorldZ = backDoorPivot.localToWorld(activeLogo.position.clone()).z;
            const zErr = logoWorldZ - targetWorldZ;
            if (Math.abs(zErr) > 0.0001) {
              activeLogo.position.addScaledVector(new THREE.Vector3(invE[8], invE[9], invE[10]), -zErr);
            }
          }
        }
        activeLogo.rotation.set(0, 0, 0);
        activeLogo.scale.set(opensLeft ? -1 : 1, 1, 1);
        activeLogo.userData.restPos = activeLogo.position.clone();
        activeLogo.userData.restQuat = activeLogo.quaternion.clone();
        activeLogo.userData.restScale = activeLogo.scale.clone();
      } else {
        if (activeLogo.parent !== backDoor) {
          activeLogo.parent?.remove(activeLogo);
          backDoor.add(activeLogo);
        }
        activeLogo.position.set(0, 0, 0);
        activeLogo.rotation.set(0, 0, 0);
        activeLogo.scale.set(opensLeft ? -1 : 1, 1, 1);
        activeLogo.userData.restPos = activeLogo.position.clone();
        activeLogo.userData.restQuat = activeLogo.quaternion.clone();
        activeLogo.userData.restScale = activeLogo.scale.clone();
      }

      activeLogo.visible = true;
      activeLogo.traverse(o => { o.visible = true; });
    }

    requestDelayedRender();
  }

  changeMoodLedColor(value) {
    if (value == null) {
      return;
    }

    const moodLedObjects = this.extraOptions.elements.filter(
      (item) => item.type == PergolaExtraOptionType.moodLed
    );

    moodLedObjects[0].object.material.color.set(value);
    moodLedObjects[0].object.material.emissive.set(value);
    // moodLedObjects[0].object.material.emissiveIntensity = 5;
  }

  changeObjectVisibility(status, object) {
    if (object == null) {
      return;
    }

    object.visible = status;

    if (object.isGroup) {
      for (let index = 0; index < object.children.length; index++) {
        const ge = object.children[index];
        ge.visible = status;
      }
    }
  }

  changeObjectArrayVisibility(status, objectArray) {
    if (objectArray == null || objectArray.length == 0) {
      return;
    }

    for (let f = 0; f < objectArray.length; f++) {
      const element = objectArray[f];
      if (element.object.isGroup) {
        for (let index = 0; index < element.object.children.length; index++) {
          const obj = element.object.children[index];
          obj.visible = status;
        }
        element.object.visible = status;
        element.active = status;
      } else {
        element.object.visible = status;
        element.active = status;
      }
    }
  }
}

export class PergolaSettings {
  constructor() {
    this.width = null;
    this.length = null;
    this.height = null;
    this.colorHex = 0;
    this.colorAccessoriesHex = 0;
    this.extraOption = null
  }

  getValues() {
    var values = [
      {
        name: "Dimensions",
        value: pergolaSettings.toString_dimensions(),
        options: null,
      },
      {
        name: "FRAME COLOR",
        value: pergolaSettings.toString_color(),
        options: null,
      },
      {
        name: "Wall Mounted",
        value: pergolaSettings.toString_mountingWall(),
        options: null,
      },
      {
        name: "Side Options",
        value: "",
        options: [
          ["Perimeter LED lights", pergolaSettings.toString_extraOptions_Led()],
          ["Heater", pergolaSettings.toString_extraOptions_Heater()],
        ],
      },
    ];

    return values;
  }

  toString_dimensions() {
    return `Width: ${this.width}', Projection:${this.length}', Height: ${this.height}'`;
  }

  toString_color() {
    return this.colorHex.toUpperCase();
  }
}

class PergolaDimensions {
  constructor() {
    this.width = 8;
    this.length = 8;
    this.height = 8;
  }
}



// Клас для кольору
class PergolaColorElement {
  constructor() {
    this.name = "Espresso";
    this.select = null;
    this.hex = "";
    this.ral = "";
  }
}

//* SYSTEMS
class PergolaSystem {
  constructor() {
    this.objects = [];
  }
}

//* SPAN
class PergolaSpan {
  constructor() {
    this.objects = [];
  }
}

class PergolaSpanObject {
  constructor() {
    this.side = null;
    this.number = 0;
    this.width = null;
    this.height = null;
    this.posX = 0;
    this.posY = 0;
    this.posZ = 0;
    this.offsetY = 0.2;
    this.avatar = null;
    this.hotspot = null;
    this.active = false;
    this.isSystemSet = false;
    this.activeaccessoriesType = null;
    this.systems = [];
    this.isLocked = false;

    this.getCurrentSystem = () => {
      return this.systems.find((system) => {
        return this.activeaccessoriesType !== null
          ? system.type === this.activeaccessoriesType
          : system.active;
      });
    };
  }
}

class PergolaSystemObject {
  constructor() {
    this.name = "";
    this.type = null;
    this.spanWidth = null;
    this.spanHeight = null;
    this.direction = null;
    this.side = null;
    this.posX = 0;
    this.posZ = 0;
    this.openingside = null;
    this.openValue = 0;
    this.color = null;
    this.object = null;
    this.active = false;
    this.isLocked = false;
    this.windowObject = null;
    this.windowPosX = 0;
    this.windowPosZ = 0;
    this.doorQty = 0;
  }
}

// Клас для додаткових опцій
class PergolaExtraOptions {
  constructor() {
    this.elements = [];
  }
}

// Клас для додаткових елементів
class PergolaExtraOptionElement {
  constructor() {
    this.type = null;
    this.active = false;
    this.object = null;
    this.objects = [];
  }
}

const PergolaExtraOptionType = {
  light: 0,
  fan: 1,
  heater: 2,
  led: 3,
  moodLight: 4,
  moodLed: 5,
};

var pergolaSettings = new PergolaSettings();


pergolaSettings.width = 18; // 18
pergolaSettings.length = 12; // 12
pergolaSettings.height = 8; // 8
pergolaSettings.colorHex = "#281F1E";
pergolaSettings.colorAccessoriesHex = "#281F1E";
pergolaSettings.extraOption = false;

var blockURLWriter = true;
export var pergola = new PergolaObject();

// Returns the code string for the currently selected size (e.g. "R306XH")
export function getCurrentSizeCode() {
  const sizes = SIZE_DATA[+state.shapeType];
  return (sizes?.[state.sizeIndex] ?? sizes?.[0])?.code ?? '';
}

const PALMA_CODES = new Set(['R204H', 'R205H', 'R305H', 'S104H']);
const PHOENIX_CODES = new Set(['R306H', 'R308H', 'S106H', 'S206H', 'S208H', 'R306XH', 'R308XH']);

const TWODEFAULTWINDOWS_CODES = new Set(['S106H', 'S206H', 'R306H', 'R306XH']);
const FOURDEFAULTWINDOWS_CODES = new Set(['R308H', 'S208H', 'R308XH']);

// Places the correct number of default (permanent) roof windows for the active size.
// Even spanIndex = left slope, odd = right slope; moduleIndex = floor(spanIndex/2).
function placeDefaultRoofWindows() {
  if (buildCopyAmount < 3) return;
  const code = getCurrentSizeCode();
  const base = buildCopyAmount - 2; // always even for the models in both sets

  if (FOURDEFAULTWINDOWS_CODES.has(code)) {
    // 4 windows staggered: right at mod B-1, left at mod B, gap, right at mod B+2, left at mod B+3
    pergola.placeAccessory('roofWindow', 'roof', base - 1, { permanent: true });
    pergola.placeAccessory('roofWindow', 'roof', base, { permanent: true });
    pergola.placeAccessory('roofWindow', 'roof', base + 5, { permanent: true });
    pergola.placeAccessory('roofWindow', 'roof', base + 6, { permanent: true });
  } else if (TWODEFAULTWINDOWS_CODES.has(code)) {
    // 2 windows staggered: right at mod B-1, left at mod B
    pergola.placeAccessory('roofWindow', 'roof', base - 1, { permanent: true });
    pergola.placeAccessory('roofWindow', 'roof', base, { permanent: true });
  } else {
    // Single default window (original behaviour)
    pergola.placeAccessory('roofWindow', 'roof', (buildCopyAmount - 3) * 2, { permanent: true });
  }
}

// Returns which heater is allowed for the active size: 'palma' | 'phoenix' | null
export function getAllowedHeaterForCurrentSize() {
  const code = getCurrentSizeCode();
  if (PALMA_CODES.has(code)) return 'palma';
  if (PHOENIX_CODES.has(code)) return 'phoenix';
  return null;
}

const EXTRA_DOUBLE_DOOR_CODES = new Set(['R305H', 'R306H', 'R308H', 'S206H', 'S208H', 'R306XH', 'R308XH']);

export function isExtraDoubleDoorAllowed() {
  return EXTRA_DOUBLE_DOOR_CODES.has(getCurrentSizeCode());
}

export function showHotspotsForAccessory(key) { pergola.showHotspotsForAccessory(key); }
export function showHotspotsForAutomatedOpening() { pergola.showHotspotsForAutomatedOpening(); }
export function showHotspotsForExtraDoor() { pergola.showHotspotsForExtraDoor(); }
export function showHotspotsForExtraDoubleDoor() { pergola.showHotspotsForExtraDoubleDoor(); }
export function showHotspotsForDownpipes() { pergola.showHotspotsForDownpipes(); }
export function hideAllAccessoryHotspots() { pergola.hideAllAccessoryHotspots(); }
export function applyBackDoorSide(side) { pergola.applyBackDoorSide(side); }

// Returns all cloned auto-window objects currently placed in the scene
export function getPlacedAutoWindowClones() {
  const clones = [];
  if (!scene) return clones;
  scene.traverse(o => {
    if (o.userData?.accTag?.startsWith('automateOpening__')) clones.push(o);
  });
  return clones;
}
export function placeAccessory(key, zone, spanIndex) { return pergola.placeAccessory(key, zone, spanIndex); }
export function removePlacedAccessory(key, zone, spanIndex) { return pergola.removePlacedAccessory(key, zone, spanIndex); }
export function removeAccessory(key) { pergola.removeAccessory(key); }
export function getAccessoryData(key) { return PergolaObject.getAccessoryData(key); }

//************* */ Mesh-click animation ****************
const _meshClickRaycaster = new THREE.Raycaster();
const _meshClickMouse = new THREE.Vector2();
// Track active mixers so we can reset them on the next click
const _meshClickMixers = [];
window._meshClickMixers = _meshClickMixers;
// Incremented on every click so stale RAF ticks from a previous click self-cancel
let _meshClickGen = 0;
// Track open/closed state per target: key = cloneRoot.uuid (PATH A) or 'model' (PATH B)
const _meshClickOpenState = new Map();

export function initMeshClickAnimation() {
  const canvasEl = renderer?.domElement;
  if (!canvasEl) return;

  // Extracts the object name from a Three.js track name like "Object.001.quaternion"
  // Property is always one of these known suffixes.
  const propRe = /\.(position|quaternion|scale|morphTargetInfluences)$/;
  const trackObjName = (trackName) => {
    const prop = trackName.match(propRe)?.[0] ?? '';
    return trackName.slice(0, trackName.length - prop.length);
  };

  let _startX = 0, _startY = 0, _moved = false;

  // Cache names of all objects that have animation clips (lazily built)
  let _animatableNames = null;
  const getAnimatableNames = () => {
    if (_animatableNames) return _animatableNames;
    const gltf = IMPORTED_MODELS_GLTF[0];
    if (!gltf?.animations?.length) return new Set();
    _animatableNames = new Set();
    gltf.animations.forEach(clip => {
      clip.tracks.forEach(t => { _animatableNames.add(trackObjName(t.name)); });
    });
    return _animatableNames;
  };

  const hitHasAnimation = (hitObject) => {
    const names = getAnimatableNames();
    // Check ancestor chain (covers original-model meshes like door)
    let o = hitObject;
    while (o && o !== scene) {
      if (names.has(o.name)) return true;
      o = o.parent;
    }
    // Check accTag clone subtree (covers placed auto-window clones)
    let clone = null;
    let c = hitObject;
    while (c && c !== scene) {
      if (c.userData?.accTag) { clone = c; break; }
      c = c.parent;
    }
    if (clone) {
      let found = false;
      clone.traverse(ch => { if (!found && names.has(ch.name)) found = true; });
      return found;
    }
    return false;
  };

  canvasEl.addEventListener('mousedown', e => {
    _startX = e.offsetX; _startY = e.offsetY; _moved = false;
  });
  canvasEl.addEventListener('mousemove', e => {
    if (Math.abs(e.offsetX - _startX) > 4 || Math.abs(e.offsetY - _startY) > 4) _moved = true;

    if (!theModel) return;
    _meshClickMouse.x = (e.offsetX / canvasEl.clientWidth) * 2 - 1;
    _meshClickMouse.y = -(e.offsetY / canvasEl.clientHeight) * 2 + 1;
    _meshClickRaycaster.setFromCamera(_meshClickMouse, camera);

    const hoverHits = [
      ..._meshClickRaycaster.intersectObject(theModel, true),
      ..._meshClickRaycaster.intersectObjects(
        scene.children.filter(o => o.userData?.accTag), true
      ),
    ].filter(h => !h.object.name.startsWith('avatar_'));

    if (hoverHits.some(h => hitHasAnimation(h.object))) {
      canvasEl.style.cursor = 'pointer';
    }
  });

  canvasEl.addEventListener('mouseup', e => {
    if (_moved) return;

    _meshClickMouse.x = (e.offsetX / canvasEl.clientWidth) * 2 - 1;
    _meshClickMouse.y = -(e.offsetY / canvasEl.clientHeight) * 2 + 1;
    _meshClickRaycaster.setFromCamera(_meshClickMouse, camera);

    if (!theModel) return;

    // Raycast the main model + any accTag clones that live in scene directly
    const hits = _meshClickRaycaster.intersectObject(theModel, true);
    const sceneHits = _meshClickRaycaster.intersectObjects(
      scene.children.filter(o => o.userData?.accTag), true
    );
    // Skip hotspot avatars (named avatar_*) — they sit in front of real meshes
    const all = [...hits, ...sceneHits]
      .filter(h => !h.object.name.startsWith('avatar_'))
      .sort((a, b) => a.distance - b.distance);
    console.log('[meshClick] hits (filtered):', all.map(h => h.object.name));
    if (!all.length) return;

    const gltf = IMPORTED_MODELS_GLTF.find(g => g?.scene === theModel) ?? IMPORTED_MODELS_GLTF[0];
    if (!gltf?.animations?.length) return;

    const findCloneRoot = (startObj) => {
      let o = startObj;
      while (o && o !== scene) {
        if (o.userData?.accTag) return o;
        o = o.parent;
      }
      return null;
    };

    // Prefer automateOpening__ clones (may be behind manual window clone in ray order)
    let cloneRoot = null;
    for (const hit of all) {
      const root = findCloneRoot(hit.object);
      if (root?.userData?.accTag?.startsWith('automateOpening__')) {
        cloneRoot = root;
        break;
      }
    }
    if (!cloneRoot) {
      cloneRoot = findCloneRoot(all[0].object);
    }

    _meshClickMixers.forEach(m => m.stopAllAction());
    _meshClickMixers.length = 0;
    const clickGen = ++_meshClickGen;

    let mixer, relevantClips;

    if (cloneRoot) {
      // clicked a placed clone (auto-window, manual window, etc.)
      const nameToUUID = new Map();
      nameToUUID.set(cloneRoot.name, cloneRoot.uuid);
      cloneRoot.traverse(o => { if (o.name) nameToUUID.set(o.name, o.uuid); });
      const cloneNames = new Set(nameToUUID.keys());

      relevantClips = gltf.animations.filter(a =>
        a.tracks.some(t => cloneNames.has(trackObjName(t.name)))
      );
      if (!relevantClips.length) return;

      const isOpen = _meshClickOpenState.get(cloneRoot.uuid) ?? false;
      _meshClickOpenState.set(cloneRoot.uuid, !isOpen);

      mixer = new THREE.AnimationMixer(cloneRoot);
      relevantClips.forEach(origClip => {
        const retargetedTracks = origClip.tracks.map(t => {
          const prop = t.name.match(propRe)?.[0] ?? '';
          const objName = trackObjName(t.name);
          const uuid = nameToUUID.get(objName);
          return Object.assign(t.clone(), { name: uuid ? (uuid + prop) : t.name });
        });
        const clip = new THREE.AnimationClip(origClip.name, origClip.duration, retargetedTracks);
        const action = mixer.clipAction(clip);
        action.setLoop(THREE.LoopOnce, 1);
        action.clampWhenFinished = true;
        if (isOpen) {
          action.reset();
          action.time = clip.duration;
          action.timeScale = -1;
        } else {
          action.reset();
          action.timeScale = 1;
        }
        action.play();
        mixer.update(0.001);
      });

    } else {
      // clicked an original-model mesh 
      const ancestorNames = new Set();
      let cur = all[0].object;
      while (cur && cur !== theModel.parent) {
        if (cur.name) ancestorNames.add(cur.name);
        cur = cur.parent;
      }

      relevantClips = gltf.animations.filter(a =>
        a.tracks.some(t => ancestorNames.has(trackObjName(t.name)))
      );
      if (!relevantClips.length) return;

      // if ANY hit is inside a mosquito door subtree (not just all[0] — when mosquito is open
      // the door mesh overlaps and may be the closest hit, masking the mosquito mesh)
      const frontMosqRoot = theModel.getObjectByName('door_mosquito');
      const backMosqRoot = theModel.getObjectByName('door_mosquito_back')
        ?? theModel.getObjectByName('door_mosquito001');
      let clickedMosqRoot = null;
      outerMosq: for (const hit of all) {
        for (const root of [frontMosqRoot, backMosqRoot]) {
          if (root?.visible) root.traverse(o => { if (o === hit.object) clickedMosqRoot = root; });
          if (clickedMosqRoot) break outerMosq;
        }
      }

      if (clickedMosqRoot) {
        const mosqSubtreeNames = new Set();
        clickedMosqRoot.traverse(o => { if (o.name) mosqSubtreeNames.add(o.name); });

        // Use gltf.animations directly so the key is stable regardless of which hit object was first
        const mosqAnimClips = gltf.animations.filter(a => a.tracks.some(t => mosqSubtreeNames.has(trackObjName(t.name))));
        const mosqKey = mosqAnimClips.map(c => c.name).sort().join('|');
        const mosqOpen = _meshClickOpenState.get(mosqKey) ?? false;
        _meshClickOpenState.set(mosqKey, !mosqOpen);

        // Detect parent door root FIRST so its subtree names can be excluded from mosquito clips
        const logoNamesD = new Set(['door_mosquito_logo', 'door_logo', 'door_mosquito_back_logo', 'back_door_logo', 'door_logo_L', 'door_logo_R', 'door_mosquito_logo_L', 'door_mosquito_logo_R']);
        let parentDoorRoot = null;
        {
          const candidates = ['front_wall', 'back_wall_door', 'back_wall_doors', 'front_wall_double', 'back_wall_double'];
          for (const name of candidates) {
            const obj = theModel.getObjectByName(name);
            if (!obj || !obj.visible) continue;
            let found = false;
            obj.traverse(o => { if (o === clickedMosqRoot || o === clickedMosqRoot.parent) found = true; });
            if (found) { parentDoorRoot = obj; break; }
          }
          if (!parentDoorRoot) {
            const animatedNames = new Set();
            gltf.animations.forEach(clip => clip.tracks.forEach(t => animatedNames.add(trackObjName(t.name))));
            let cur = clickedMosqRoot.parent;
            while (cur && cur !== theModel) {
              if (animatedNames.has(cur.name) && cur.visible) { parentDoorRoot = cur; break; }
              cur = cur.parent;
            }
          }
        }

        // Build parent door subtree names to exclude from mosquito clips (prevents door tracks
        // in a shared GLTF clip from being played during the mosquito animation).
        // Remove mosquito subtree names from the exclusion set — mosquito is a child of the door,
        // so its names appear in the door subtree too; excluding them would empty the mosquito clips.
        const parentDoorExcludeNamesB = new Set();
        if (parentDoorRoot) {
          parentDoorRoot.traverse(o => { if (o.name) parentDoorExcludeNamesB.add(o.name); });
          for (const n of mosqSubtreeNames) parentDoorExcludeNamesB.delete(n);
        }

        const mosqSafeClips = mosqAnimClips.map(clip => {
          const safeTracks = clip.tracks.filter(t => {
            const n = trackObjName(t.name);
            return mosqSubtreeNames.has(n) && !parentDoorExcludeNamesB.has(n);
          });
          return new THREE.AnimationClip(clip.name, clip.duration, safeTracks);
        }).filter(clip => clip.tracks.length > 0);

        const playMosqB = (onFinish) => {
          // When closing (mosqOpen=true), stopAllAction() on the previous click unbound the door's
          // PropertyMixers, which snapped door back to its default (closed) position.
          // Re-apply door=open immediately and hold it there while mosquito animates.
          let doorHoldMixer = null;
          if (mosqOpen && parentDoorRoot) {
            doorHoldMixer = new THREE.AnimationMixer(theModel);
            const holdDoorNames = new Set();
            parentDoorRoot.traverse(o => { if (o.name) holdDoorNames.add(o.name); });
            gltf.animations
              .filter(a => a.tracks.some(t => holdDoorNames.has(trackObjName(t.name))))
              .map(clip => {
                const st = clip.tracks.filter(t => !logoNamesD.has(trackObjName(t.name)) && !mosqSubtreeNames.has(trackObjName(t.name)));
                return st.length === clip.tracks.length ? clip : new THREE.AnimationClip(clip.name, clip.duration, st);
              })
              .filter(c => c.tracks.length > 0)
              .forEach(clip => {
                const a = doorHoldMixer.clipAction(clip);
                a.setLoop(THREE.LoopOnce, 1);
                a.clampWhenFinished = true;
                a.reset(); a.time = clip.duration; a.timeScale = -0.000001; a.play();
              });
            doorHoldMixer.update(0.001); // apply door=open transforms immediately
          }

          const mosqMixer = new THREE.AnimationMixer(theModel);
          mosqMixer.userData = {};
          _meshClickMixers.push(mosqMixer);
          mosqSafeClips.forEach(clip => {
            const action = mosqMixer.clipAction(clip);
            action.setLoop(THREE.LoopOnce, 1);
            action.clampWhenFinished = true;
            if (mosqOpen) { action.reset(); action.time = clip.duration; action.timeScale = -1; }
            else { action.reset(); action.timeScale = 1; }
            action.play();
          });
          mosqMixer.update(0.001);
          let lastT = performance.now();
          const tick = () => {
            if (_meshClickGen !== clickGen) return;
            const now = performance.now();
            const dt = (now - lastT) / 1000;
            if (doorHoldMixer) doorHoldMixer.update(dt); // keep door visually open while mosquito closes
            mosqMixer.update(dt);
            lastT = now;
            requestDelayedRender();
            if (mosqMixer._actions?.some(a => a.isRunning())) requestAnimationFrame(tick);
            else {
              if (doorHoldMixer) doorHoldMixer.stopAllAction(); // release door before playParentDoorB takes over
              if (onFinish) onFinish();
            }
          };
          requestAnimationFrame(tick);
        };

        const doorOpenStateKey = `_doorOpen_${parentDoorRoot?.name ?? 'front'}`;
        const isDoorOpen = window[doorOpenStateKey] ?? false;


        // Helper: play parent door clips (forward or reverse)
        const playParentDoorB = (reverse, onDone) => {
          if (!parentDoorRoot) { onDone(); return; }
          const parentDoorNames = new Set();
          parentDoorRoot.traverse(o => { if (o.name) parentDoorNames.add(o.name); });
          const parentClips = gltf.animations.filter(a =>
            a.tracks.some(t => parentDoorNames.has(trackObjName(t.name)))
          ).map(clip => {
            const safeTracks = clip.tracks.filter(t => !logoNamesD.has(trackObjName(t.name)) && !mosqSubtreeNames.has(trackObjName(t.name)));
            return safeTracks.length === clip.tracks.length ? clip : new THREE.AnimationClip(clip.name, clip.duration, safeTracks);
          }).filter(clip => clip.tracks.length > 0);
          if (!parentClips.length) { onDone(); return; }
          window[doorOpenStateKey] = !reverse;
          window._mainDoorIsOpen = !reverse;
          const preMixerB = new THREE.AnimationMixer(theModel);
          _meshClickMixers.push(preMixerB);
          parentClips.forEach(clip => {
            const action = preMixerB.clipAction(clip);
            action.setLoop(THREE.LoopOnce, 1);
            action.clampWhenFinished = true;
            if (reverse) { action.reset(); action.time = clip.duration; action.timeScale = -1; }
            else { action.reset(); action.timeScale = 1; }
            action.play();
          });
          preMixerB.update(0.001);
          let lastT = performance.now();
          const preTick = () => {
            if (_meshClickGen !== clickGen) return; // superseded by a newer click
            const now = performance.now();
            preMixerB.update((now - lastT) / 1000);
            lastT = now;
            requestDelayedRender();
            if (preMixerB._actions?.some(a => a.isRunning())) requestAnimationFrame(preTick); else onDone();
          };
          requestAnimationFrame(preTick);
        };

        if (mosqOpen && isDoorOpen) {
          // CLOSING: mosquito first, then parent door in reverse
          playMosqB(() => playParentDoorB(true, () => { }));
          return;
        }

        if (!isDoorOpen && parentDoorRoot) {
          // OPENING: parent door first, then mosquito
          playParentDoorB(false, () => playMosqB(null));
          return;
        }

        playMosqB(null);
        return;
      }

      {
        const frontWallSync = theModel.getObjectByName('front_wall');
        const frontDoorNamesSync = new Set();
        if (frontWallSync) frontWallSync.traverse(o => { if (o.name) frontDoorNamesSync.add(o.name); });
        if (relevantClips.some(c => c.tracks.some(t => frontDoorNamesSync.has(trackObjName(t.name))))) {
          const pathBKeySync = relevantClips.map(c => c.name).sort().join('|');
          const mainIsCurrentlyOpen = _meshClickOpenState.get(pathBKeySync) ?? false;
          window._mainDoorIsOpen = !mainIsCurrentlyOpen;
        }
      }

      // Strip logo tracks from clips so the mixer doesn't double-move them.
      const logoNamesB = new Set(['door_mosquito_logo', 'door_logo', 'door_mosquito_back_logo', 'back_door_logo', 'door1_F_logo', 'door2_F_logo', 'door1_F_back_logo', 'door2_F_back_logo', 'door_logo_L', 'door_logo_R', 'door_mosquito_logo_L', 'door_mosquito_logo_R']);

      const safeClips = relevantClips.map(clip => {
        const safeTracks = clip.tracks.filter(t => !logoNamesB.has(trackObjName(t.name)));
        return safeTracks.length === clip.tracks.length
          ? clip : new THREE.AnimationClip(clip.name, clip.duration, safeTracks);
      });

      const pathBKey = relevantClips.map(c => c.name).sort().join('|');
      const isOpen = _meshClickOpenState.get(pathBKey) ?? false;
      _meshClickOpenState.set(pathBKey, !isOpen);

      mixer = new THREE.AnimationMixer(theModel);
      safeClips.forEach(clip => {
        const action = mixer.clipAction(clip);
        action.setLoop(THREE.LoopOnce, 1);
        action.clampWhenFinished = true;
        if (isOpen) {
          action.reset();
          action.time = clip.duration;
          action.timeScale = -1;
        } else {
          action.reset();
          action.timeScale = 1;
        }
        action.play();
        mixer.update(0.001);
      });
    }

    _meshClickMixers.push(mixer);

    let lastTime = performance.now();
    const tick = () => {
      if (_meshClickGen !== clickGen) return; // superseded by a newer click
      const now = performance.now();
      const delta = (now - lastTime) / 1000;
      lastTime = now;
      _meshClickMixers.forEach(m => m.update(delta));

      requestDelayedRender();
      const stillRunning = _meshClickMixers.some(m => {
        let running = false;
        m._actions?.forEach(a => { if (a.isRunning()) running = true; });
        return running;
      });
      if (stillRunning) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  });
}

export function RegisterMorphsForObject(object) {
  if (!object.isMesh) return;
  if (object.morphTargetDictionary == null) return;

  for (const [key, value] of Object.entries(object.morphTargetDictionary)) {
    var morph = {
      name: key,
      object: object,
      key: value,
      value: value,
    };
    morphs.push(morph);
  }
}


// GUI - TEST WORK
function customGUI() {
  const gui = new dat.GUI();
  gui.close();

  const gui_PDF_functions = {
    GetPDF: function () {
      // createPDF();
    },
  };

  const folder_PDF = gui.addFolder("PDF Options");
  folder_PDF.add(gui_PDF_functions, "GetPDF");

  const gui_CreateImage_functions = {
    CreateImages: function () {
      CreateImageList();
    },
  };

  const folder_Screenshot = gui.addFolder("Image Options");
  folder_Screenshot.add(gui_CreateImage_functions, "CreateImages");

  var params_Bloom = {
    threshold: 1,
    strength: 1,
    radius: 1,
  };

  const folder_bloom = gui.addFolder("Bloom Options");
  folder_bloom
    .add(params_Bloom, "threshold", 0, 10)
    .onChange(function (newValue) {
      updateBloomSettings(newValue);
    });
  folder_bloom
    .add(params_Bloom, "strength", 0, 10)
    .onChange(function (newValue) {
      updateBloomSettings(null, newValue);
    });
  folder_bloom.add(params_Bloom, "radius", 0, 10).onChange(function (newValue) {
    updateBloomSettings(null, null, newValue);
  });
}

//#endregion

function initDayScene() {
  bloomPass.enabled = false;
  saoPass.enabled = false;
  outputPass.enabled = false;
  fxaaPass.enabled = false;
  updateEnvMap(ENVIRONMENT_MAP, ENVIRONMENT_MAP_INTENSITY);
  updateBloomSettings(null, 0);
  dirLight.intensity = 1.5;
  renderer.toneMapping = THREE.AgXToneMapping // AgXToneMapping; //ACESFilmicToneMapping
  renderer.toneMappingExposure = 1.5;
  scene.background = new THREE.Color(BACKGROUND_COLOR);
  requestDelayedRender();
}

//#region PDF
function calculateImageScale(
  originalWidth,
  originalHeight,
  targetWidth,
  targetHeight
) {
  return Math.min(targetWidth / originalWidth, targetHeight / originalHeight);
}

//#endregion

//#region Dimmensions

function removeObject3D(object3D) {
  if (!(object3D instanceof THREE.Object3D)) return false;

  if (object3D.geometry) object3D.geometry.dispose();

  if (object3D.material) {
    if (object3D.material instanceof Array) {
      object3D.material.forEach((material) => material.dispose());
    } else {
      object3D.material.dispose();
    }
  }
  object3D.removeFromParent();
  return true;
}

var dimmensionObjects = [];

function changeDimmensionRender(status, lookAtCamera = null, stage) {
  if (!status) {
    for (let index = 0; index < dimmensionObjects.length; index++) {
      const element = dimmensionObjects[index];
      removeObject3D(element);
    }

    dimmensionObjects = [];
    return;
  }

  const colorDemension = "#000000";
  const { FL_point, FR_point, RR_point } = pergola.getCornerPoints();
  const modelHeight = state.height;
  const deltaHeight = 0.01;

  let textSize = 0.2;

  if (state.width > 15 || state.length > 15) {
    textSize = 0.25;
  }

  if (state.width > 25 || state.length > 25) {
    textSize = 0.3;
  }

  if (state.width > 30 || state.length > 30) {
    textSize = 0.35;
  }

  var pos_width_0 = new THREE.Vector3(
    FL_point.x - 0.1,
    modelHeight - deltaHeight,
    FL_point.z + 0.1
  );
  var pos_width_1 = new THREE.Vector3(
    FR_point.x + 0.08,
    modelHeight - deltaHeight,
    FR_point.z + 0.1
  );

  var pos_length_0 = new THREE.Vector3(
    FR_point.x + 0.1,
    modelHeight - deltaHeight,
    FR_point.z + 0.08
  );
  var pos_length_1 = new THREE.Vector3(
    RR_point.x + 0.1,
    modelHeight - deltaHeight,
    RR_point.z - 0.1
  );

  var pos_width_center = generateMidpoints(pos_width_0, pos_width_1, 1);
  var pos_length_center = generateMidpoints(pos_length_0, pos_length_1, 1);

  var pos_width_textPosition = new THREE.Vector3(
    pos_width_center[0].x,
    pos_width_center[0].y + 0.2,
    pos_width_center[0].z + 0.1
  );
  var pos_length_textPosition = new THREE.Vector3(
    pos_length_center[0].x + 0.1,
    pos_length_center[0].y + 0.1,
    pos_length_center[0].z
  );

  AddDimmension(
    pos_width_center[0],
    pos_width_0,
    pos_width_1,
    (state.width.toString()) + "m",
    pos_width_textPosition,
    "x",
    0.01,
    colorDemension,
    lookAtCamera
  );
  createDimensionBorderLine(pos_width_0, 0.25, 0.01, "x", colorDemension);
  createDimensionBorderLine(pos_width_1, 0.25, 0.01, "x", colorDemension);
  createDimensionText(
    state.width.toString() + " m",
    pos_width_textPosition,
    colorDemension,
    lookAtCamera,
    textSize
  );

  AddDimmension(
    pos_length_center[0],
    pos_length_0,
    pos_length_1,
    (state.length.toString()) + " m",
    pos_length_textPosition,
    "z",
    0.01,
    colorDemension,
    lookAtCamera
  );
  createDimensionBorderLine(pos_length_0, 0.25, 0.01, "x", colorDemension);
  createDimensionBorderLine(pos_length_1, 0.25, 0.01, "x", colorDemension);
  createDimensionText(
    state.length.toString() + " m",
    pos_length_textPosition,
    colorDemension,
    lookAtCamera,
    textSize
  );

  if (stage !== 1) {
    var pos_height_0 = new THREE.Vector3(RR_point.x + 0.5, -1, RR_point.z);
    var pos_height_1 = new THREE.Vector3(
      RR_point.x + 0.2,
      modelHeight,
      RR_point.z
    );

    var pos_height_center = generateMidpoints(pos_height_0, pos_height_1, 1);
    var pos_height_textPosition = new THREE.Vector3(
      pos_height_center[0].x + 0.1,
      pos_height_center[0].y,
      pos_height_center[0].z
    );

    AddDimmension(
      pos_height_center[0],
      pos_height_0,
      pos_height_1,
      "8" + " m",
      pos_height_textPosition,
      "y",
      0.01,
      colorDemension,
      lookAtCamera
    );
    createDimensionBorderLine(pos_height_0, 0.25, 0.01, "y", colorDemension);
    createDimensionBorderLine(pos_height_1, 0.25, 0.01, "y", colorDemension);
    createDimensionText(
      state.height.toString() + " m",
      pos_height_textPosition,
      colorDemension,
      lookAtCamera,
      textSize
    );
  }
}

function AddDimmension(
  position,
  start,
  end,
  text,
  textPosition = null,
  side = "x",
  thickness = 0.01,
  color = colorDemension,
  lookAtCamera = null
) {
  const line = createDimensionLine(
    position,
    start,
    end,
    thickness,
    side,
    color
  );
  scene.add(line);
  dimmensionObjects.push(line);

  /*
  if(textPosition != null){
    createDimensionText(text, textPosition, colorDemension, lookAtCamera);
    return;
  }

  var line1_center = generateMidpoints(start, end, 1);
  createDimensionText(text, line1_center[0], colorDemension, lookAtCamera);
  dimmensionObjects.push(line);
  */
}

function getDistance(point1, point2) {
  return point1.distanceTo(point2);
}

function createDimensionLine(
  position,
  start,
  end,
  thickness = 0.01,
  side = "x",
  color = colorDemension
) {
  //const material = new THREE.LineBasicMaterial({ color: color });
  var length = getDistance(start, end);

  var x_value = side != "x" ? thickness : length;
  var y_value = side != "y" ? thickness : length;
  var z_value = side != "z" ? thickness : length;

  const material = new THREE.MeshBasicMaterial({ color: color });
  const geometry = new THREE.BoxGeometry(x_value, y_value, z_value);
  const lineMesh = new THREE.Mesh(geometry, material);
  lineMesh.position.set(position.x, position.y, position.z);

  return lineMesh;
}

function createDimensionBorderLine(
  position,
  length,
  thickness = 0.01,
  side = "x",
  color = colorDemension
) {
  var x_value = side != "y" ? thickness : length;
  var y_value = side != "x" ? thickness : length;
  var z_value = side != "z" ? thickness : length;

  switch (side) {
    case "x":
      x_value = thickness;
      y_value = length;
      z_value = thickness;
      break;
    case "y":
      x_value = length;
      y_value = thickness;
      z_value = thickness;
      break;
    case "z":
      x_value = thickness;
      y_value = length;
      z_value = thickness;
      break;

    default:
      break;
  }

  const material = new THREE.MeshBasicMaterial({ color: color });
  const geometry = new THREE.BoxGeometry(x_value, y_value, z_value);
  const lineBorderMesh = new THREE.Mesh(geometry, material);
  lineBorderMesh.position.set(position.x, position.y, position.z);

  scene.add(lineBorderMesh);
  dimmensionObjects.push(lineBorderMesh);
  return lineBorderMesh;
}

function loadThreeJSFonts() {
  const loader = new FontLoader();
  loader.load(
    "https://threejs.org/examples/fonts/helvetiker_regular.typeface.json",
    function (font) {
      threejs_font_helvetiker_regular = font;
    }
  );
}

function createDimensionText(
  text,
  position,
  color = colorDemension,
  lookAtCamera = null,
  textSize = 0.2
) {
  if (threejs_font_helvetiker_regular == null) {
    return;
  }

  const textGeometry = new TextGeometry(text, {
    font: threejs_font_helvetiker_regular,
    size: textSize, // Розмір тексту
    depth: 0.01, // Глибина тексту
  });
  const textMaterial = new THREE.MeshBasicMaterial({ color: color });
  const textMesh = new THREE.Mesh(textGeometry, textMaterial);
  textMesh.position.set(position.x, position.y, position.z);
  if (lookAtCamera != null) {
    textMesh.lookAt(lookAtCamera.position);
  }

  scene.add(textMesh);
  dimmensionObjects.push(textMesh);

  return textMesh;
}

//#endregion

//#region CAPTURE CAMERA IMAGE

var share_RenderImageSize = {
  x: 650,
  y: 400,
};

var share_RenderImages = [];

export async function CreateImageList() {
  if (canvas == null) {
    return;
  }

  const fov = 50;
  let width = Number(state.width);
  let length = Number(state.length);
  const sizeValue = width > length ? width : length;

  const deltaDist = ConvertMorphValue(state.height, 1.0, 3.5, 0.5, 2.0);
  const deltaY = ConvertMorphValue(state.height, 1.0, 3.5, 1.0, 2.5);

  const dist = sizeValue * 1.3 + deltaDist + 2.5;

  console.log(canvas);
  const cameraImageViews_Global = [
    {
      id: "view_1.png",
      alt: "view 1",
      cameraObject: new THREE.PerspectiveCamera(
        29,
        canvas.width / canvas.height,
        0.01,
        1000
      ),
      position: new THREE.Vector3(dist / 1.0, deltaY * 0.5, dist / 1.0),
      rotation: new THREE.Vector3(0, Math.PI / 4.5, 0),
      lookAt: new THREE.Vector3(0, deltaY * 0.3 - 0.5, 0),
    },
    {
      id: "view_top.png",
      alt: "view from top",
      cameraObject: new THREE.PerspectiveCamera(
        47,
        canvas.width / canvas.height,
        0.01,
        1000
      ),
      position: new THREE.Vector3(0, dist * 0.95, 0),
      rotation: new THREE.Vector3(-Math.PI / 2, 0, 0),
      rotate: true,
    },
  ];

  share_RenderImages = [];

  pergola.update();

  if (state.pdfMode) {
    const louverNameX = getLouverMeshNames(state.roofType, state.louvreType, 'x');
    const louverNameY = getLouverMeshNames(state.roofType, state.louvreType, 'y');
    const namesToHide = [louverNameX, louverNameY, `lighting_${louverNameX}`, `lighting_${louverNameY}`].filter(Boolean);

    const rootScene = pergola.theModel.parent || pergola.theModel;
    rootScene.traverse((obj) => {
      if (obj.name && namesToHide.includes(obj.name)) {
        obj.visible = false;
        obj.traverse(ch => { ch.visible = false; });
      }
    });
  }

  for (let index = 0; index < cameraImageViews_Global.length; index++) {
    const element = cameraImageViews_Global[index];

    element.cameraObject.visible = true;
    element.cameraObject.aspect = camera.aspect;
    element.cameraObject.updateProjectionMatrix();
    element.cameraObject.position.set(
      element.position.x,
      element.position.y,
      element.position.z
    );
    if (element.lookAt) {
      element.cameraObject.lookAt(element.lookAt);
    } else {
      element.cameraObject.rotation.set(
        element.rotation.x,
        element.rotation.y,
        element.rotation.z
      );
    }

    changeDimmensionRender(true, element, index, element.rotate);
    TakeImage(element, "ar_pop_share_image");
    await new Promise((resolve) => setTimeout(resolve, 1));
    changeDimmensionRender(false);
  }

  pdfImg.img = share_RenderImages[0].src;
  pdfImgTop.img = share_RenderImages[1].src;

  // $("#js-summary-image-preview-1").find("img").eq(1).remove();
}

function TakeImage(view, img_class) {
  var img_div = document.createElement("div");
  img_div.classList.add(img_class);
  var img = CreateImage(view);
  img_div.appendChild(img);
  //DownloadRenderImage(img.src, img.alt);
  //ar_pop_share_pics.appendChild(img_div);
}

function CreateImage(view) {
  var img = new Image();
  renderer.setSize(share_RenderImageSize.x, share_RenderImageSize.y, false);
  view.cameraObject.aspect = share_RenderImageSize.x / share_RenderImageSize.y;
  view.cameraObject.updateProjectionMatrix();
  renderer.render(scene, view.cameraObject);
  img.src = renderer.domElement.toDataURL();
  img.alt = view.alt;
  share_RenderImages.push(img);
  view.cameraObject.visible = false;
  updateRenderSize();
  return img;
}

//#endregion

function buildGlassDebugPanel(mat) {
  const existing = document.getElementById('glass-debug-panel');
  if (existing) {
    existing._glassMat = mat;
    existing.querySelectorAll('input[type=range], input[type=checkbox]').forEach(input => {
      input._rebind?.(mat);
    });
    return;
  }

  const panel = document.createElement('div');
  panel.id = 'glass-debug-panel';
  panel.style.cssText = [
    'position:fixed', 'top:10px', 'left:10px', 'z-index:99999',
    'background:#1a1a1a', 'color:#f0f0f0',
    'font:12px/1.5 monospace', 'box-shadow:0 4px 20px rgba(0,0,0,.6)',
    'min-width:260px', 'user-select:none',
  ].join(';');

  const sliders = [
    { key: 'metalness', min: 0, max: 1, step: 0.01 },
    { key: 'roughness', min: 0, max: 1, step: 0.01 },
    { key: 'opacity', min: 0, max: 1, step: 0.01 },
    { key: 'alphaTest', min: 0, max: 1, step: 0.01 },  // Alpha Clip threshold
    { key: 'ior', min: 1, max: 2.5, step: 0.01 },
    { key: 'transmission', min: 0, max: 1, step: 0.01 },
    { key: 'thickness', min: 0, max: 10, step: 0.1 },
    { key: 'attenuationDistance', min: 0, max: 10, step: 0.1 },  // Absorption distance
    { key: 'iridescence', min: 0, max: 1, step: 0.01 },
    { key: 'iridescenceIOR', min: 1, max: 2.5, step: 0.01 },
    { key: 'clearcoat', min: 0, max: 1, step: 0.01 },  // Clearcoat
    { key: 'clearcoatRoughness', min: 0, max: 1, step: 0.01 },
    { key: 'sheen', min: 0, max: 1, step: 0.01 },
    { key: 'sheenRoughness', min: 0, max: 1, step: 0.01 },
    { key: 'emissiveIntensity', min: 0, max: 3, step: 0.01 },
    { key: 'specularIntensity', min: 0, max: 1, step: 0.01 },
    { key: 'envMapIntensity', min: 0, max: 3, step: 0.01 },
  ];

  const header = document.createElement('div');
  header.style.cssText = 'padding:8px 12px;background:#2a2a2a;border-radius:8px 8px 0 0;display:flex;justify-content:space-between;align-items:center;cursor:pointer';
  header.innerHTML = '<span style="font-weight:bold;letter-spacing:.05em">glass_wave</span><span id="glass-debug-toggle" style="font-size:16px">▲</span>';

  const body = document.createElement('div');
  body.style.cssText = 'padding:10px 12px';

  sliders.forEach(({ key, min, max, step }) => {
    const val = mat[key] ?? 0;
    const row = document.createElement('div');
    row.style.cssText = 'display:grid;grid-template-columns:130px 1fr 40px;align-items:center;gap:6px;margin:3px 0';

    const label = document.createElement('span');
    label.textContent = key;
    label.style.color = '#aaa';

    const input = document.createElement('input');
    input.type = 'range';
    input.min = min; input.max = max; input.step = step;
    input.value = val;
    input.style.cssText = 'width:100%;accent-color:#4fc3f7';

    const display = document.createElement('span');
    display.textContent = val.toFixed(2);
    display.style.cssText = 'color:#4fc3f7;text-align:right';

    let currentMat = mat;
    input._rebind = (newMat) => {
      currentMat = newMat;
      input.value = newMat[key] ?? 0;
      display.textContent = (+input.value).toFixed(2);
    };
    input.addEventListener('input', () => {
      currentMat[key] = +input.value;
      currentMat.needsUpdate = true;
      display.textContent = (+input.value).toFixed(2);
    });

    row.append(label, input, display);
    body.appendChild(row);
  });

  // normalScale.x / normalScale.y (Vector2)
  [['normalScale X', 'x'], ['normalScale Y', 'y']].forEach(([labelText, axis]) => {
    const val = mat.normalScale?.[axis] ?? 1;
    const row = document.createElement('div');
    row.style.cssText = 'display:grid;grid-template-columns:130px 1fr 40px;align-items:center;gap:6px;margin:3px 0';
    const lbl = document.createElement('span'); lbl.textContent = labelText; lbl.style.color = '#aaa';
    const inp = document.createElement('input');
    inp.type = 'range'; inp.min = -3; inp.max = 3; inp.step = 0.01; inp.value = val;
    inp.style.cssText = 'width:100%;accent-color:#4fc3f7';
    const disp = document.createElement('span');
    disp.textContent = (+val).toFixed(2); disp.style.cssText = 'color:#4fc3f7;text-align:right';
    let cNsMat = mat;
    inp._rebind = (newMat) => { cNsMat = newMat; inp.value = newMat.normalScale?.[axis] ?? 1; disp.textContent = (+inp.value).toFixed(2); };
    inp.addEventListener('input', () => { if (cNsMat.normalScale) cNsMat.normalScale[axis] = +inp.value; cNsMat.needsUpdate = true; disp.textContent = (+inp.value).toFixed(2); });
    row.append(lbl, inp, disp);
    body.appendChild(row);
  });

  // Checkboxes
  const makeCheck = (labelText, getter, setter) => {
    const row = document.createElement('div');
    row.style.cssText = 'display:flex;align-items:center;gap:8px;margin:4px 0';
    const chk = document.createElement('input');
    chk.type = 'checkbox';
    chk.checked = getter(mat);
    chk.style.cssText = 'width:16px;height:16px;min-width:16px;cursor:pointer;accent-color:#4fc3f7;flex-shrink:0;appearance:auto;-webkit-appearance:auto';
    let cChkMat = mat;
    chk._rebind = (newMat) => { cChkMat = newMat; chk.checked = getter(newMat); };
    chk.addEventListener('change', () => { setter(cChkMat, chk.checked); cChkMat.needsUpdate = true; });
    const lbl = document.createElement('span'); lbl.textContent = labelText; lbl.style.color = '#aaa';
    row.append(chk, lbl);
    body.appendChild(row);
    return chk;
  };

  makeCheck('transparent', m => m.transparent, (m, v) => m.transparent = v);
  makeCheck('alphaToCoverage', m => !!m.alphaToCoverage, (m, v) => m.alphaToCoverage = v);
  makeCheck('wireframe', m => !!m.wireframe, (m, v) => m.wireframe = v);

  // Collapse toggle
  let collapsed = false;
  header.addEventListener('click', () => {
    collapsed = !collapsed;
    body.style.display = collapsed ? 'none' : 'block';
    document.getElementById('glass-debug-toggle').textContent = collapsed ? '▼' : '▲';
  });

  panel.append(header, body);
  document.body.appendChild(panel);
}

//#region Encode/Decode

String.prototype.SEncode = function () {
  if (this == undefined) {
    return "";
  }
  return btoa(unescape(encodeURIComponent(this)));
};

String.prototype.SDecode = function () {
  if (this == undefined) {
    return "";
  }
  return decodeURIComponent(escape(atob(this)));
};

//#endregion
